(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[47341],{

/***/ 47341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Form; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/lib/shared/lodash.ts
var lodash = __webpack_require__(90969);
// EXTERNAL MODULE: ./src/lib/shared/routerQueriesToString.ts
var routerQueriesToString = __webpack_require__(78418);
;// CONCATENATED MODULE: ./src/components/shared/form/formNew/utils/stepRouting.ts
function getFieldStepRouting(field) {
    const rawMetaRouting = field.meta?.stepRouting;
    if (!rawMetaRouting) {
        return null;
    }
    try {
        const parsed = JSON.parse(rawMetaRouting);
        if (typeof parsed?.isActive === "boolean" && Array.isArray(parsed?.rules)) {
            return parsed;
        }
    } catch  {
        return null;
    }
    return null;
}
function evaluateRule(rule, fieldValue) {
    const ruleValue = String(rule.value ?? "");
    const actual = String(fieldValue ?? "");
    switch(rule.operator){
        case "is":
            return actual === ruleValue;
        case "isNot":
            return actual !== ruleValue;
        case "contains":
            return actual.includes(ruleValue);
        case "doesNotContain":
            return !actual.includes(ruleValue);
        case "greaterThan":
            return Number(actual) > Number(ruleValue);
        case "lessThan":
            return Number(actual) < Number(ruleValue);
        default:
            return actual === ruleValue;
    }
}
/**
 * Checks if the current step has fields with active stepRouting rules
 * that match the current field values. If so, returns the target step index.
 * Returns null if no routing applies.
 */ function getRoutedStepIndex(steps, currentStep, fieldsData) {
    const currentFields = steps[currentStep]?.fields ?? [];
    for (const field of currentFields){
        const stepRouting = getFieldStepRouting(field);
        if (!stepRouting?.isActive || !stepRouting?.rules?.length) {
            continue;
        }
        const fieldValue = fieldsData[field.codeName]?.value;
        for (const rule of stepRouting.rules){
            if (evaluateRule(rule, fieldValue)) {
                const targetStepIndex = steps.findIndex((step)=>step.id === Number(rule.targetStep));
                if (targetStepIndex !== -1) {
                    return targetStepIndex;
                }
            }
        }
    }
    return null;
}
/**
 * Computes the set of step indices that should be skipped based on the
 * current answers and active stepRouting rules.
 *
 * For each step `i` whose field has an active routing rule that matches the
 * current value, the indices strictly between `i` and the target step index
 * are added to the skipped set. Backward routing (target <= i) is ignored.
 * The first matching rule per field wins.
 */ function getSkippedStepIndices(steps, fieldsData) {
    const skipped = new Set();
    steps.forEach((step, i)=>{
        for (const field of step.fields){
            const stepRouting = getFieldStepRouting(field);
            if (!stepRouting?.isActive || !stepRouting?.rules?.length) {
                continue;
            }
            const fieldValue = fieldsData[field.codeName]?.value;
            let matchedTarget = null;
            for (const rule of stepRouting.rules){
                if (evaluateRule(rule, fieldValue)) {
                    const targetStepIndex = steps.findIndex((s)=>s.id === Number(rule.targetStep));
                    if (targetStepIndex !== -1) {
                        matchedTarget = targetStepIndex;
                        break;
                    }
                }
            }
            if (matchedTarget !== null && matchedTarget > i) {
                for(let j = i + 1; j < matchedTarget; j++){
                    skipped.add(j);
                }
            }
        }
    });
    return skipped;
}
/**
 * Returns the nearest non-skipped index strictly less than `from`, or 0 if
 * none is reachable.
 */ function findPrevVisibleIndex(from, skipped) {
    let idx = from - 1;
    while(idx > 0 && skipped.has(idx)){
        idx -= 1;
    }
    return Math.max(idx, 0);
}
/**
 * Returns the nearest non-skipped index strictly greater than `from`, or the
 * last step index if none is reachable.
 */ function findNextVisibleIndex(from, skipped, totalSteps) {
    let idx = from + 1;
    while(idx < totalSteps - 1 && skipped.has(idx)){
        idx += 1;
    }
    return Math.min(idx, totalSteps - 1);
}

// EXTERNAL MODULE: ./src/api/index.ts + 19 modules
var api = __webpack_require__(21513);
// EXTERNAL MODULE: ./src/lib/shared/form.ts + 1 modules
var shared_form = __webpack_require__(198);
// EXTERNAL MODULE: ./src/lib/shared/cookies.ts
var cookies = __webpack_require__(76309);
// EXTERNAL MODULE: ./src/hooks/useFormContext.tsx
var useFormContext = __webpack_require__(21465);
// EXTERNAL MODULE: ./src/hooks/usePrev.tsx
var usePrev = __webpack_require__(21818);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./src/components/shared/form/formNew/utils/decodeFieldsFromText.ts
var decodeFieldsFromText = __webpack_require__(59067);
;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useSuccessStep.ts

const useSuccessStep = (successMessage, fieldsState, isSecondServiceForm)=>{
    if (isSecondServiceForm) {
        const formattedSuccessMessage = (0,decodeFieldsFromText/* decodeFieldsFromText */.l)(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        JSON.parse(localStorage.getItem("successMessage")), fieldsState);
        return formattedSuccessMessage;
    }
    const formattedSuccessMessage1 = (0,decodeFieldsFromText/* decodeFieldsFromText */.l)(successMessage, fieldsState);
    return formattedSuccessMessage1;
};

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/types.ts
var ActionTypes;
(function(ActionTypes) {
    ActionTypes["SHOW_EXIT_MODAL"] = "SHOW_EXIT_MODAL";
    ActionTypes["SET_STEP"] = "SET_STEP";
    ActionTypes["SET_FIELDS_STATE"] = "SET_FIELDS_STATE";
    ActionTypes["REPLACE_FIELDS_STATE"] = "REPLACE_FIELDS_STATE";
    ActionTypes["SET_LOADING_FORM"] = "SET_LOADING_FORM";
    ActionTypes["SET_FORM_SUBMITTED"] = "SET_FORM_SUBMITTED";
    ActionTypes["SET_FORM_ERROR_FIELD"] = "SET_FORM_ERROR_FIELD";
    ActionTypes["SET_FORM_ERROR"] = "SET_FORM_ERROR";
    ActionTypes["SET_NEXT_STEP"] = "SET_NEXT_STEP";
    ActionTypes["SET_OTP"] = "SET_OTP";
    ActionTypes["SET_FORM_WAITING_OTP"] = "SET_FORM_WAITING_OTP";
    ActionTypes["SET_STEP_STATUS"] = "SET_STEP_STATUS";
    ActionTypes["RESET_FORM_SUBMIT"] = "RESET_FORM_SUBMIT";
    ActionTypes["SHOW_REGULATIONS_PAGE"] = "SHOW_REGULATIONS_PAGE";
    ActionTypes["SHOW_CUSTOM_LISTING_MODAL"] = "SHOW_CUSTOM_LISTING_MODAL";
    ActionTypes["SET_FORM_MODAL"] = "SET_FORM_MODAL";
    ActionTypes["TOGGLE_SHOW_FORM_INSIDE_EXIT_MODAL"] = "TOGGLE_SHOW_FORM_INSIDE_EXIT_MODAL";
    ActionTypes["SET_OPERATION"] = "SET_OPERATION";
    ActionTypes["SET_GLOBAL_LOADING"] = "SET_GLOBAL_LOADING";
})(ActionTypes || (ActionTypes = {}));

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useFields.ts
const useFields = (form)=>{
    const temp = {};
    form.steps.forEach((step)=>{
        step.fields.forEach((field)=>{
            temp[field.codeName] = {
                value: field.defaultValue ?? "",
                valid: true,
                errorMessage: "",
                changed: false,
                fieldType: field.fieldType,
                meta: field.meta
            };
        });
    });
    return {
        fields: temp
    };
};

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useSteps.ts



const useSteps = (form, fieldsState, singleQuestion)=>{
    const initialSteps = (0,react.useMemo)(()=>{
        const stepsToUse = singleQuestion ? form.steps.slice(0, 1) : form.steps;
        return stepsToUse.map((step)=>({
                ...step,
                title: (0,decodeFieldsFromText/* decodeFieldsFromText */.l)(step.title || "", fieldsState),
                fields: step.fields.map((field)=>{
                    return {
                        ...field,
                        meta: Array.isArray(field.meta) ? (0,lodash/* mapValues */.Q8)((0,lodash/* keyBy */.VS)(field.meta, "key"), "value") : field.meta
                    };
                })
            }));
    }, [
        form.steps,
        fieldsState,
        singleQuestion
    ]);
    const { 0: steps , 1: setSteps  } = (0,react.useState)(initialSteps);
    return {
        steps,
        setSteps
    };
};

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useNext.ts

function useNext(value) {
    const valueRef = (0,react.useRef)(value);
    const resolvesRef = (0,react.useRef)([]);
    (0,react.useEffect)(()=>{
        if (valueRef.current !== value) {
            for (const resolve of resolvesRef.current){
                resolve(value);
            }
            resolvesRef.current = [];
            valueRef.current = value;
        }
    }, [
        value
    ]);
    return ()=>new Promise((resolve)=>{
            resolvesRef.current = [
                ...resolvesRef.current,
                resolve
            ];
        });
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/state/reducer.ts

const initState = {
    waitingOtp: false,
    submitted: false,
    loadingForm: false,
    currentStep: 0,
    fieldsState: {},
    formError: null,
    formErrors: 0,
    formErrorsResolved: false,
    stepStatus: "success",
    visitedSteps: {},
    otp: {
        isRequired: false,
        isResolved: false,
        countDown: 60
    },
    showExitModal: false,
    blockBack: false,
    showRegulations: false,
    showCustomListingModal: false,
    showFormModal: false,
    showFromInExitModal: false,
    operation: null,
    globalLoading: true
};
/**
 * Pure form reducer.
 *
 * NOTE: Side effects that previously lived inside `SET_FORM_SUBMITTED`
 * (clearing module-level `leadId` / `startSendingData`) are now handled
 * by the caller (see the dispatch wrapper in `useForm/index.tsx`).
 *
 * The reducer still performs two intentional browser side effects that
 * are kept for behavior parity:
 *  - `sessionStorage.removeItem` on form-submit
 *  - `window.history.pushState` on step transitions
 */ const formReducer = (state, action)=>{
    switch(action.type){
        case ActionTypes.SET_STEP:
            return {
                ...state,
                currentStep: action.payload,
                loadingForm: false
            };
        case ActionTypes.SHOW_EXIT_MODAL:
            return {
                ...state,
                showExitModal: !!action.payload
            };
        case ActionTypes.TOGGLE_SHOW_FORM_INSIDE_EXIT_MODAL:
            return {
                ...state,
                showFromInExitModal: action.payload ?? !state.showFromInExitModal
            };
        case ActionTypes.SET_FIELDS_STATE:
            return {
                ...state,
                fieldsState: {
                    ...state.fieldsState,
                    ...action.payload
                }
            };
        case ActionTypes.REPLACE_FIELDS_STATE:
            return {
                ...state,
                fieldsState: action.payload
            };
        case ActionTypes.SET_LOADING_FORM:
            return {
                ...state,
                loadingForm: action.payload
            };
        case ActionTypes.SET_FORM_SUBMITTED:
            {
                sessionStorage.removeItem(`form-${action.payload.formId}`);
                sessionStorage.removeItem(`lead-id-form-${action.payload.formId}`);
                const isResolved = action.payload.isOtpResolved ?? false;
                return {
                    ...state,
                    submitted: true,
                    waitingOtp: false,
                    formErrors: 0,
                    otp: {
                        ...state.otp,
                        isRequired: false,
                        isResolved
                    }
                };
            }
        case ActionTypes.SET_STEP_STATUS:
            return {
                ...state,
                stepStatus: action.payload ? "success" : "error"
            };
        case ActionTypes.SET_FORM_ERROR_FIELD:
            {
                window.history.pushState(null, "", `#step-${state.currentStep + 2}`);
                return {
                    ...state,
                    fieldsState: action.payload.fields,
                    formErrors: action.payload.formErrors,
                    formErrorsResolved: true,
                    blockBack: true
                };
            }
        case ActionTypes.RESET_FORM_SUBMIT:
            return {
                ...state,
                formErrors: 0,
                formErrorsResolved: false
            };
        case ActionTypes.SET_FORM_ERROR:
            return {
                ...state,
                formError: action.payload
            };
        case ActionTypes.SET_FORM_MODAL:
            return {
                ...state,
                showFormModal: action.payload
            };
        case ActionTypes.SET_NEXT_STEP:
            window.history.pushState(null, "", `#step-${state.currentStep + 2}`);
            return {
                ...state,
                currentStep: state.currentStep + 1,
                loadingForm: false,
                visitedSteps: {
                    ...state.visitedSteps,
                    [state.currentStep]: state.currentStep
                }
            };
        case ActionTypes.SET_OTP:
            return {
                ...state,
                otp: action.payload,
                formErrors: 0
            };
        case ActionTypes.SET_FORM_WAITING_OTP:
            return {
                ...state,
                waitingOtp: action.payload
            };
        case ActionTypes.SHOW_REGULATIONS_PAGE:
            return {
                ...state,
                showRegulations: action.payload.showRegulations
            };
        case ActionTypes.SHOW_CUSTOM_LISTING_MODAL:
            return {
                ...state,
                showCustomListingModal: action.payload.showCustomListingModal
            };
        case ActionTypes.SET_OPERATION:
            return {
                ...state,
                operation: {
                    ...state.operation,
                    ...action.payload
                },
                otp: {
                    ...state.otp,
                    isResolved: action.payload.isOtpResolved ?? state.otp.isResolved
                },
                formErrors: action.payload.formErrors ?? state.formErrors
            };
        case ActionTypes.SET_GLOBAL_LOADING:
            return {
                ...state,
                globalLoading: action.payload
            };
        default:
            return state;
    }
};

;// CONCATENATED MODULE: ./src/hooks/useForm/reducer.ts


;// CONCATENATED MODULE: ./src/components/shared/form/formNew/state/runtimeState.ts
/**
 * Per-form-instance runtime state.
 *
 * Replaces module-level `let` flags that previously lived at the top of
 * `useForm/index.tsx`. Each call to `useForm()` creates its own runtime
 * object (held in a `useRef`) so that multiple forms can coexist on the
 * same page without bleeding state into each other.
 *
 * The `leadId` value is kept as a module-level singleton because it is
 * intentionally shared across forms in the same session (e.g. main form
 * -> PII completion form -> second service form all reuse the same lead).
 */ const createFormRuntime = ()=>({
        isApiCallInProgress: false,
        startSendingData: false,
        submitStepClicked: false,
        clickedOnSubmit: false,
        queues: [],
        skippedValidationFields: []
    });
// --- lead id singleton (intentionally shared across instances) ---
let _leadId = null;
// --- final-submit lock (shared across form instances by formId) ---
const _finalSubmitInFlightByFormId = new Map();
const leadIdSingleton = {
    get () {
        return _leadId;
    },
    set (value) {
        _leadId = value;
    }
};
const finalSubmitLock = {
    tryAcquire (formId) {
        if (_finalSubmitInFlightByFormId.get(formId)) return false;
        _finalSubmitInFlightByFormId.set(formId, true);
        return true;
    },
    release (formId) {
        _finalSubmitInFlightByFormId.delete(formId);
    },
    isLocked (formId) {
        return !!_finalSubmitInFlightByFormId.get(formId);
    }
};

;// CONCATENATED MODULE: ./src/hooks/useForm/runtimeState.ts


;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useOtp.ts
/**
 * OTP-related handlers extracted from `useForm/index.tsx`.
 *
 * Owns the SMS/email OTP submit, resend, and edit-phone flows that all
 * route through `sendDataToServer` and dispatch operation/state updates
 * on the parent reducer.
 *
 * Public API (returned object) matches the previous in-file shape so the
 * parent hook can spread it into its return value untouched.
 */ 
const useOtp = ({ state , dispatch , sendDataToServer , setLoading  })=>{
    const { operation  } = state;
    const selectedBuyerIds = ()=>operation?.firstRoundBuyers?.filter((i)=>i.selected)?.map((buyer)=>buyer.buyerId);
    const handleOtpSubmit = async (formOtp)=>{
        setLoading(true);
        const { success , data  } = await sendDataToServer({
            submit: true,
            formOtp,
            buyerIds: selectedBuyerIds()
        });
        setLoading(false);
        if (!success) {
            return {
                success: false
            };
        }
        if (data?.operationId) {
            dispatch({
                type: ActionTypes.SET_OPERATION,
                payload: {
                    operationId: data.operationId,
                    key: "ROUND_ONE",
                    isOtpResolved: true
                }
            });
        }
        return {
            success: true
        };
    };
    const handleOtpResend = async ()=>{
        const { success  } = await sendDataToServer({
            submit: true,
            buyerIds: selectedBuyerIds()
        });
        return {
            success
        };
    };
    const handleOtpEditPhoneNumber = async ()=>{
        setLoading(true);
        const { success  } = await sendDataToServer({
            submit: true
        });
        setLoading(false);
        return {
            success
        };
    };
    return {
        handleOtpSubmit,
        handleOtpResend,
        handleOtpEditPhoneNumber
    };
};

// EXTERNAL MODULE: ./src/api/buyers.ts
var buyers = __webpack_require__(3481);
;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useBidding.ts
/**
 * Bidding handlers extracted from `useForm/index.tsx`.
 *
 * Owns the first-round and second-round bidding flows that call the
 * `fetchLeadBuyers` API after a lead has been submitted, plus the
 * `fetchFirstRoundBuyers` helper used by the one-to-one flow.
 *
 * The handlers preserve the original behavior verbatim — they are pure
 * wrappers around the same `sendDataToServer` / dispatch / loading
 * helpers that previously lived inline in the parent hook.
 */ 



const SKIP_ROUND_ONE_CATEGORIES = [
    "auto-warranty",
    "car-warranty"
];
const useBidding = ({ form , domain , dispatch , sendDataToServer , setLoading , setLoadingBuyers , handleRejectedLeads , categorySlug , initialFieldData  })=>{
    // Round-one bidding is skipped for warranty categories — those flows
    // go straight to round two after lead submission.
    const skipRoundOneBidding = (0,react.useMemo)(()=>!SKIP_ROUND_ONE_CATEGORIES.includes(categorySlug), [
        categorySlug
    ]);
    const fetchFirstRoundBuyers = (id)=>{
        setLoadingBuyers(true);
        void (0,buyers/* fetchLeadBuyers */.c)(id).then((res)=>{
            if (res.data?.buyers && res.data.buyers.length) {
                dispatch({
                    type: ActionTypes.SET_OPERATION,
                    payload: {
                        firstRoundBuyers: res.data.buyers.map((buyer)=>({
                                ...buyer,
                                selected: true
                            })),
                        secondRoundBuyers: [],
                        loadingBuyers: false,
                        hasDomainConsent: res.data.buyers.every((buyer)=>buyer.isNoble) ? false : true
                    }
                });
            } else {
                dispatch({
                    type: ActionTypes.SET_OPERATION,
                    payload: {
                        loadingBuyers: false
                    }
                });
            }
            dispatch({
                type: ActionTypes.SET_GLOBAL_LOADING,
                payload: false
            });
        });
    };
    const startFirstRoundBidding = ({ operationId , firstRoundBuyers , secondRoundBuyers , isOtpResolved  })=>{
        if (!operationId) {
            return;
        }
        if (skipRoundOneBidding) {
            sessionStorage.setItem(sharedUtils/* SKIPPED_OPERATION_ID_KEY */.UG, operationId);
            dispatch({
                type: ActionTypes.SET_FORM_SUBMITTED,
                payload: {
                    formId: form.id,
                    isOtpResolved
                }
            });
            return;
        }
        if (secondRoundBuyers && secondRoundBuyers.length) {
            dispatch({
                type: ActionTypes.SET_OPERATION,
                payload: {
                    key: "ROUND_TWO",
                    secondRoundBuyers,
                    formErrors: 0
                }
            });
            return;
        }
        setLoadingBuyers(true);
        if (firstRoundBuyers && firstRoundBuyers.length) {
            void (0,buyers/* fetchLeadBuyers */.c)(operationId).then((res)=>{
                //? SALE IS MADE ... GET THE WINNER BUYER TO SEND IT TO THANK YOU PAGE TO EXCLUDE IT FROM OFFER
                if (res.data?.status === "SUCCESS" && res.data.buyers.length > 0) {
                    dispatch({
                        type: ActionTypes.SET_OPERATION,
                        payload: {
                            winnerBuyer: res.data?.buyers?.map((buyer)=>({
                                    ...buyer,
                                    selected: true
                                }))
                        }
                    });
                }
                if (res.data?.status === "FAILED" && res.data?.buyers?.length > 0) {
                    dispatch({
                        type: ActionTypes.SET_OPERATION,
                        payload: {
                            key: "ROUND_TWO",
                            secondRoundBuyers: res.data.buyers.map((buyer)=>({
                                    ...buyer,
                                    selected: true
                                })),
                            formErrors: 0
                        }
                    });
                } else if (res.data?.status === "FAILED" && res.data?.buyers?.length === 0) {
                    if (// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    domain.fallbackSettings && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    domain.fallbackSettings?.domain && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    domain.fallbackSettings?.excludedBuyers && !initialFieldData && res.data.extraData && res.data.extraData.redirect) {
                        setLoading(true);
                        handleRejectedLeads();
                    } else {
                        dispatch({
                            type: ActionTypes.SET_FORM_SUBMITTED,
                            payload: {
                                formId: form.id,
                                isOtpResolved
                            }
                        });
                    }
                    //? SALE IS MADE ... NO BUYER TOOK THE LEAD
                    dispatch({
                        type: ActionTypes.SET_OPERATION,
                        payload: {
                            winnerBuyer: []
                        }
                    });
                } else {
                    dispatch({
                        type: ActionTypes.SET_FORM_SUBMITTED,
                        payload: {
                            formId: form.id,
                            isOtpResolved
                        }
                    });
                }
            }).finally(()=>{
                setLoadingBuyers(false);
            });
        } else {
            dispatch({
                type: ActionTypes.SET_FORM_SUBMITTED,
                payload: {
                    formId: form.id,
                    isOtpResolved
                }
            });
        }
    };
    const startSecondRoundBidding = async ({ selectedBuyers , consentLanguage , hasDomainConsent  })=>{
        setLoading(true);
        const { success , data  } = await sendDataToServer({
            submit: true,
            buyerIds: selectedBuyers.map((buyer)=>buyer.buyerId),
            consentLanguage,
            hasDomainConsent
        });
        if (!success) {
            setLoading(false);
            dispatch({
                type: ActionTypes.SET_FORM_ERROR,
                payload: "An Unexpected Error Occurred"
            });
        } else {
            if (data?.operationId) {
                void (0,buyers/* fetchLeadBuyers */.c)(data?.operationId).then((res)=>{
                    if (res.data?.status === "FAILED" && res.data?.buyers?.length > 0) {
                        dispatch({
                            type: ActionTypes.SET_OPERATION,
                            payload: {
                                key: "ROUND_TWO",
                                secondRoundBuyers: res.data.buyers.map((buyer)=>({
                                        ...buyer,
                                        selected: true
                                    })),
                                formErrors: 0
                            }
                        });
                    } else {
                        dispatch({
                            type: ActionTypes.SET_FORM_SUBMITTED,
                            payload: {
                                formId: form.id
                            }
                        });
                    }
                }).finally(()=>{
                    setLoadingBuyers(false);
                    setLoading(false);
                });
            } else {
                dispatch({
                    type: ActionTypes.SET_FORM_SUBMITTED,
                    payload: {
                        formId: form.id
                    }
                });
            }
        }
    };
    return {
        fetchFirstRoundBuyers,
        startFirstRoundBidding,
        startSecondRoundBidding
    };
};

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useValidation.ts
/**
 * Validation handlers extracted from `useForm/index.tsx`.
 *
 * Owns single-field validation, blur-triggered validation + side-effect
 * data sync, full-step validation (including the firstName/lastName
 * full-name special case), tracking which fields had their validation
 * skipped server-side, and applying server-side validation errors to
 * the form state.
 *
 * All handlers preserve the original behavior — they wrap the same
 * helpers (`fieldValidation`, `fullNameValidation`,
 * `canShowFieldAfterDependency`, etc.) the parent hook used inline.
 */ 



const useValidation = ({ form , domain , locale , selectedCountryCode , domainNameTranslation , state , steps , dispatch , runtimeRef , otp , isPiiCompletionForm , piiCompletionData , loadingForm , handleUpdateOffers , getStepField , nextState , saveSharedFields , sendDataToServer , setHasRegulations , setShowPiiCompletionOtherFields , domainEnableRejectedAnswer , rejectedAnswersRules , phoneNumber , referrer , visitDetails , userAgent  })=>{
    const { fieldsState , formErrors  } = state;
    const addFieldToSkippedValidation = (codeName)=>{
        const skipped = runtimeRef.current.skippedValidationFields;
        if (!skipped.includes(codeName)) {
            skipped.push(codeName);
        }
    };
    const serverSideValidation = ({ data , success  })=>{
        dispatch({
            type: ActionTypes.SET_LOADING_FORM,
            payload: false
        });
        if (success) {
            if (data?.otpRequired) {
                dispatch({
                    type: ActionTypes.SET_OTP,
                    payload: {
                        ...otp,
                        isRequired: true,
                        countDown: data.otpTime ?? 60
                    }
                });
                dispatch({
                    type: ActionTypes.SET_FORM_WAITING_OTP,
                    payload: true
                });
            } else {
                if (data?.operationId) {
                    dispatch({
                        type: ActionTypes.SET_OPERATION,
                        payload: {
                            operationId: data.operationId,
                            key: "ROUND_ONE"
                        }
                    });
                }
            }
        } else if (data?.results) {
            const newFieldsState = {
                ...fieldsState
            };
            data?.results?.map((result)=>{
                const field = getStepField(result.codeName);
                newFieldsState[result.codeName] = {
                    ...fieldsState[result.codeName],
                    valid: false,
                    errorMessage: (0,sharedUtils/* getErrorMessageTranslation */.Ul)(domain, result?.errorCode, locale, result.reason ?? field?.errorMessage)
                };
            });
            dispatch({
                type: ActionTypes.SET_FORM_ERROR_FIELD,
                payload: {
                    fields: newFieldsState,
                    formErrors: formErrors + 1
                }
            });
        } else {
            dispatch({
                type: ActionTypes.SET_FORM_ERROR,
                payload: form.errorMessage ?? domain?.translations?.[`${domainNameTranslation}_generalFormErrorHasOccurred`] ?? "An error has occurred, please try again"
            });
        }
    };
    const handleFieldValidation = async (field, checkRegulations = true, overrideFieldsState)=>{
        const _fieldsState = overrideFieldsState ?? fieldsState;
        const validCountryCode = form?.supportedCountries.length && form?.supportedCountries.find((item)=>item.value === selectedCountryCode) ? selectedCountryCode : "US";
        const rawValue = _fieldsState[field.codeName]?.value;
        const { valid , message , newValue , hasRegulations , validationSkipped , isRejectedAnswerResult =false ,  } = await (0,shared_form/* fieldValidation */.wY)(field, typeof rawValue === "string" ? rawValue.trim() : rawValue, locale, validCountryCode, handleUpdateOffers, domain, domainEnableRejectedAnswer, rejectedAnswersRules, {
            phoneNumber,
            referrer,
            visitDetails,
            userAgent
        });
        if (validationSkipped) {
            addFieldToSkippedValidation(field.codeName);
        }
        if (hasRegulations && checkRegulations) {
            setHasRegulations(true);
            return;
        }
        const newObj = {};
        newObj[field.codeName] = {
            ..._fieldsState[field.codeName],
            valid,
            errorMessage: !valid ? field.errorMessage ? field.errorMessage : message : "",
            value: newValue ?? _fieldsState[field.codeName].value,
            isRejectedAnswerResult
        };
        dispatch({
            type: ActionTypes.SET_FIELDS_STATE,
            payload: {
                ...newObj
            }
        });
        const { fieldsState: newFieldsState  } = await nextState();
        saveSharedFields(newFieldsState);
        return valid;
    };
    const handleFieldBlur = (field)=>{
        if (!fieldsState[field.codeName].changed) return;
        if (runtimeRef.current.submitStepClicked) return;
        void handleFieldValidation(field, false);
        if (runtimeRef.current.startSendingData && !loadingForm) {
            if (!runtimeRef.current.isApiCallInProgress) {
                void sendDataToServer({
                    submit: false,
                    skippedValidationFields: runtimeRef.current.skippedValidationFields
                });
            } else {
                runtimeRef.current.queues.push(()=>sendDataToServer({
                        submit: false,
                        skippedValidationFields: runtimeRef.current.skippedValidationFields
                    }).then(()=>undefined));
            }
        }
    };
    const handleStepValidation = async (overrideFieldsState)=>{
        const _fieldsState = overrideFieldsState ?? fieldsState;
        const { currentStep  } = state;
        let stepValid = true;
        let fields = [];
        if (formErrors) {
            fields = (0,lodash/* flattenDeep */.Ar)(steps.map((step)=>step.fields)).filter((field)=>!_fieldsState[field.codeName].valid);
        } else {
            fields = steps[currentStep].fields;
        }
        dispatch({
            type: ActionTypes.SET_LOADING_FORM,
            payload: true
        });
        for (const field of fields){
            const fieldValid = !(0,shared_form/* canShowFieldAfterDependency */.bw)(field, _fieldsState) ? true : await handleFieldValidation(field, true, _fieldsState);
            if (!fieldValid) {
                if (isPiiCompletionForm && stepValid && !piiCompletionData?.missingFields.includes(field.codeName)) {
                    setShowPiiCompletionOtherFields(true);
                    const { codeName  } = field;
                    setTimeout(()=>{
                        const element = document.getElementById(codeName);
                        if (element) {
                            element.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }
                    }, 100);
                }
                stepValid = false;
            }
        }
        if (stepValid && steps[currentStep].fields.every((f)=>[
                "firstName",
                "lastName"
            ].includes(f.codeName))) {
            const { valid: fullNameValid , message: fullNameMessage  } = await (0,shared_form/* fullNameValidation */.zJ)({
                ...(0,lodash/* pick */.ei)((0,lodash/* mapValues */.Q8)(_fieldsState, "value"), [
                    "firstName",
                    "lastName", 
                ]),
                domain,
                locale
            });
            const newObj = {};
            dispatch({
                type: ActionTypes.SET_LOADING_FORM,
                payload: false
            });
            const { fieldsState: newFieldsState  } = await nextState();
            newObj["firstName"] = {
                ...newFieldsState["firstName"],
                valid: fullNameValid,
                errorMessage: fullNameMessage
            };
            newObj["lastName"] = {
                ...newFieldsState["lastName"],
                valid: fullNameValid,
                errorMessage: fullNameMessage
            };
            dispatch({
                type: ActionTypes.SET_FIELDS_STATE,
                payload: {
                    ...newObj
                }
            });
            if (!fullNameValid) {
                stepValid = false;
            }
        }
        dispatch({
            type: ActionTypes.SET_LOADING_FORM,
            payload: false
        });
        dispatch({
            type: ActionTypes.SET_STEP_STATUS,
            payload: stepValid
        });
        return stepValid;
    };
    return {
        addFieldToSkippedValidation,
        serverSideValidation,
        handleFieldValidation,
        handleFieldBlur,
        handleStepValidation
    };
};

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/utils/goToThankYou.ts

/**
 * Build the absolute URL to redirect the user to the thank-you page.
 *
 * Pure modulo `window.location.origin`. Extracted from formNew.tsx so the URL
 * shape can be unit-tested without mounting the form.
 */ function buildThankYouUrl({ domain , category , locale , defaultLocale , operation , form , fieldsData , ignoreCategoryInThankYouPagePath , queryString , params , leadUuid  }) {
    const isSingleCategory = domain?.categories?.length === 1;
    const categorySlug = category ? `${category.slug}/` : "";
    const activeLang = locale === (defaultLocale ?? "en") ? "" : `${locale}/`;
    const winnerBuyer = operation?.winnerBuyer?.map((item)=>item?.buyerId)?.join(",") ?? "";
    const selectedCategory = domain.categories.find((categoryElement)=>categoryElement.slug === form?.categorySlug);
    const isSecondServiceSupported = !!(selectedCategory && selectedCategory?.secondServiceCategories?.length);
    const encodedData = (0,sharedUtils/* base64EncodeUnicode */.Fl)(JSON.stringify(params));
    const zc = fieldsData["zipCode"]?.value ?? "";
    const ebPart = winnerBuyer.length > 0 ? `&eb=${winnerBuyer}` : "";
    const leadPart = leadUuid ? `&lead_uuid=${leadUuid}` : "";
    if (isSingleCategory || isSecondServiceSupported || ignoreCategoryInThankYouPagePath) {
        return `${window.location.origin}/${activeLang}thank-you?data=${encodedData}&zc=${zc}${ebPart}${leadPart}&${queryString}`;
    }
    return `${window.location.origin}/${activeLang}${categorySlug}thank-you?data=${encodedData}&zc=${zc}${ebPart}${leadPart}&${queryString}`;
}

// EXTERNAL MODULE: ./src/components/shared/modal/index.tsx
var modal = __webpack_require__(18740);
// EXTERNAL MODULE: ./src/components/svg/closeIcon.tsx
var closeIcon = __webpack_require__(69655);
;// CONCATENATED MODULE: ./src/hooks/useForm/types.ts


// EXTERNAL MODULE: ./src/hooks/useLegalLinkHandler.ts
var useLegalLinkHandler = __webpack_require__(367);
;// CONCATENATED MODULE: ./src/components/shared/form/TCPA/index.tsx







const TCPAText = ({ text , buttonText ="submit" , finalBuyers , secondRound =false , dispatch , firstRoundBuyers , excludeDomain , websiteName  })=>{
    // check for changes in checked property and update the dom element
    (0,react.useEffect)(()=>{
        const inputs = document.querySelectorAll('[data-tf-element-role*="consent-opted-advertiser-input"]');
        const handleCheckboxChange = (input)=>{
            const name = input.getAttribute("data-tf-element-role");
            const element = document.querySelector(`[data-tf-element-role="${name}"]`);
            const checked = element?.getAttribute("checked");
            if (element) {
                element.setAttribute("checked", checked === "true" ? "false" : "true");
            }
            if (input.getAttribute("value") === "domain") {
                dispatch({
                    type: ActionTypes.SET_OPERATION,
                    payload: {
                        hasDomainConsent: input.getAttribute("checked") === "true"
                    }
                });
                return;
            }
            const checkboxes = document.querySelectorAll('[data-tf-element-role*="consent-opted-advertiser-input"]');
            const updatedBuyers = [];
            checkboxes.forEach((checkbox)=>{
                const checked = checkbox?.getAttribute("checked");
                const id = checkbox?.getAttribute("value");
                const currentBuyer = firstRoundBuyers.find((buyer)=>buyer.buyerId === id);
                if (currentBuyer) {
                    updatedBuyers.push({
                        ...currentBuyer,
                        selected: checked === "true"
                    });
                }
            });
            dispatch({
                type: ActionTypes.SET_OPERATION,
                payload: {
                    firstRoundBuyers: updatedBuyers
                }
            });
        };
        inputs.forEach((input)=>{
            input.addEventListener("change", ()=>handleCheckboxChange(input));
        });
        dispatch({
            type: ActionTypes.SET_OPERATION,
            payload: {
                hasDomainConsent: true,
                firstRoundBuyers: firstRoundBuyers.map((buyer)=>({
                        ...buyer,
                        selected: true
                    }))
            }
        });
        return ()=>{
            inputs.forEach((input)=>{
                input.removeEventListener("change", ()=>handleCheckboxChange(input));
            });
        };
    }, []);
    const contentRef = (0,react.useRef)(null);
    (0,useLegalLinkHandler/* useLegalLinkHandler */.z)(contentRef);
    // @todo remove unused logic
    if (secondRound) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: contentRef,
                dangerouslySetInnerHTML: {
                    __html: text?.replace(/\$\{websiteName\}/g, websiteName)?.replace(/\$\{btnText\}/g, `\<span data-tf-element-role="submit-text" \>${buttonText}\<\/span\>`).replace("the following: ${buyers}", "the selected providers above.")
                }
            })
        });
    }
    if (excludeDomain) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: contentRef,
                dangerouslySetInnerHTML: {
                    __html: text?.replace(/\$\{websiteName\}/g, websiteName)?.replace(/\$\{btnText\}/g, `\<span data-tf-element-role="submit-text" \>${buttonText}\<\/span\>`).replace("the following: ${buyers}", "${buyers}").replace(/\$\{buyers\}/g, `${firstRoundBuyers?.map((buyer)=>`<span data-tf-element-role="consent-advertiser-name">${buyer.displayName ?? buyer.buyerName}</span>`).join(" ")}`)
                }
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: contentRef,
            dangerouslySetInnerHTML: {
                __html: text?.replace(/\$\{websiteName\}/g, websiteName)?.replace(/\$\{btnText\}/g, `\<span data-tf-element-role="submit-text" \>${buttonText}\<\/span\>`).replace(/\$\{buyers\}/g, `${finalBuyers?.map((buyer)=>`<span  style="display: inline-block"><span style="display:flex;flex-wrap:nowrap;position: relative;top: 2px;align-items: center;height:10px" data-tf-element-role="consent-opted-advertiser-name-${buyer.buyerId}"><input value="${buyer.buyerId}" type="checkbox" style="margin:0px 3px;accent-color: gray;width:10px;height:10px"  checked="true" data-tf-element-role="consent-opted-advertiser-input-${buyer.buyerId}" />${buyer.displayName ?? buyer.buyerName}</span></span>`).join(" ")}`)
            }
        })
    });
};
function TCPA({ content , className , buttonText , operation , dispatch , position ="bottom"  }) {
    const { 0: showPartnerPopup , 1: setShowPartnerPopup  } = (0,react.useState)(false);
    const { 0: finalPopupContent , 1: setFinalPopupContent  } = (0,react.useState)(null);
    const extractTcpaMessagesFromContent = (arr)=>{
        const arrayOfStrings = arr.map((el)=>el.TCPAMessage);
        const tcpaArrayAfterRemoveDuplicate = new Set(arrayOfStrings);
        return [
            ...tcpaArrayAfterRemoveDuplicate
        ];
    };
    const { domain , domainNameTranslation  } = (0,useDomainContext/* useDomainContext */.w)();
    (0,react.useEffect)(()=>{
        const partnersEl = document.getElementById("tcpa-Modal");
        const popupContent = partnersEl?.getElementsByTagName("span")[0];
        if (popupContent) {
            setFinalPopupContent(popupContent?.innerHTML.trim());
        }
        partnersEl?.addEventListener("click", ()=>{
            const viewModal = true;
            setShowPartnerPopup(viewModal);
        });
        if (operation && operation.key === "FETCH_BUYERS" && operation.loadingBuyers) {
            window.cancelledOperations = window.cancelledOperations ?? [];
            window.cancelledOperations.push(operation.operationId);
        }
    }, []);
    const secondRound = (0,react.useMemo)(()=>{
        return operation?.key === "ROUND_TWO";
    }, [
        operation?.key
    ]);
    const excludeDomain = (0,react.useMemo)(()=>{
        return operation?.firstRoundBuyers?.length === 1 && operation?.firstRoundBuyers?.[0].isNoble;
    }, [
        operation?.firstRoundBuyers
    ]);
    const finalBuyers = (0,react.useMemo)(()=>{
        return [
            ...(secondRound ? operation?.secondRoundBuyers?.filter((buyer)=>buyer.selected) ?? [] : operation?.firstRoundBuyers) ?? [],
            ...!excludeDomain ? [
                {
                    displayName: domain.niceName ?? domain.name,
                    buyerName: domain.name,
                    buyerId: "domain",
                    logo: ""
                }, 
            ] : [], 
        ];
    }, [
        operation?.firstRoundBuyers,
        operation?.secondRoundBuyers
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "hidden",
                id: "leadid_tcpa_disclosure"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: "leadid_tcpa_disclosure",
                style: {
                    height: "fit-content",
                    fontSize: "9px",
                    color: "#242626"
                },
                "data-tf-element-role": "consent-language",
                className: `font-light leading-3 block mt-5 mb-5 ${className ?? ""}`,
                children: Array.isArray(content) && content.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: extractTcpaMessagesFromContent(content).map((tcpa, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TCPAText, {
                            dispatch: dispatch,
                            text: tcpa.replace("button above", position === "aboveSubmitButton" ? "button below" : "button above"),
                            finalBuyers: finalBuyers,
                            buttonText: buttonText,
                            secondRound: secondRound,
                            firstRoundBuyers: operation?.firstRoundBuyers ?? [],
                            excludeDomain: excludeDomain,
                            websiteName: domain.niceName || domain.name
                        }, index))
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TCPAText, {
                    dispatch: dispatch,
                    text: content.replace("button above", position === "aboveSubmitButton" ? "button below" : "button above"),
                    finalBuyers: finalBuyers,
                    buttonText: buttonText,
                    secondRound: secondRound,
                    firstRoundBuyers: operation?.firstRoundBuyers ?? [],
                    excludeDomain: excludeDomain,
                    websiteName: domain.niceName || domain.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal["default"], {
                onClose: ()=>{
                    setShowPartnerPopup(false);
                },
                active: showPartnerPopup && !!finalPopupContent,
                closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(closeIcon["default"], {}),
                backdropClosable: true,
                modalStyles: {
                    display: "flex",
                    flexDirection: "column",
                    maxHeight: "100%"
                },
                modalClassName: "h-[90vh] rounded",
                bodyStyles: {
                    overflowY: "scroll"
                },
                width: 900,
                header: domain?.translations?.[`${domainNameTranslation}_tcpaPartnersModalTitle`] ?? `Our Partners`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pb-5 lg:px-9 px-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: finalPopupContent
                        }
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/utils/tcpa.tsx



/**
 * Build the TCPA element used inside the new form.
 * Returns `undefined` when TCPA should not be rendered.
 */ function buildTcpaElement({ isSecondServiceForm , isSecondServiceSelected , showTCPAMessage , formErrors , operation , domain , finalForm , steps , currentStep , classes , submitButtonText , dispatch  }) {
    const showTCPA = (isSecondServiceForm && isSecondServiceSelected || !isSecondServiceForm && showTCPAMessage && !formErrors) && (!operation?.loadingBuyers || operation?.firstRoundBuyers?.length);
    const domainTcpa = domain?.textBlocks?.find((textEl)=>textEl.position === "custom-domain-tcpa")?.text;
    if (!showTCPA) {
        return undefined;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TCPA, {
        content: (domainTcpa ? domainTcpa : finalForm.tCPAMessages ? finalForm.tCPAMessages : steps[currentStep].TCPAMessage) ?? "",
        className: classes?.tcpaClassName ?? "",
        buttonText: submitButtonText,
        operation: operation ?? {},
        dispatch: dispatch,
        position: domain.config?.tcpaPosition ?? (domain.categories[0]?.config?.tcpaPosition === "aboveSubmitButton" ? "aboveSubmitButton" : "bottom")
    });
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/utils/expandableFields.ts
/** True when the field declares an `expandable` meta key. */ function expandableFields_isExpandable(field) {
    const metaKeys = field.meta ? Object.keys(field.meta) : [];
    return Array.isArray(metaKeys) && metaKeys.length ? metaKeys[0] === "expandable" ? true : false : false;
}
/**
 * Returns the array of expandable Field-shaped objects for the given parent
 * field, looked up from the live `fieldsData` map.
 */ function expandableFields_getExpandableFields(field, fieldsData) {
    const filteredExpandableFields = Object.keys(JSON.parse(field.meta?.expandable ?? "[]")).filter((f)=>f !== field.codeName);
    const allFields = Object.keys(fieldsData);
    const arrayOfExpandableFields = [];
    allFields.forEach((codeName)=>{
        if (filteredExpandableFields.includes(codeName)) {
            arrayOfExpandableFields.push(fieldsData[codeName]);
        }
    });
    return arrayOfExpandableFields;
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/utils/index.ts





;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useNavigation.ts
/**
 * Navigation handlers extracted from `useForm/index.tsx`.
 *
 * Owns the small handlers that move the form forward/back, manage the
 * URL hash, focus the first input on the first step, and scroll the
 * page to the top of the form. Behavior is preserved verbatim.
 */ 

const useNavigation = ({ form , state , dispatch , setWindowStep , skippedStepIndices , instanceId , isGeneralModalForm , synchronizedForms  })=>{
    const { currentStep , otp  } = state;
    const handlePrevStep = ()=>{
        const prevVisible = findPrevVisibleIndex(currentStep, skippedStepIndices);
        dispatch({
            type: ActionTypes.SET_STEP,
            payload: prevVisible
        });
        if (synchronizedForms) {
            // Notify peer forms about the step change so they can sync.
            window.dispatchEvent(new CustomEvent("formStepChanged", {
                detail: {
                    formId: String(form.id),
                    instanceId,
                    step: prevVisible
                }
            }));
        }
        // Only manipulate browser history for non-modal forms.
        if (!isGeneralModalForm) {
            window.history.back();
        }
    };
    const handleWindowBack = ()=>{
        if (!otp.isResolved && window.location.hash.startsWith("#step-")) {
            const step = parseInt(window.location.hash.replace("#step-", ""), 10);
            const targetIndex = step - 1;
            if (skippedStepIndices.has(targetIndex)) {
                const visibleIndex = findPrevVisibleIndex(targetIndex, skippedStepIndices);
                window.history.replaceState("", document.title, `#step-${visibleIndex + 1}`);
                setWindowStep(visibleIndex + 1);
            } else {
                setWindowStep(step);
            }
        } else {
            window.history.pushState("", document.title, `#step-1`);
            dispatch({
                type: ActionTypes.SHOW_EXIT_MODAL,
                payload: 1
            });
        }
    };
    const handleFirstStepFieldFocus = ()=>{
        const selector = "input[type=text], input[type=tel], input[type=number], input[type=date],input[type=email], textarea";
        if (document.getElementById(`form_${form.id}`)?.querySelectorAll(selector).length) {
            setTimeout(()=>{
                const element = document.getElementById(`form_${form.id}`)?.querySelectorAll(selector);
                if (element && element.length) {
                    element[0].focus();
                }
            }, 300);
        }
    };
    const handleScrollFormTop = ()=>{
        try {
            window.scroll({
                behavior: "smooth",
                top: 0
            });
        } catch (err) {
            if (err instanceof TypeError) {
                window.scroll(0, 0);
            } else {
                throw err;
            }
        }
    };
    return {
        handlePrevStep,
        handleWindowBack,
        handleFirstStepFieldFocus,
        handleScrollFormTop
    };
};

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useFormModals.ts
/**
 * Modal helpers extracted from `useForm/index.tsx`.
 *
 * Owns the small UI toggles for the form's exit modal, custom listing
 * modal, full-form modal (with backdrop side effects), and the
 * `forceShowListingModal` rule evaluator that maps a field's
 * `meta.forceShowOffers` config to a modal trigger.
 */ 
const useFormModals = ({ dispatch , setListingSlug  })=>{
    const toggleShowFormInExitModal = (payload)=>{
        dispatch({
            type: ActionTypes.TOGGLE_SHOW_FORM_INSIDE_EXIT_MODAL,
            payload: payload
        });
    };
    const setShowCustomListingModal = (show)=>{
        dispatch({
            type: ActionTypes.SHOW_CUSTOM_LISTING_MODAL,
            payload: {
                showCustomListingModal: show
            }
        });
    };
    const toggleFormModal = (payload)=>{
        if (payload) {
            const backdrop = document.getElementById("backdrop");
            if (!backdrop) {
                const backdrop1 = document.createElement("div");
                backdrop1.id = "backdrop";
                backdrop1.classList.add("backdrop");
                document.body.appendChild(backdrop1);
                document.getElementsByTagName("html")[0].classList.add("overflow-hidden");
                document.body.classList.add("overflow-hidden");
            }
        } else {
            const backdrop2 = document.getElementById("backdrop");
            document.getElementsByTagName("html")[0].classList.remove("overflow-hidden");
            document.body.classList.remove("overflow-hidden");
            if (backdrop2) {
                backdrop2.remove();
            }
            dispatch({
                type: ActionTypes.SET_STEP,
                payload: 0
            });
        }
        dispatch({
            type: ActionTypes.SET_FORM_MODAL,
            payload
        });
    };
    const forceShowListingModal = ({ meta , selectedValue , currentFieldCodeName  })=>{
        if (meta && meta?.forceShowOffers) {
            const parsedMeta = JSON.parse(meta?.forceShowOffers);
            if (parsedMeta.value === selectedValue && parsedMeta.codeName === currentFieldCodeName) {
                dispatch({
                    type: ActionTypes.SHOW_CUSTOM_LISTING_MODAL,
                    payload: {
                        showCustomListingModal: true
                    }
                });
                setListingSlug(parsedMeta.listSlug);
                return true;
            }
        }
        return false;
    };
    return {
        toggleShowFormInExitModal,
        setShowCustomListingModal,
        toggleFormModal,
        forceShowListingModal
    };
};

// EXTERNAL MODULE: ./src/lib/shared/config.ts
var config = __webpack_require__(98218);
;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useSharedFields.ts
/**
 * Shared-fields persistence helpers extracted from `useForm/index.tsx`.
 *
 * The "shared fields" feature persists a small subset of field values
 * (configured via `SHARED_FIELDS_CODENAME`) to `localStorage` so they
 * can be pre-filled when the user later sees a second-service form on
 * another domain in the same session.
 *
 * `saveSharedFields` writes the snapshot, `getSharedFields` reads it
 * asynchronously, and `fillFormWithSharedFields` dispatches the
 * snapshot back into the reducer.
 */ 

const useSharedFields = ({ dispatch  })=>{
    const saveSharedFields = (newFieldsState)=>{
        const SHARED_FIELDS = {};
        Object.keys(newFieldsState).forEach((fieldElement)=>{
            if (config/* SHARED_FIELDS_CODENAME.includes */.gA.includes(fieldElement)) {
                SHARED_FIELDS[fieldElement] = newFieldsState[fieldElement].value;
            }
        });
        localStorage.setItem("sharedFields", JSON.stringify(SHARED_FIELDS));
    };
    const fillFormWithSharedFields = (sharedFields)=>{
        const newObj = {};
        Object.keys(sharedFields).forEach((fieldElement)=>{
            if (sharedFields[fieldElement]) {
                newObj[fieldElement] = {
                    valid: true,
                    errorMessage: "",
                    value: sharedFields[fieldElement],
                    changed: true
                };
            }
        });
        dispatch({
            type: ActionTypes.SET_FIELDS_STATE,
            payload: {
                ...newObj
            }
        });
    };
    const getSharedFields = async ()=>{
        try {
            const sharedFields = await new Promise((resolve, reject)=>{
                const data = localStorage.getItem("sharedFields");
                if (data) {
                    try {
                        const parsedData = JSON.parse(data);
                        resolve(parsedData);
                    } catch (error) {
                        reject(error);
                    }
                } else {
                    resolve(undefined);
                }
            });
            return sharedFields;
        } catch (error) {
            return undefined;
        }
    };
    return {
        saveSharedFields,
        fillFormWithSharedFields,
        getSharedFields
    };
};

// EXTERNAL MODULE: ./src/lib/shared/helpers.ts
var helpers = __webpack_require__(11169);
// EXTERNAL MODULE: ./src/services/buyerPhoneNumberService.ts
var buyerPhoneNumberService = __webpack_require__(42076);
;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useApiCall.ts
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /**
 * Buyer phone number API call flow extracted from `useForm/index.tsx`.
 *
 * `applyApiCallFlow` runs the "API call" field flow that resolves a
 * buyer phone number for redirect-style category pages.
 */ 


const useApiCall = ({ fieldsState , dispatch , setApiCallLoading , setBuyerPhoneNumber , category  })=>{
    const applyApiCallFlow = async (options)=>{
        // Show loading state
        setApiCallLoading(true);
        dispatch({
            type: ActionTypes.SET_LOADING_FORM,
            payload: true
        });
        let result = "";
        const data = {
            zipCode: fieldsState["zipCode"].value,
            categoryId: category?.id,
            onSuccess: (phoneNumber)=>{
                result = phoneNumber;
            },
            onError: ()=>{
                result = "";
            }
        };
        await buyerPhoneNumberService/* BuyerPhoneNumberService.handleApiCall */.o.handleApiCall(options?.apiCallField, data);
        // Stop loading after API call
        await (0,helpers/* delay */.g)(category?.config?.loadingThreshold || 5000);
        setBuyerPhoneNumber(result);
        dispatch({
            type: ActionTypes.SET_LOADING_FORM,
            payload: false
        });
        return result;
    };
    return {
        applyApiCallFlow
    };
};

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useFieldDataDependency.ts
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-unsafe-argument */ /* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-unsafe-return */ /* eslint-disable @typescript-eslint/no-unsafe-call */ /**
 * Resolves cascading field data dependencies (lookups & variations).
 *
 * - `getFieldsDataDependency` filters fields whose `dataDependency`
 *   chain has been affected by a change in `changedFields`.
 * - `fetchFieldsDataDependency` resolves those dependent option lists
 *   via `getLookupsAndVariations` and writes them back into `steps`.
 */ 


const useFieldDataDependency = ({ steps , setSteps , prevFieldsState , fieldsState , nextState  })=>{
    const getFieldsDataDependency = ({ checkChangedFields , changedFields  } = {
        checkChangedFields: true,
        changedFields: {}
    })=>{
        const allFields = (0,lodash/* flatten */.xH)(steps.map((step)=>step.fields));
        const changedFieldsState = (0,sharedUtils/* differenceBetweenTwoObjects */.tu)(prevFieldsState, {
            ...fieldsState,
            ...changedFields
        });
        const fieldsWithDataDependencyAndDependentOn = allFields.filter((f)=>f.dataDependency && f.dataDependency.dependency && f.dataDependency?.dependency?.some((dependencyItem)=>checkChangedFields ? !!changedFieldsState[dependencyItem.fieldCodeName] : true));
        return {
            fieldsWithDataDependencyAndDependentOn
        };
    };
    const fetchFieldsDataDependency = async (fieldsWithDataDependencyAndDependentOn)=>{
        const { fieldsState: newFieldsState  } = await nextState();
        for await (const field of fieldsWithDataDependencyAndDependentOn){
            const dependentOnFields = [];
            const tempSteps = [
                ...steps
            ];
            let fieldIndex = 0;
            //Get step index for the field
            const stepIndex = steps.findIndex((step)=>step.fields.some((f, index)=>{
                    if (f.codeName === field.codeName) {
                        fieldIndex = index;
                        return true;
                    }
                    return false;
                }));
            // Fetch fields data if its depend on another field
            if (field.dataDependency?.dependency?.every((dependencyItem)=>{
                const allFields = (0,lodash/* flatten */.xH)(steps.map((step)=>step.fields));
                const dependentOnField = allFields.find((f)=>f.codeName === dependencyItem.fieldCodeName);
                const dependentUponFieldData = newFieldsState[dependentOnField?.codeName];
                dependentOnFields.push({
                    dependentOnType: dependencyItem.dependentOn,
                    id: dependentOnField?.defaultValues?.options.find((options)=>options.value === dependentUponFieldData.value)?.id
                });
                return dependentUponFieldData.value && dependentUponFieldData.valid;
            })) {
                const { ordering , type , source  } = field.dataDependency;
                const variationsIds = dependentOnFields.filter((i)=>i.dependentOnType === "variations");
                // should fire loading for field and clear all option before getting the response
                const updatedSteps = [
                    ...steps
                ];
                updatedSteps[stepIndex].fields[fieldIndex] = {
                    ...updatedSteps[stepIndex].fields[fieldIndex],
                    fetchingFieldData: true
                };
                updatedSteps[stepIndex].fields[fieldIndex].defaultValues = {
                    options: []
                };
                setSteps(updatedSteps);
                const { data , error  } = await (0,api/* getLookupsAndVariations */.Ek)({
                    source,
                    queries: {
                        orderBy: ordering?.field,
                        orderByDirection: ordering?.direction,
                        type,
                        lookupsId: dependentOnFields.find((i)=>i.dependentOnType === "lookups")?.id,
                        variationsIds: variationsIds.length ? variationsIds.map((i)=>i.id).join(",") : undefined
                    }
                });
                if (data && !error) {
                    // reset fetchingFieldData to false to hide loading inside select
                    tempSteps[stepIndex].fields[fieldIndex] = {
                        ...tempSteps[stepIndex].fields[fieldIndex],
                        fetchingFieldData: false
                    };
                    tempSteps[stepIndex].fields[fieldIndex].defaultValues = {
                        options: data
                    };
                    setSteps(tempSteps);
                }
            } else {
                // reset fetchingFieldData to false to hide loading inside select
                tempSteps[stepIndex].fields[fieldIndex] = {
                    ...tempSteps[stepIndex].fields[fieldIndex],
                    fetchingFieldData: false
                };
                tempSteps[stepIndex].fields[fieldIndex].defaultValues = {
                    options: []
                };
                setSteps(tempSteps);
            }
        } // end for
    };
    return {
        getFieldsDataDependency,
        fetchFieldsDataDependency
    };
};

// EXTERNAL MODULE: ./src/services/actionsTracker.ts + 1 modules
var actionsTracker = __webpack_require__(55584);
;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useSingleQuestion.ts
/**
 * Single-question form business case.
 *
 * Some pages embed `useForm` in a "single question" mode where the form
 * acts as a teaser: only the first step is shown, and submitting the
 * answer should redirect the user to another URL (built from the
 * domain's `routeConfig` placeholders) instead of going through the
 * normal multi-step / lead-submission flow.
 *
 * Owns:
 *   - The `isSingleQuestion` flag (just an alias of the prop, for
 *     readability at call sites).
 *   - The redirect itself, including:
 *       * setting `loadingForm` + the `isFormSubmitted` ref,
 *       * resolving `[keyword]` / `[generic-route]` placeholders from
 *         `routeConfig`,
 *       * forwarding the current query string (minus `slug`),
 *       * tracking a `sourceLink` click via `stackAction` when present,
 *       * persisting `skip-to-step` to sessionStorage.
 *
 * Note: the `singleQuestion` flag is also consumed by `useSteps` (to
 * slice to the first step) and by field-rendering logic — those are
 * presentation concerns and stay where they are.
 */ 






const useSingleQuestion = ({ singleQuestion , urlToRedirectFromSingleQuestion , dispatch , isFormSubmitted  })=>{
    const { query  } = (0,next_router.useRouter)();
    const { routeConfig  } = (0,useDomainContext/* useDomainContext */.w)();
    const redirectForSingleQuestion = (0,react.useCallback)((options)=>{
        dispatch({
            type: ActionTypes.SET_LOADING_FORM,
            payload: true
        });
        isFormSubmitted.current = true;
        const genericRoute = routeConfig?.replacedPortions?.find((portion)=>portion.key === "[generic-route]")?.value;
        const keyword = routeConfig?.replacedPortions?.find((portion)=>portion.key === "[keyword]")?.value;
        const href = (0,sharedUtils/* replacePlaceholders */.wT)(urlToRedirectFromSingleQuestion?.trim() || "/", {
            keyword,
            genericRoute,
            queryString: (0,routerQueriesToString/* gettingQueriesAsString */.r)(query, "inline", [
                "slug", 
            ])
        });
        const sourceLink = new URLSearchParams(href.split("?")[1]).get("sourceLink") || "";
        if (sourceLink) {
            (0,actionsTracker/* stackAction */.nm)({
                action: "click",
                category: "link",
                label: "sourceLink",
                value: sourceLink,
                createdAt: new Date().toISOString()
            });
        }
        if (options?.skipToStep) {
            sessionStorage.setItem("skip-to-step", options.skipToStep);
        }
        window.location.href = href;
    }, [
        dispatch,
        isFormSubmitted,
        query,
        routeConfig,
        urlToRedirectFromSingleQuestion, 
    ]);
    return {
        isSingleQuestion: !!singleQuestion,
        redirectForSingleQuestion
    };
};

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/utils/sendDataToServer.helpers.ts
/**
 * Pure helpers extracted from `useForm/index.tsx`'s `sendDataToServer`.
 *
 * These have no React or runtime-ref dependencies. Keeping them out of
 * the hook file makes the orchestrator readable and gives the
 * data-shaping logic clear inputs/outputs.
 */ 

const LEAD_CAPTURE_ALLOWED_FIELDS = [
    "checkbox",
    "radio",
    "select",
    "multiSelect", 
];
const CONTACT_US_MAIN_FIELDS = [
    "email",
    "firstName",
    "lastName",
    "phoneNumber", 
];
const parseSelectedOptionIndex = (optionSelectedIndex)=>{
    if (!optionSelectedIndex) return undefined;
    const indexPart = optionSelectedIndex.split("-")[1];
    const parsed = Number.parseInt(indexPart, 10);
    return Number.isNaN(parsed) ? undefined : parsed;
};
const collectFieldsWithValues = (newFieldsState, form, opts)=>{
    const selectedOptions = {};
    if (opts.isSecondServiceForm) {
        const fields = form.steps[0].fields.filter((f)=>newFieldsState[f.codeName]?.value?.trim()).map((f)=>{
            const fieldState = newFieldsState[f.codeName];
            const selectedIndex = parseSelectedOptionIndex(fieldState?.optionSelectedIndex);
            if (selectedIndex !== undefined) {
                selectedOptions[f.codeName] = selectedIndex;
            }
            return {
                codeName: f.codeName,
                value: fieldState?.value
            };
        });
        return {
            fields,
            selectedOptions
        };
    }
    const fields1 = Object.keys(newFieldsState).filter((codeName)=>{
        const val = newFieldsState[codeName]?.value;
        return typeof val === "string" ? val.trim() : val;
    }).map((codeName)=>{
        const field = newFieldsState[codeName];
        const useLabels = LEAD_CAPTURE_ALLOWED_FIELDS.includes(field.fieldType ?? "") && opts.leadCaptureForm;
        // Coerce to string before splitting — field.value may be a number/boolean
        // for non-text inputs (e.g. radio, slider).
        const selected = typeof field.value === "string" ? field.value.split(",") : [
            String(field.value)
        ];
        const selectedIndex = parseSelectedOptionIndex(field.optionSelectedIndex);
        if (selectedIndex !== undefined) {
            selectedOptions[codeName] = selectedIndex;
        }
        return {
            codeName,
            value: useLabels ? field.defaultValues?.options.filter((el)=>selected.includes(el.value)).map((el)=>el.label).join(",") : field.value
        };
    });
    return {
        fields: fields1,
        selectedOptions
    };
};
/**
 * Fills skipped questions with their default answers from field meta.
 * For any field not in filledFields that has a skippableDefaultAnswer in meta,
 * adds that field with the default value to the filledFields array.
 */ const fillDefaultAnswersForSkippedQuestions = (filledFields, fields, selectedOptions = {})=>{
    const filledCodeNames = new Set(filledFields.map((f)=>f.codeName));
    const getSkippableDefaultValue = (field)=>{
        const meta = field.meta;
        let skippableDefaultAnswer;
        if (Array.isArray(meta)) {
            skippableDefaultAnswer = meta.find((item)=>typeof item === "object" && item !== null && "key" in item && item.key === "skippableDefaultAnswer" && "value" in item)?.value;
        } else if (meta && typeof meta === "object") {
            skippableDefaultAnswer = meta.skippableDefaultAnswer;
        }
        if (skippableDefaultAnswer && typeof skippableDefaultAnswer === "object" && "value" in skippableDefaultAnswer && typeof skippableDefaultAnswer.value === "string") {
            return skippableDefaultAnswer.value;
        }
        if (typeof skippableDefaultAnswer === "string") {
            try {
                const parsed = JSON.parse(skippableDefaultAnswer);
                if (typeof parsed?.value === "string") {
                    return parsed.value;
                }
            } catch  {
                return skippableDefaultAnswer;
            }
        }
        return undefined;
    };
    // Add missing fields that define a skippable default answer and keep only
    // entries where a valid default value could be extracted from meta.
    const defaultAnswersToAdd = fields.filter((field)=>!filledCodeNames.has(field.codeName)).map((field)=>{
        const value = getSkippableDefaultValue(field);
        return value ? {
            codeName: field.codeName,
            value
        } : null;
    }).filter((field)=>field !== null);
    return {
        fields: [
            ...filledFields,
            ...defaultAnswersToAdd
        ],
        autoFilledFieldCodeNames: defaultAnswersToAdd.map((field)=>field.codeName),
        selectedOptions
    };
};
/**
 * Builds the body for `submitContactUsForm` (lead-capture / "Partner With Us" flow).
 */ const buildContactUsPayload = (fields, opts)=>{
    const find = (codeName)=>fields.find((el)=>el.codeName === codeName)?.value;
    return {
        email: find("email"),
        firstName: find("firstName"),
        googleReCaptcha: opts.googleReCaptcha,
        lastName: find("lastName"),
        phone: find("phoneNumber"),
        type: "partnerWithUs",
        customFields: [
            {
                key: "category",
                value: opts.categoryName
            },
            ...fields.filter((el)=>!CONTACT_US_MAIN_FIELDS.includes(el.codeName)).map((el)=>({
                    key: el.codeName,
                    value: el.value
                })), 
        ]
    };
};
/** Builds the redirect URL used when `goToListPage` is set on submit. */ const buildOffersListRedirectUrl = (fields, opts)=>{
    const filters = fields.reduce((acc, item)=>{
        if (item.codeName === "topClinicalTrialsAgeField") {
            acc["age"] = item.value === "topClinicalTrialsAgeField_18+" ? "18-100" : item.value.split("_")[1];
            return acc;
        }
        if (item.codeName === "topClinicalTrialsGenderField") {
            acc["gender"] = item.value.split("_")[1];
            return acc;
        }
        acc[item.codeName] = item.value;
        return acc;
    }, {});
    const zip = (fields.find((el)=>el.codeName === "zipCode")?.value) ?? "";
    const formattedZip = zip.length === 4 ? `0${zip}` : zip;
    return `${window.location.origin}/offers?zc=${formattedZip}` + `&filters=${(0,sharedUtils/* base64EncodeUnicode */.Fl)(JSON.stringify(filters))}` + `&referrer=${opts.categorySlugAlias ?? ""}` + `&${(0,routerQueriesToString/* gettingQueriesAsString */.r)(opts.query, "inline", [
        "category"
    ])}`;
};
/** Parses the `query.x` redirect-config payload (rejected-lead cross-domain redirect). */ const parseRedirectConfig = (rawX)=>{
    if (!rawX) return {};
    try {
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment
        return JSON.parse((0,sharedUtils/* base64DecodeUnicode */.e1)(rawX));
    } catch  {
        return {};
    }
};
/** Builds the `meta` block shared across all `submitLeadForm` calls. */ const buildSharedMeta = (input)=>({
        countryCode: input.selectedCountryCode || "US",
        skippedValidationFields: input.skippedValidationFields?.length ? input.skippedValidationFields.join(",") : "",
        autoFilledFieldCodeNames: input.autoFilledFieldCodeNames?.length ? input.autoFilledFieldCodeNames.join(",") : "",
        ...input.selectedOptions && Object.keys(input.selectedOptions).length > 0 && {
            selectedOption: input.selectedOptions
        },
        timeOnSite: input.timeOnSiteSeconds,
        lander: localStorage.getItem("lander") ?? "",
        consent: input.consent,
        hasDomainConsent: input.hasDomainConsent ?? undefined,
        referredByDomain: input.referredByDomain,
        ...input.redirectedLeadId && {
            redirectedLeadId: input.redirectedLeadId
        }
    });
/**
 * Builds the second-service `meta` extension. Only relevant when the
 * domain has second-service enabled AND the current call is for the
 * second form — links it back to the first-service lead via the
 * `mainId` stored in localStorage.
 */ const buildSecondServiceMeta = (input)=>{
    if (!input.isSecondService || !input.secondForm) return {};
    const mainId = localStorage.getItem("mainId");
    return {
        isSecondService: true,
        ...mainId ? {
            parent: mainId
        } : {},
        startingService: input.categoryName || ""
    };
};

;// CONCATENATED MODULE: ./src/hooks/useForm/sendDataToServer.helpers.ts


;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useForm.tsx
/* eslint-disable @typescript-eslint/require-await */ 































// Module-level page load identifier — regenerated on every hard reload (synchronizedForms only).
const PAGE_LOAD_ID =  true ? `${Date.now()}` : 0;
const SYNC_EVENTS = {
    instanceSubmitted: "formInstanceSubmitted",
    stepChanged: "formStepChanged",
    dataSynced: "formDataSynced"
};
const getSyncStorageKeys = (formId)=>({
        fields: `form-${formId}`,
        submitted: `form-${formId}-submitted`,
        step: `form-${formId}-step`,
        pageLoadId: `form-${formId}-page-load-id`
    });
const safeParseFieldsState = (stateStr)=>{
    if (!stateStr) return null;
    try {
        return JSON.parse(stateStr);
    } catch  {
        return null;
    }
};
const useForm = (form, isSecondServiceForm, isPiiCompletionForm, goToListPage, resetLeadId, scrollToTop, showInModal, isFormInsideOffersModal, isFormSubmitted, initialFieldData, singleQuestion, urlToRedirectFromSingleQuestion, isGeneralModalForm)=>{
    const { executeRecaptcha  } = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)();
    const { 0: listingSlug , 1: setListingSlug  } = (0,react.useState)(null);
    const { asPath , query  } = (0,next_router.useRouter)();
    const { fields  } = useFields(form);
    const { 0: showPiiCompletionOtherFields , 1: setShowPiiCompletionOtherFields  } = (0,react.useState)(false);
    const { locale , selectedCountryCode , totalTimeSpendOnSite , domain , domainNameTranslation , category , piiCompletionData , handleUpdateOffers , // setShowFormModalState,
    setBuyerPhoneNumber , apiCallLoading , setApiCallLoading , loadOneToOneForm , routeConfig , headerOffer , referrer , visitDetails , userAgent ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const synchronizedForms = Boolean(routeConfig?.templateConfig?.variantConfig?.synchronizedForms) && !isFormInsideOffersModal;
    const syncStorageKeys = (0,react.useMemo)(()=>getSyncStorageKeys(form.id), [
        form.id
    ]);
    // Per-instance runtime flags (replaces the previous module-level `let`s).
    // Each call to `useForm` has its own copy so multiple form instances on
    // the same page do not bleed state into each other.
    const runtimeRef = (0,react.useRef)(createFormRuntime()); //need to check this logic more
    // Unique identifier for this form instance — used to prevent self-syncing (synchronizedForms only)
    const instanceIdRef = (0,react.useRef)(typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`);
    //  Used to track whether this instance is the first render of a modal form (synchronizedForms only)
    const { 0: modalFormFirstRender , 1: setModalFormFirstRender  } = (0,react.useState)(true);
    // Expose a ref to the function that fetches field data dependencies (synchronizedForms only)
    const fetchSyncedDependenciesRef = (0,react.useRef)(null);
    const { 0: state , 1: rawDispatch  } = (0,react.useReducer)(formReducer, {
        ...initState,
        fieldsState: fields
    });
    // Wraps the reducer dispatch so side effects that previously lived inside
    // the reducer (clearing the leadId singleton and the per-instance
    // `startSendingData` flag on SET_FORM_SUBMITTED) still happen.
    const dispatch = (0,react.useCallback)((action)=>{
        if (action.type === ActionTypes.SET_FORM_SUBMITTED) {
            leadIdSingleton.set(null);
            runtimeRef.current.startSendingData = false;
            // Mark — synchronously and globally — that a form has been
            // submitted. This is set the moment ANY useForm instance dispatches
            // SET_FORM_SUBMITTED (including the exit-modal form), so the
            // beforeunload auto-save guard can bail before the page form
            // re-renders to flip its own `isFormSubmitted` ref. Without this,
            // a redirect-triggered `beforeunload` races ahead of that re-render
            // and re-fires a stray `submit: false` request.
            window.__anyFormSubmitted = true;
        }
        rawDispatch(action);
    }, []);
    const { steps , setSteps  } = useSteps(form, fields, singleQuestion);
    // It's a workaround to keep steps in sync with the current form definition when switching to a second-service form at runtime.
    (0,react.useEffect)(()=>{
        if (isSecondServiceForm && fields) {
            const updatedSteps = [
                ...form.steps
            ];
            setSteps(updatedSteps);
        }
    }, [
        form,
        isSecondServiceForm,
        fields
    ]);
    // The step index at which the first API call to fetch buyers should be made. On second-service forms this is always the first step, on regular forms it's determined by the form definition (the `stepToFetchBuyers` field) and compared against the `stepToSendingData` field to ensure it happens before sending data to server.
    const stepToStartFetchingBuyers = (0,react.useMemo)(()=>{
        const fetchingBuyersIndex = form.steps.findIndex((step)=>step.id === form.stepToFetchBuyers);
        const sendingDataIndex = form.steps.findIndex((step)=>step.id === form.stepToSendingData);
        if (fetchingBuyersIndex > sendingDataIndex) {
            return fetchingBuyersIndex;
        }
        return sendingDataIndex;
    }, [
        form
    ]);
    (0,react.useEffect)(()=>{
        // clear leadId on multiform service
        if (state.currentStep === 0 && resetLeadId) {
            const cachedLeadID = sessionStorage.getItem(`lead-id-form-${form.id}`);
            leadIdSingleton.set(cachedLeadID ?? null);
            runtimeRef.current.startSendingData = false;
        }
        if (state.submitted && state.currentStep === form.steps.length - 1) {
            setFormSubmitted(true);
            if (synchronizedForms) {
                // Persist submission state so modal forms know on remount
                sessionStorage.setItem(syncStorageKeys.submitted, "true");
                // Notify other same-formId instances that this form was submitted
                window.dispatchEvent(new CustomEvent(SYNC_EVENTS.instanceSubmitted, {
                    detail: {
                        formId: String(form.id),
                        instanceId: instanceIdRef.current
                    }
                }));
            }
        }
    }, [
        state.submitted,
        state.currentStep,
        form
    ]);
    const prevFieldsState = (0,usePrev/* usePrev */.z)(state.fieldsState);
    const nextState = useNext(state);
    const { 0: windowStep , 1: setWindowStep  } = (0,react.useState)(null); // window history step
    const successMessage = useSuccessStep(form.successMessage, state.fieldsState, !!isSecondServiceForm);
    const jornayaIdRef = (0,react.useRef)(null);
    const { setFormSubmitted  } = (0,useFormContext/* useFormContext */.G)();
    const getEventDetail = (event)=>event.detail;
    const isPeerEvent = (0,react.useCallback)((detail)=>{
        return !!detail && String(detail.formId) === String(form.id) && detail.instanceId !== instanceIdRef.current;
    }, [
        form.id
    ]);
    // Submission forms synchronization, Listen for submission events from other form instances with the same formId (synchronizedForms only)
    (0,react.useEffect)(()=>{
        if (!synchronizedForms) return;
        const handlePeerSubmission = (event)=>{
            const detail = getEventDetail(event);
            if (!isPeerEvent(detail) || state.submitted) return;
            dispatch({
                type: ActionTypes.SET_FORM_SUBMITTED,
                payload: {
                    formId: form.id
                }
            });
            setFormSubmitted(true);
        };
        window.addEventListener(SYNC_EVENTS.instanceSubmitted, handlePeerSubmission);
        return ()=>{
            window.removeEventListener(SYNC_EVENTS.instanceSubmitted, handlePeerSubmission);
        };
    }, [
        synchronizedForms,
        form.id,
        state.submitted,
        dispatch,
        setFormSubmitted,
        isPeerEvent, 
    ]);
    // Step synchronization, Listen for step changes (e.g. prev button) from peer form instances (synchronizedForms only)
    (0,react.useEffect)(()=>{
        if (!synchronizedForms) return;
        const handlePeerStepChange = (event)=>{
            const detail = getEventDetail(event);
            if (!isPeerEvent(detail) || typeof detail.step !== "number") {
                return;
            }
            dispatch({
                type: ActionTypes.SET_STEP,
                payload: detail.step
            });
        };
        window.addEventListener(SYNC_EVENTS.stepChanged, handlePeerStepChange);
        return ()=>{
            window.removeEventListener(SYNC_EVENTS.stepChanged, handlePeerStepChange);
        };
    }, [
        synchronizedForms,
        dispatch,
        isPeerEvent
    ]);
    // Fields synchronization, Listen for field data sync events from peer form instances and merge the shared field snapshot into state (synchronizedForms only)
    (0,react.useEffect)(()=>{
        if (!synchronizedForms) return;
        const handlePeerDataChange = (event)=>{
            const detail = getEventDetail(event);
            if (!isPeerEvent(detail)) return;
            const peerFields = safeParseFieldsState(sessionStorage.getItem(syncStorageKeys.fields));
            if (!peerFields) return;
            dispatch({
                type: ActionTypes.SET_FIELDS_STATE,
                payload: peerFields
            });
            if (detail.dependentFieldCodeNames?.length) {
                fetchSyncedDependenciesRef.current?.(detail.dependentFieldCodeNames);
            }
        };
        window.addEventListener(SYNC_EVENTS.dataSynced, handlePeerDataChange);
        return ()=>{
            window.removeEventListener(SYNC_EVENTS.dataSynced, handlePeerDataChange);
        };
    }, [
        synchronizedForms,
        dispatch,
        syncStorageKeys.fields,
        isPeerEvent
    ]);
    const getPhoneNumberValue = (category, headerOffer)=>{
        let phoneNumber;
        if (category && headerOffer && headerOffer?.length) {
            phoneNumber = (0,sharedUtils/* getPhoneNumber */.ly)(headerOffer[0]);
        } else {
            phoneNumber = "";
        }
        return phoneNumber ? (0,sharedUtils/* formatPhoneNumber */.un)(phoneNumber) : null;
    };
    const phoneNumber = getPhoneNumberValue(category, headerOffer);
    //rejected answer validation: check domain -> check category
    const domainEnableRejectedAnswer = Boolean(domain?.config?.enableRejectedAnswers || category?.config?.enableRejectedAnswers);
    const rejectedAnswersRules = domain?.config?.enableRejectedAnswers ? domain.config?.rejectedAnswersRules : category?.config?.rejectedAnswersRules;
    const jornayaIdElement = (0,react.useMemo)(()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
            id: "leadid_token",
            name: "universal_leadid",
            type: "hidden",
            value: "",
            ref: jornayaIdRef
        });
    }, []);
    const { submitted , loadingForm , currentStep , fieldsState , formError , otp , waitingOtp , visitedSteps , showExitModal , stepStatus , formErrors , formErrorsResolved , showRegulations , showCustomListingModal , showFormModal , showFromInExitModal , operation , globalLoading ,  } = state;
    const skippedStepIndices = (0,react.useMemo)(()=>getSkippedStepIndices(steps, fieldsState), [
        steps,
        fieldsState
    ]);
    (0,react.useEffect)(()=>{
        if (!skippedStepIndices.has(currentStep)) return;
        const nextVisible = findNextVisibleIndex(currentStep, skippedStepIndices, steps.length);
        if (nextVisible === currentStep) return;
        window.history.replaceState(null, "", `#step-${nextVisible + 1}`);
        dispatch({
            type: ActionTypes.SET_STEP,
            payload: nextVisible
        });
    }, [
        skippedStepIndices,
        currentStep,
        steps.length,
        dispatch
    ]);
    (0,react.useEffect)(()=>{
        const skippedBeforeCurrent = Array.from(skippedStepIndices).filter((index)=>index < currentStep);
        if (!skippedBeforeCurrent.length) return;
        const clearedFields = {
            ...fieldsState
        };
        let hasChanges = false;
        skippedBeforeCurrent.forEach((index)=>{
            const step = steps[index];
            if (!step) return;
            step.fields.forEach((field)=>{
                if (field.codeName in clearedFields) {
                    delete clearedFields[field.codeName];
                    hasChanges = true;
                }
            });
        });
        if (!hasChanges) return;
        const replaceFieldsAction = {
            type: ActionTypes.REPLACE_FIELDS_STATE,
            payload: clearedFields
        };
        dispatch(replaceFieldsAction);
    }, [
        skippedStepIndices,
        currentStep,
        steps,
        fieldsState,
        dispatch
    ]);
    // Mirror the reducer's `submitted` flag into a ref so the (stable,
    // []-deps) beforeunload listener below can read the *current* submitted
    // state — a plain closure would capture a stale `state.submitted` from the
    // first render. Updated on every render.
    const submittedRef = (0,react.useRef)(false);
    submittedRef.current = state.submitted;
    // Auto-save listener for browser unload/navigation.
    // This persists partially-filled data ONLY when the user leaves WITHOUT
    // completing the form. It must never fire once the form is submitted.
    //
    // Three "already submitted" signals, because no single one covers every
    // case from inside this instance's listener:
    //  - `clickedOnSubmit`: this instance clicked submit.
    //  - `submittedRef`: this instance's reducer is submitted (covers the
    //    inline exit-modal handoff, which marks the page form submitted).
    //  - `__anyFormSubmitted`: set synchronously when ANY instance submits —
    //    covers the exit-modal form (a separate instance) and the redirect ->
    //    beforeunload race that fires before the page form re-renders.
    const sendDataToServerListener = (0,react.useCallback)(()=>{
        const accessToken = (0,cookies/* getAccessToken */.hP)();
        const anyFormSubmitted = !!window.__anyFormSubmitted;
        const willFire = !runtimeRef.current.clickedOnSubmit && !submittedRef.current && !isFormSubmitted.current && !anyFormSubmitted && !!accessToken;
        if (willFire) {
            void sendDataToServer({
                submit: false
            });
        }
    }, []);
    const getStepField = (fieldCodeName)=>{
        const stepIndex = steps.findIndex((s)=>s.fields.find((f)=>f.codeName === fieldCodeName));
        return steps[stepIndex].fields.find((f)=>f.codeName === fieldCodeName);
    };
    // Modal state handlers extracted into a dedicated hook.
    // - toggleShowFormInExitModal: opens/closes the form embedded in the exit-offer modal.
    // - setShowCustomListingModal: controls visibility of the custom listing modal state.
    // - toggleFormModal: toggles the main form-in-modal container based on step/context.
    // - forceShowListingModal: conditionally interrupts normal flow to show a listing modal.
    const { toggleShowFormInExitModal , setShowCustomListingModal , toggleFormModal , forceShowListingModal ,  } = useFormModals({
        dispatch,
        setListingSlug
    });
    // Single-question flow helper.
    // Builds the redirect behavior used by one-question forms, where submit
    // should navigate immediately instead of continuing the standard step flow.
    // `redirectForSingleQuestion` is called from handleSubmit when that mode is enabled.
    const { redirectForSingleQuestion  } = useSingleQuestion({
        singleQuestion,
        urlToRedirectFromSingleQuestion,
        dispatch,
        isFormSubmitted
    });
    const getExcludedBuyersId = ()=>{
        if (query.x) {
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const data = // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            JSON.parse((0,sharedUtils/* base64DecodeUnicode */.e1)(query.x));
            return typeof data.excludedBuyers === "string" ? data.excludedBuyers.split(",").map((item)=>Number(item)) : [];
        }
        return [];
    };
    /**
     * Side-channel A: "Partner With Us" / lead-capture form.
     * Bypasses the normal lead flow and posts to the contact-us endpoint.
     */ const runLeadCaptureSubmit = async (fields)=>{
        const token = executeRecaptcha ? await executeRecaptcha("contact_us_form") : null;
        const payload = buildContactUsPayload(fields, {
            googleReCaptcha: token,
            categoryName: category?.name
        });
        const { error  } = await (0,api/* submitContactUsForm */.F2)({
            //@ts-ignore
            fields: {
                ...payload
            }
        });
        if (!error) {
            dispatch({
                type: ActionTypes.SET_FORM_SUBMITTED,
                payload: {
                    formId: form.id
                }
            });
        }
        return {
            success: !error,
            data: null
        };
    };
    /**
     * Side-channel B: redirect the user to the /offers listing page
     * with their answers encoded into the URL (no lead submission).
     */ const runGoToListRedirect = (fields)=>{
        window.location.href = buildOffersListRedirectUrl(fields, {
            query,
            categorySlugAlias: category?.slugAlias
        });
        return {
            success: true,
            data: null
        };
    };
    /**
     * Dispatches the reducer action that corresponds to the
     * `submitLeadForm` response — either kick off an operation
     * (round-one / round-two / fetch buyers) or mark the form as
     * fully submitted when the lead was enqueued.
     */ const dispatchAfterSubmit = ({ data , submit , fetchBuyers , buyerIds  })=>{
        if (data?.operationId) {
            dispatch({
                type: ActionTypes.SET_OPERATION,
                payload: {
                    operationId: data.operationId,
                    key: fetchBuyers ? "FETCH_BUYERS" : submit ? "ROUND_TWO" : "ROUND_ONE"
                }
            });
        } else if (submit && (!loadOneToOneForm || buyerIds?.length === 0) && data?.enqueued) {
            dispatch({
                type: ActionTypes.SET_FORM_SUBMITTED,
                payload: {
                    formId: form.id
                }
            });
        }
    };
    /**
     * Persists the resolved leadId across the leadId singleton,
     * sessionStorage (per-form), and localStorage (`mainId` is the
     * cross-form anchor used by second-service flows).
     */ const persistLeadId = (data)=>{
        const nextLeadId = data?.leadId ?? leadIdSingleton.get() ?? null;
        leadIdSingleton.set(nextLeadId);
        if (nextLeadId && resetLeadId) {
            sessionStorage.setItem(`lead-id-form-${form.id}`, nextLeadId);
        }
        if (!isSecondServiceForm) {
            localStorage.setItem("mainId", nextLeadId);
        }
    };
    const sendDataToServer = async ({ submit , formOtp , skippedValidationFields , secondForm , consent , fetchBuyers , buyerIds , consentLanguage , hasDomainConsent  })=>{
        let hasSubmitLock = false;
        if (submit) {
            hasSubmitLock = finalSubmitLock.tryAcquire(form.id);
            if (!hasSubmitLock) {
                return {
                    success: false,
                    data: null
                };
            }
        }
        try {
            // ----- guards -----
            if (singleQuestion) return {
                success: true,
                data: null
            };
            const leadCaptureForm = !!domain.config?.leadCapture;
            if (!runtimeRef.current.startSendingData || leadCaptureForm && !submit || goToListPage && !submit) {
                return {
                    success: false,
                    data: null
                };
            }
            // ----- mark in-flight -----
            if (submit) runtimeRef.current.clickedOnSubmit = true;
            runtimeRef.current.isApiCallInProgress = true;
            dispatch({
                type: ActionTypes.SET_FORM_ERROR,
                payload: null
            });
            // ----- collect fields -----
            const { fieldsState: newFieldsState  } = await nextState();
            const { fields: filledFields , selectedOptions: collectedSelectedOptions ,  } = collectFieldsWithValues(newFieldsState, form, {
                isSecondServiceForm: !!isSecondServiceForm,
                leadCaptureForm
            });
            const { fields: fieldsForSubmit , autoFilledFieldCodeNames , selectedOptions ,  } = fillDefaultAnswersForSkippedQuestions(filledFields, (0,lodash/* flatten */.xH)(steps.map((step)=>step.fields)), collectedSelectedOptions);
            if (!isSecondServiceForm && state.submitted) {
                return {
                    success: false,
                    data: null
                };
            }
            if (!fieldsForSubmit.length) return {
                success: false,
                data: null
            };
            // ----- side-channels (early-return flows that bypass submitLeadForm) -----
            if (submit && leadCaptureForm) {
                return runLeadCaptureSubmit(fieldsForSubmit);
            }
            if (submit && goToListPage) {
                return runGoToListRedirect(fieldsForSubmit);
            }
            // ----- main path: submitLeadForm -----
            const redirectConfig = parseRedirectConfig(query.x);
            const sharedMeta = buildSharedMeta({
                selectedCountryCode,
                skippedValidationFields,
                autoFilledFieldCodeNames: submit ? autoFilledFieldCodeNames : undefined,
                selectedOptions,
                timeOnSiteSeconds: totalTimeSpendOnSite.current / 1000,
                consent,
                hasDomainConsent,
                referredByDomain: query.referredBy,
                redirectedLeadId: redirectConfig.redirectedLeadId
            });
            const secondServiceMeta = buildSecondServiceMeta({
                isSecondService: domain.settings?.isSecondServiceEnabled,
                secondForm,
                categoryName: category?.name
            });
            const currentLeadId = sessionStorage.getItem(`lead-id-form-${form.id}`);
            const forcedBuyersIds = getForcedBuyersIds();
            const excludedBuyers = getExcludedBuyersId();
            const { error , data  } = await (0,api/* submitLeadForm */.j4)({
                fields: fieldsForSubmit,
                leadId: piiCompletionData?.leadId ?? leadIdSingleton.get() ?? currentLeadId,
                jornayaId: document?.getElementById("leadid_token")?.value ?? undefined,
                url: window.location.href,
                submit,
                fetchBuyers,
                ...forcedBuyersIds && fetchBuyers ? {
                    forcedBuyersIds
                } : {},
                ...excludedBuyers.length && fetchBuyers ? {
                    excludedBuyers
                } : {},
                domainFormId: form?.domainFormId,
                otpCode: formOtp ?? undefined,
                language: locale ?? "en",
                consentLanguage,
                meta: {
                    ...(0,sharedUtils/* getUserMeta */.Uj)(),
                    ...secondServiceMeta,
                    ...sharedMeta
                },
                isPiiCompletionForm: isPiiCompletionForm || undefined,
                token: isPiiCompletionForm ? query["pii-token"] : undefined,
                buyerIds,
                isOneToOneConsent: !!loadOneToOneForm
            });
            // ----- post-response -----
            dispatchAfterSubmit({
                data,
                submit,
                fetchBuyers,
                buyerIds
            });
            persistLeadId(data);
            // drain next queued task if any
            if (runtimeRef.current.queues.length > 0) {
                const queued = runtimeRef.current.queues.shift();
                if (queued) {
                    await queued();
                }
            }
            return {
                data,
                success: !error
            };
        } finally{
            runtimeRef.current.isApiCallInProgress = false;
            if (hasSubmitLock) {
                finalSubmitLock.release(form.id);
            }
        }
    };
    const setLoading = (loading)=>{
        dispatch({
            type: ActionTypes.SET_LOADING_FORM,
            payload: loading
        });
    };
    const setLoadingBuyers = (loading)=>{
        dispatch({
            type: ActionTypes.SET_OPERATION,
            payload: {
                loadingBuyers: loading
            }
        });
    };
    const setHasRegulations = (hasRegulations)=>{
        dispatch({
            type: ActionTypes.SHOW_REGULATIONS_PAGE,
            payload: {
                showRegulations: hasRegulations
            }
        });
    };
    /**
     * Flatten every step's fields into a single `{ codeName: value }` map,
     * keeping only entries the user actually filled (empty / whitespace-only
     * values are dropped). Used to pre-fill the fallback funnel.
     */ const collectFilledFieldValues = ()=>{
        const filled = {};
        form.steps.forEach((step)=>{
            step.fields.forEach((f)=>{
                const value = fieldsState[f.codeName]?.value;
                if (value?.trim()) {
                    filled[f.codeName] = value;
                }
            });
        });
        return filled;
    };
    /**
     * Wipe the cached form state for this form on this domain so the user
     * can't come back and resubmit the same rejected lead.
     */ const clearFormCacheForCurrentDomain = ()=>{
        sessionStorage.removeItem(`form-${form.id}`);
        sessionStorage.removeItem(`lead-id-form-${form.id}`);
    };
    /**
     * Resolve the environment-matching subdomain prefix so the fallback URL
     * stays in the same environment as the current page
     * (staging → staging.<fallback>, local → local.<fallback>, else prod).
     */ const getEnvironmentSubdomain = ()=>{
        const hostname = window.location.hostname;
        const isStaging = hostname.includes("staging");
        const isLocal = hostname.includes("local.");
        if (isStaging) return "staging.";
        if (isLocal) return "local.";
        return "";
    };
    /**
     * Build the absolute URL that hands the rejected lead off to the fallback
     * funnel, encoding the user's answers and the buyer-exclusion payload as
     * query params.
     */ const buildFallbackRedirectUrl = (filledFields)=>{
        // `la` param — base64-encoded answers consumed by the fallback funnel
        // to pre-fill its own fields.
        const encodedAnswers = (0,sharedUtils/* base64EncodeUnicode */.Fl)(JSON.stringify(filledFields));
        // `x` param — base64-encoded payload telling the fallback funnel
        // which buyers already rejected this lead (so it doesn't offer them
        // again) and the original leadId so the back-end can link both attempts.
        const excludedBuyers = domain.fallbackSettings?.excludedBuyers.join(",");
        const encodedRedirectInfo = (0,sharedUtils/* base64EncodeUnicode */.Fl)(JSON.stringify({
            excludedBuyers,
            redirectedLeadId: leadIdSingleton.get() || ""
        }));
        // Forward marketing / tracking query params, but strip the ones we're
        // about to overwrite (`x`, `la`, `tb`, `lead_uuid`) and the legacy
        // `data` param.
        const STRIPPED_QUERY_PARAMS = [
            "data",
            "la",
            "tb",
            "x",
            "lead_uuid"
        ];
        const forwardedQueryString = (0,routerQueriesToString/* gettingQueriesAsString */.r)(query, "start", STRIPPED_QUERY_PARAMS);
        // `domain.fallbackSettings.domain` may be stored with or without the
        // https:// prefix; normalize so we don't end up with `https://https://`.
        const rawDestination = domain.fallbackSettings?.domain;
        const cleanedDestination = rawDestination.includes("https://") ? rawDestination.split("https://")[1] : rawDestination;
        // `/fbas` (auto-sell) vs `/fb` (regular fallback). `tb=true` flags
        // this as a transferred-buyer / rejected-lead handoff so the
        // destination knows to consume the encoded payload.
        const redirectPath = domain.config?.autoSell ? "fbas" : "fb";
        const currentLeadId = leadIdSingleton.get();
        const leadUuidParam = currentLeadId ? `&lead_uuid=${currentLeadId}` : "";
        const protocol = window.location.protocol;
        const port = window.location.port;
        const portSegment = port ? `:${port}` : "";
        const subdomain = getEnvironmentSubdomain();
        return `${protocol}//${subdomain}${cleanedDestination}${portSegment}` + `/${redirectPath}` + `?x=${encodedRedirectInfo}` + `&tb=true` + `&la=${encodedAnswers}` + `${leadUuidParam}` + `&${forwardedQueryString}`;
    };
    /**
     * Called when the current lead is rejected (no buyer accepts it).
     * Forwards the user to the domain configured in `domain.fallbackSettings`
     * (a different brand/funnel under the same family) while preserving the
     * answers they already filled in, so they don't have to start over.
     */ const handleRejectedLeads = ()=>{
        const filledFields = collectFilledFieldValues();
        clearFormCacheForCurrentDomain();
        const fallbackUrl = buildFallbackRedirectUrl(filledFields);
        window.location.replace(fallbackUrl);
    };
    const { fetchFirstRoundBuyers , startFirstRoundBidding , startSecondRoundBidding ,  } = useBidding({
        form,
        domain,
        dispatch,
        sendDataToServer,
        setLoading,
        setLoadingBuyers,
        handleRejectedLeads,
        categorySlug: category?.slug,
        initialFieldData
    });
    const { saveSharedFields , fillFormWithSharedFields , getSharedFields  } = useSharedFields({
        dispatch
    });
    const { serverSideValidation , handleFieldBlur , handleStepValidation  } = useValidation({
        form,
        domain,
        locale,
        selectedCountryCode,
        domainNameTranslation,
        state,
        steps,
        dispatch,
        runtimeRef,
        otp,
        isPiiCompletionForm,
        piiCompletionData,
        loadingForm,
        handleUpdateOffers,
        getStepField,
        nextState,
        saveSharedFields,
        sendDataToServer,
        setHasRegulations,
        setShowPiiCompletionOtherFields,
        domainEnableRejectedAnswer,
        rejectedAnswersRules,
        phoneNumber,
        referrer,
        visitDetails,
        userAgent
    });
    const dispatchNextStep = (options)=>{
        const routedStep = getRoutedStepIndex(steps, currentStep, options?.routingFieldsData ?? fieldsState);
        let nextStep;
        if (routedStep !== null) {
            window.history.pushState(null, "", `#step-${routedStep + 1}`);
            dispatch({
                type: ActionTypes.SET_STEP,
                payload: routedStep
            });
            nextStep = routedStep;
        } else {
            dispatch({
                type: ActionTypes.SET_NEXT_STEP,
                payload: undefined
            });
            nextStep = currentStep + 1;
        }
        if (synchronizedForms) {
            // Notify peer form instances about the step advance.
            window.dispatchEvent(new CustomEvent(SYNC_EVENTS.stepChanged, {
                detail: {
                    formId: String(form.id),
                    instanceId: instanceIdRef.current,
                    step: nextStep
                }
            }));
        }
    };
    const handleSubmit = async (ev, options)=>{
        ev?.preventDefault();
        // Guard against duplicate submissions / form already finalized.
        const isFormBusy = loadingForm || submitted || waitingOtp || finalSubmitLock.isLocked(form.id);
        if (isFormBusy) return;
        runtimeRef.current.submitStepClicked = true;
        const stepValid = options?.skipValidation ? false : await handleStepValidation(options?.routingFieldsData);
        // We can advance when the step validated OR the caller explicitly
        // asked us to skip validation (e.g. silent / programmatic advance).
        const canProceed = stepValid || !!options?.skipValidation;
        // Single-question forms have their own redirect flow and never run
        // through the normal step-by-step submission below.
        if (singleQuestion && canProceed) {
            redirectForSingleQuestion({
                skipToStep: options?.skipToStep
            });
            return;
        }
        // Fire the analytics "first form interaction" event once when the
        // user submits step 0.
        if (currentStep === 0) {
            void (0,api/* callEvent */.dr)({
                event: "FirstFormInteraction"
            });
        }
        // ----- local flags shared by the helpers below -----
        const isFirstStep = currentStep === 0;
        const isLastStep = currentStep === steps.length - 1;
        const hasTcpaOnCurrentStep = !!steps[currentStep]?.includeTCPAMessage;
        const shouldFetchBuyers = !!loadOneToOneForm && currentStep === stepToStartFetchingBuyers;
        const isSecondFormFlag = !!options?.isSecondForm;
        // The hidden <label> rendered next to the TCPA checkbox; we capture
        // its rendered HTML so the back-end can store the exact consent text
        // the user agreed to.
        const tcpaText = document.querySelector('[data-tf-element-role="consent-language"]');
        // Buyers the user picked in the round-one bidding modal (only set on
        // one-to-one flows).
        const selectedBuyerIds = operation?.firstRoundBuyers?.filter((i)=>i.selected)?.map((buyer)=>buyer.buyerId);
        // ----- TCPA #1: record consent (+ optionally fetch buyers) BEFORE
        // the optional first-step api-call flow runs, so consent is captured
        // even if that flow short-circuits the rest of handleSubmit.
        if (hasTcpaOnCurrentStep) {
            void sendDataToServer({
                submit: false,
                consent: true,
                secondForm: options?.isSecondForm,
                fetchBuyers: shouldFetchBuyers,
                consentLanguage: tcpaText?.innerHTML,
                buyerIds: selectedBuyerIds,
                hasDomainConsent: operation?.hasDomainConsent
            });
        }
        // First-step api-call hook (e.g. instant-quote / phone-number lookup).
        // If it returns a buyer phone number we hand that to the UI and stop.
        const shouldRunApiCallFlow = !!options?.enableApiCall && canProceed && isFirstStep;
        if (shouldRunApiCallFlow) {
            const result = await applyApiCallFlow(options);
            if (result) {
                setBuyerPhoneNumber(result);
                setApiCallLoading(false);
                return;
            }
        }
        // ----- TCPA #2: re-record consent after the api-call flow ran.
        // Buyers were already requested in TCPA #1 so this call omits
        // fetchBuyers/buyerIds on purpose.
        if (hasTcpaOnCurrentStep) {
            void sendDataToServer({
                submit: false,
                consent: true,
                secondForm: options?.isSecondForm
            });
        }
        if (!canProceed) return;
        // ----- step-progress / lead-submission helpers (closures over the
        // locals declared above; intentionally inner so we don't have to
        // thread tcpaText / selectedBuyerIds / options through arguments).
        const advanceToNextStep = ()=>{
            dispatchNextStep(options);
        };
        /** Final-step submit: send the lead and run server-side validation. */ const submitFinalStep = async ()=>{
            const { data , success  } = await sendDataToServer({
                submit: true,
                skippedValidationFields: runtimeRef.current.skippedValidationFields,
                secondForm: isSecondFormFlag,
                buyerIds: selectedBuyerIds,
                consentLanguage: tcpaText?.innerHTML
            });
            serverSideValidation({
                data,
                success
            });
        };
        /** Intermediate-step send: just persists step data (no submit). */ const sendIntermediateStepData = (fetchBuyersFlag)=>sendDataToServer({
                submit: false,
                skippedValidationFields: runtimeRef.current.skippedValidationFields,
                secondForm: isSecondFormFlag,
                fetchBuyers: fetchBuyersFlag
            });
        /**
         * Creates the lead (no leadId yet) and either runs final validation
         * on submit or advances to the next step.
         */ const createLeadAndContinue = async (fetchBuyersFlag)=>{
            const { data , success  } = await sendDataToServer({
                submit: isLastStep,
                skippedValidationFields: runtimeRef.current.skippedValidationFields,
                secondForm: isSecondFormFlag,
                fetchBuyers: fetchBuyersFlag,
                buyerIds: isLastStep ? selectedBuyerIds : undefined
            });
            if (isLastStep) {
                serverSideValidation({
                    data,
                    success
                });
            } else {
                advanceToNextStep();
            }
        };
        // `zipCode` is cached by the StreetAddress field's autocomplete;
        // clear it so it doesn't leak between forms / submissions.
        localStorage.removeItem("zipCode");
        const hasExistingLeadId = !!leadIdSingleton.get();
        const isAnotherApiCallInFlight = runtimeRef.current.isApiCallInProgress;
        // ----- no lead yet: create one (optionally queued behind an
        // in-flight call). startLoadingForm so the UI shows a spinner while
        // we wait for the lead to be created.
        if (!hasExistingLeadId) {
            setLoading(true);
            if (isAnotherApiCallInFlight) {
                runtimeRef.current.queues.push(async ()=>{
                    void createLeadAndContinue(shouldFetchBuyers);
                });
            } else {
                void createLeadAndContinue(shouldFetchBuyers);
            }
            return;
        }
        // ----- lead already exists -----
        if (isAnotherApiCallInFlight) {
            // Queue the step-data insertion behind the in-flight call so
            // requests don't race.
            if (isLastStep) {
                setLoading(true);
                runtimeRef.current.queues.push(submitFinalStep);
            } else {
                if (shouldFetchBuyers) {
                    runtimeRef.current.queues.push(async ()=>{
                        await sendIntermediateStepData(true);
                    });
                }
                // Don't wait for the queued call \u2014 advance the UI now so
                // the user perceives the step transition as instant.
                advanceToNextStep();
            }
            return;
        }
        // ----- no api call in flight, lead exists \u2014 fire immediately -----
        if (isLastStep) {
            setLoading(true);
            await submitFinalStep();
        } else {
            void sendIntermediateStepData(shouldFetchBuyers);
            advanceToNextStep();
        }
    };
    const loadFieldsFromSessionStorage = ()=>{
        try {
            if (initialFieldData) {
                const fieldData = {
                    valid: true,
                    errorMessage: null,
                    value: null,
                    optionSelectedIndex: undefined,
                    changed: false,
                    fieldType: "email",
                    defaultValues: null
                };
                const x = Object.keys(initialFieldData).reduce((acc, key)=>{
                    acc[key] = {
                        ...fieldData,
                        value: initialFieldData[key]
                    };
                    return acc;
                }, {});
                return x;
            }
            if (isPiiCompletionForm) {
                const fields = piiCompletionData?.fields.reduce((acc, field)=>{
                    acc[field.codeName] = {
                        value: field.value,
                        errorMessage: "",
                        changed: false,
                        valid: true
                    };
                    return acc;
                }, {}) ?? null;
                return fields;
            }
            const stateStr = sessionStorage.getItem(`form-${form.id}`);
            return stateStr ? JSON.parse(stateStr) : null;
        } catch (e) {
            return null;
        }
    };
    const reloadFormData = (0,react.useCallback)(()=>{
        const sessionStorageFields = loadFieldsFromSessionStorage();
        if (!sessionStorageFields) return;
        // Fix optionSelectedIndex for radio fields that were converted to select in modal
        const allFields = (0,lodash/* flatten */.xH)(steps.map((step)=>step.fields));
        const fieldByCodeName = new Map(allFields.map((field)=>[
                field.codeName,
                field
            ]));
        const fixedFields = {
            ...sessionStorageFields
        };
        // Restore missing optionSelectedIndex for radio values saved from modal/select rendering.
        Object.keys(fixedFields).forEach((codeName)=>{
            const fieldDef = fieldByCodeName.get(codeName);
            const fieldData = fixedFields[codeName];
            const isMissingSelectedIndex = fieldData.optionSelectedIndex === undefined || fieldData.optionSelectedIndex === null || fieldData.optionSelectedIndex === "";
            // If this is a radio field and has a value but no optionSelectedIndex
            if (fieldDef?.fieldType !== "radio" || !fieldData?.value || !isMissingSelectedIndex) {
                return;
            }
            const options = fieldDef.defaultValues?.options || fieldData.defaultValues?.options;
            const selectedIndex = options?.findIndex((option)=>option.value === fieldData.value);
            if (selectedIndex === undefined || selectedIndex < 0) return;
            fixedFields[codeName] = {
                ...fieldData,
                optionSelectedIndex: `${codeName}-${selectedIndex}`
            };
        });
        const resolveFirstIncompleteStep = shared_form/* getFirstIncompleteStep */.dR;
        const targetStep = resolveFirstIncompleteStep(steps, fixedFields);
        dispatch({
            type: ActionTypes.SET_FIELDS_STATE,
            payload: fixedFields
        });
        dispatch({
            type: ActionTypes.SET_STEP,
            payload: targetStep
        });
        // Update URL hash to reflect the target step
        window.history.pushState("", document.title, `#step-${targetStep + 1}`);
        // Also update sessionStorage with the fixed data
        sessionStorage.setItem(`form-${form.id}`, JSON.stringify(fixedFields));
        // Also update localStorage globalFormValues immediately
        if (!isSecondServiceForm) {
            const formAnswers = Object.keys(fixedFields).reduce((acc, key)=>{
                acc[key] = fixedFields[key].value;
                return acc;
            }, {});
            // @ts-ignore
            window.formAnswers = formAnswers;
            localStorage.setItem("globalFormValues", JSON.stringify(formAnswers));
        }
    }, [
        form.id,
        initialFieldData,
        isPiiCompletionForm,
        isSecondServiceForm,
        steps, 
    ]);
    const { getFieldsDataDependency , fetchFieldsDataDependency  } = useFieldDataDependency({
        steps,
        setSteps,
        prevFieldsState,
        fieldsState,
        nextState
    });
    // fetch data dependencies for fields that were updated in peer instances of the same form.(synchronizedForms only)
    (0,react.useEffect)(()=>{
        if (!synchronizedForms) return;
        fetchSyncedDependenciesRef.current = (codeNames)=>{
            const allFields = (0,lodash/* flatten */.xH)(steps.map((step)=>step.fields));
            const fieldsToFetch = allFields.filter((f)=>codeNames.includes(f.codeName) && f.dataDependency);
            if (fieldsToFetch.length) {
                void fetchFieldsDataDependency(fieldsToFetch);
            }
        };
    }, [
        steps,
        fetchFieldsDataDependency
    ]);
    const { applyApiCallFlow  } = useApiCall({
        fieldsState,
        dispatch,
        setApiCallLoading,
        setBuyerPhoneNumber,
        category
    });
    const handleFieldChange = async (field, val, optionSelectedIndex)=>{
        runtimeRef.current.submitStepClicked = false;
        let newVal = val;
        if (field.mask) {
            if (field.mask === "zipCode" && selectedCountryCode === "CA") {
                newVal = (0,shared_form/* handleFieldMasking */.yr)("postalCode", val);
            } else {
                newVal = (0,shared_form/* handleFieldMasking */.yr)(field.mask, val);
            }
        }
        const newObj = {};
        // Update field value
        newObj[field.codeName] = {
            ...field,
            valid: true,
            errorMessage: "",
            value: newVal,
            changed: true
        };
        if (optionSelectedIndex) {
            newObj[field.codeName]["optionSelectedIndex"] = optionSelectedIndex;
        }
        const { fieldsWithDataDependencyAndDependentOn  } = getFieldsDataDependency({
            changedFields: newObj,
            checkChangedFields: true
        });
        // Get all fields that depends on the field that value changed
        const finalChangedFields = [
            ...fieldsWithDataDependencyAndDependentOn
        ];
        // Get all fields that depends on the depends field that value changed
        fieldsWithDataDependencyAndDependentOn.forEach((fieldWithDataDependency)=>{
            const { fieldsWithDataDependencyAndDependentOn: temp  } = getFieldsDataDependency({
                checkChangedFields: true,
                // reset value to empty string
                changedFields: {
                    [fieldWithDataDependency.codeName]: {
                        value: ""
                    }
                }
            });
            newObj[fieldWithDataDependency.codeName] = {
                ...fieldWithDataDependency,
                valid: true,
                errorMessage: "",
                value: "",
                changed: true
            };
            temp.forEach((i)=>{
                newObj[i.codeName] = {
                    ...i,
                    valid: true,
                    errorMessage: "",
                    value: "",
                    changed: true
                };
            });
            finalChangedFields.push(...temp);
        });
        // update state for all dependingOn fields
        dispatch({
            type: ActionTypes.SET_FIELDS_STATE,
            payload: {
                ...newObj
            }
        });
        void fetchFieldsDataDependency((0,lodash/* uniqBy */.mN)(finalChangedFields, "codeName"));
        const { fieldsState: newFieldsState  } = await nextState();
        sessionStorage.setItem(`form-${form.id}`, JSON.stringify({
            ...newFieldsState,
            ...newObj
        }));
        // Notify other form instances about data update
        if (isFormInsideOffersModal) {
            // Also update localStorage globalFormValues for modal form
            if (!isSecondServiceForm) {
                const allFieldsState = {
                    ...newFieldsState,
                    ...newObj
                };
                const formAnswers = Object.keys(allFieldsState).reduce((res, key)=>{
                    res = {
                        ...res,
                        [key]: allFieldsState[key].value
                    };
                    return res;
                }, {});
                localStorage.setItem("globalFormValues", JSON.stringify(formAnswers));
            }
            window.dispatchEvent(new CustomEvent("formDataUpdated", {
                detail: {
                    formId: form.id
                }
            }));
        }
        // Notify peer instances about the changed fields so they can update accordingly
        if (synchronizedForms) {
            window.dispatchEvent(new CustomEvent(SYNC_EVENTS.dataSynced, {
                detail: {
                    formId: String(form.id),
                    instanceId: instanceIdRef.current,
                    dependentFieldCodeNames: (0,lodash/* uniqBy */.mN)(finalChangedFields, "codeName").map((f)=>f.codeName)
                }
            }));
        }
        if ((field.fieldType === "radio" || field.fieldType === "select" && singleQuestion) && !forceShowListingModal({
            meta: field.meta,
            selectedValue: val,
            currentFieldCodeName: field.codeName
        })) {
            if (checkIfStepHasOneField(newObj)) {
                void handleSubmit(undefined, {
                    skipValidation: field.meta?.rejectedAnswers ? false : true,
                    skipToStep: val ? "1" : undefined,
                    routingFieldsData: {
                        ...fieldsState,
                        ...newObj
                    }
                });
            }
        }
    };
    const checkIfStepHasOneField = (fieldsData)=>{
        if (steps[currentStep]?.fields.length === 1 && (steps[currentStep]?.fields[0].fieldType === "radio" || steps[currentStep]?.fields[0].fieldType === "select" && singleQuestion)) {
            return true;
        }
        let numberOfFields = 0;
        let stepHasOneRadioField = false;
        steps[currentStep].fields.forEach((field)=>{
            if ((0,shared_form/* canShowFieldAfterDependency */.bw)(field, fieldsData)) {
                numberOfFields++;
                stepHasOneRadioField = field.fieldType === "radio" && !stepHasOneRadioField ? true : false;
            }
        });
        return numberOfFields === 1 && stepHasOneRadioField;
    };
    const { handlePrevStep , handleWindowBack , handleFirstStepFieldFocus , handleScrollFormTop ,  } = useNavigation({
        form,
        state,
        dispatch,
        setWindowStep,
        skippedStepIndices,
        instanceId: instanceIdRef.current,
        isGeneralModalForm,
        synchronizedForms
    });
    const handleOutsideFormSubmit = ()=>{
        dispatch({
            type: ActionTypes.SET_FORM_SUBMITTED,
            payload: {
                formId: form.id
            }
        });
    };
    const { handleOtpSubmit , handleOtpResend , handleOtpEditPhoneNumber  } = useOtp({
        state,
        dispatch,
        sendDataToServer,
        setLoading
    });
    function onTransitionEnd(animation) {
        const eventTarget = animation.target;
        if (animation.propertyName === "transform" && eventTarget?.id === "stepsWrapper") {
            handleFirstStepFieldFocus();
        }
    }
    (0,react.useEffect)(()=>{
        if (isSecondServiceForm) {
            const fetchSharedFields = async ()=>{
                const sharedFields = await getSharedFields();
                if (sharedFields) {
                    fillFormWithSharedFields(sharedFields);
                }
            };
            void fetchSharedFields();
        }
    }, []);
    const handleCloseFormInsideExitModal = (options)=>{
        // If called because the modal form was submitted, mark the main form as submitted too
        if (options?.wasFormSubmitted) {
            toggleShowFormInExitModal(false);
            // Set the hero form to the last step so the slide animation works correctly
            // (useSlideFormValue calculates thank you position relative to currentStep)
            dispatch({
                type: ActionTypes.SET_STEP,
                payload: steps.length - 1
            });
            dispatch({
                type: ActionTypes.SET_FORM_SUBMITTED,
                payload: {
                    formId: form.id
                }
            });
            return;
        }
        if (!state.blockBack) {
            const sessionStorageFields = loadFieldsFromSessionStorage();
            const { steps: steps1  } = form;
            if (sessionStorageFields) {
                // Fix optionSelectedIndex for radio fields that were converted to select in modal
                const allFields = (0,lodash/* flatten */.xH)(steps1.map((step)=>step.fields));
                const fixedFields = {
                    ...sessionStorageFields
                };
                Object.keys(fixedFields).forEach((codeName)=>{
                    const fieldDef = allFields.find((f)=>f.codeName === codeName);
                    const fieldData = fixedFields[codeName];
                    // If this is a radio field and has a value but no optionSelectedIndex
                    if (fieldDef?.fieldType === "radio" && fieldData?.value && (fieldData.optionSelectedIndex === undefined || fieldData.optionSelectedIndex === null || fieldData.optionSelectedIndex === "")) {
                        // Get options from either defaultValues or field data itself
                        const options = fieldDef.defaultValues?.options || fieldData.defaultValues?.options;
                        // Find the index of the selected option
                        const selectedIndex = options?.findIndex((option)=>option.value === fieldData.value);
                        if (selectedIndex !== undefined && selectedIndex >= 0) {
                            // Format must match: `${field.codeName}-${index}`
                            fixedFields[codeName] = {
                                ...fieldData,
                                optionSelectedIndex: `${codeName}-${selectedIndex}`
                            };
                        }
                    }
                });
                dispatch({
                    type: ActionTypes.SET_FIELDS_STATE,
                    payload: (0,lodash/* cloneDeep */.Xh)(fixedFields)
                });
                // Also update sessionStorage with the fixed data
                sessionStorage.setItem(`form-${form.id}`, JSON.stringify(fixedFields));
            }
            const { fieldsWithDataDependencyAndDependentOn  } = getFieldsDataDependency({
                checkChangedFields: false,
                changedFields: {}
            });
            void fetchFieldsDataDependency(fieldsWithDataDependencyAndDependentOn);
            // Find the first step with unfilled required fields
            let targetStep = steps1.length - 1; // Default to last step if all complete
            for(let i = 0; i < steps1.length; i++){
                const requiredFields = steps1[i].fields.filter((field)=>field.isRequired === true && (0,shared_form/* canShowFieldAfterDependency */.bw)(field, sessionStorageFields));
                const allRequiredFieldsFilled = requiredFields.every((field)=>sessionStorageFields?.[field.codeName]?.value && sessionStorageFields?.[field.codeName]?.valid === true);
                if (!allRequiredFieldsFilled) {
                    targetStep = i;
                    break;
                }
            }
            dispatch({
                type: ActionTypes.SET_STEP,
                payload: targetStep
            });
            window.history.pushState(null, "", `#step-${targetStep + 1}`);
            setWindowStep(targetStep + 1);
        }
        toggleShowFormInExitModal(false);
    };
    (0,react.useEffect)(()=>{
        if (synchronizedForms) return; // to avoid unwanted scroll when forms are synchronized and step changes are triggered by peer forms
        const animated = document.querySelector("#stepsWrapper");
        if (animated) {
            animated.addEventListener("transitionend", onTransitionEnd, false);
        }
        return ()=>{
            if (animated) {
                animated.removeEventListener("transitionend", onTransitionEnd, false);
            }
        };
    }, []);
    (0,react.useEffect)(()=>{
        setModalFormFirstRender(false);
        if (currentStep === 0 && showFormModal) {
            toggleFormModal(false);
        } else if (currentStep > 0 && (form.testConfig?.config?.formInsideModal || showInModal)) {
            toggleFormModal(true);
        }
        setTimeout(()=>{
            if (asPath.split("/")[1] !== "blog" && scrollToTop) {
                handleScrollFormTop();
            }
        }, 50);
        if (!isGeneralModalForm && synchronizedForms) {
            sessionStorage.setItem(syncStorageKeys.step, String(currentStep));
        }
        if (isGeneralModalForm && synchronizedForms && !modalFormFirstRender) {
            sessionStorage.setItem(syncStorageKeys.step, String(currentStep));
        }
        if (!form.stepToSendingData) {
            runtimeRef.current.startSendingData = true;
        } else if (steps[currentStep]?.id === form.stepToSendingData) {
            runtimeRef.current.startSendingData = true;
        }
    }, [
        currentStep
    ]);
    const moveBack = async ()=>{
        const { blockBack  } = await nextState();
        if (windowStep && windowStep - 1 < currentStep && !submitted && !otp.isRequired && !blockBack) {
            dispatch({
                type: ActionTypes.SET_STEP,
                payload: windowStep - 1
            });
        }
    };
    (0,react.useEffect)(()=>{
        void moveBack();
    }, [
        windowStep
    ]);
    (0,react.useEffect)(()=>{
        if (currentStep === 1 && apiCallLoading) {
            setApiCallLoading(false);
        }
    }, [
        currentStep,
        apiCallLoading,
        setApiCallLoading
    ]);
    (0,react.useEffect)(()=>{
        const asyncFunction = async ()=>{
            const sessionStorageFields = loadFieldsFromSessionStorage();
            if (initialFieldData) {
                dispatch({
                    type: ActionTypes.SET_GLOBAL_LOADING,
                    payload: true
                });
                void sendDataToServer({
                    submit: false,
                    fetchBuyers: true
                });
            } else {
                dispatch({
                    type: ActionTypes.SET_GLOBAL_LOADING,
                    payload: false
                });
            }
            if (sessionStorageFields) {
                dispatch({
                    type: ActionTypes.SET_FIELDS_STATE,
                    payload: {
                        ...sessionStorageFields
                    }
                });
            }
            const { fieldsWithDataDependencyAndDependentOn  } = getFieldsDataDependency({
                checkChangedFields: false,
                changedFields: {}
            });
            void fetchFieldsDataDependency(fieldsWithDataDependencyAndDependentOn);
            if (!isGeneralModalForm && synchronizedForms) {
                sessionStorage.removeItem(syncStorageKeys.submitted);
                sessionStorage.setItem(syncStorageKeys.pageLoadId, PAGE_LOAD_ID);
            }
            if (isGeneralModalForm && synchronizedForms) {
                const storedPageLoadId = sessionStorage.getItem(syncStorageKeys.pageLoadId);
                if (storedPageLoadId !== PAGE_LOAD_ID) {
                    sessionStorage.removeItem(syncStorageKeys.submitted);
                    sessionStorage.removeItem(syncStorageKeys.step);
                    sessionStorage.setItem(syncStorageKeys.pageLoadId, PAGE_LOAD_ID);
                }
                setTimeout(()=>{
                    // Check if form was already submitted
                    const wasSubmitted = sessionStorage.getItem(syncStorageKeys.submitted) === "true";
                    if (wasSubmitted) {
                        // Form was already submitted, show thank you
                        // First set step to last step (needed for slideFormValue calculation)
                        const lastStepIndex = form.steps.length - 1;
                        dispatch({
                            type: ActionTypes.SET_STEP,
                            payload: lastStepIndex
                        });
                        // Then mark as submitted
                        dispatch({
                            type: ActionTypes.SET_FORM_SUBMITTED,
                            payload: {
                                formId: form.id
                            }
                        });
                        setFormSubmitted(true);
                        return;
                    }
                    // Not submitted - sync to page form's step
                    const storedStepStr = sessionStorage.getItem(syncStorageKeys.step);
                    const storedStep = storedStepStr !== null ? parseInt(storedStepStr, 10) : 0;
                    // Only dispatch if step > 0 (initial state is already 0)
                    if (!isNaN(storedStep) && storedStep > 0) {
                        dispatch({
                            type: ActionTypes.SET_STEP,
                            payload: storedStep
                        });
                    } else {
                        sessionStorage.setItem(syncStorageKeys.step, String(0));
                    }
                }, 0);
            }
            if (isFormInsideOffersModal) {
                const firstStepFields = form.steps[0].fields;
                const answered = firstStepFields.every((field)=>{
                    return !!sessionStorageFields?.[field.codeName]?.value;
                });
                if (answered) {
                    dispatch({
                        type: ActionTypes.SET_STEP,
                        payload: 1
                    });
                }
            }
        };
        void asyncFunction();
        window.history.pushState("", document.title, `#step-1`);
        if (sessionStorage.getItem("skip-to-step")) {
            const step = Number(sessionStorage.getItem("skip-to-step"));
            dispatch({
                type: ActionTypes.SET_STEP,
                payload: step
            });
            sessionStorage.removeItem("skip-to-step");
        }
        if (!isGeneralModalForm) {
            window.addEventListener("popstate", handleWindowBack);
            return ()=>{
                window.removeEventListener("popstate", handleWindowBack);
            };
        }
    }, []);
    (0,react.useEffect)(()=>{
        window.addEventListener("beforeunload", sendDataToServerListener);
        return ()=>{
            window.removeEventListener("beforeunload", sendDataToServerListener);
        };
    }, []);
    const getForcedBuyersIds = ()=>{
        const match = window.location.search?.match(/[?&]buyersIds=([^&]*)/);
        return match ? match[1].split(",").map((item)=>Number(item)) : null;
    };
    (0,react.useEffect)(()=>{
        if (!state.operation?.operationId) return;
        if (state.operation?.loadingBuyers) {
            window.cancelledOperations = window.cancelledOperations ?? [];
            window.cancelledOperations.push(state.operation.operationId);
        }
        if (state.operation.key === "FETCH_BUYERS") {
            fetchFirstRoundBuyers(state.operation.operationId);
        } else if (state.operation.key === "ROUND_ONE") {
            void startFirstRoundBidding({
                operationId: state.operation.operationId,
                firstRoundBuyers: state.operation.firstRoundBuyers,
                secondRoundBuyers: state.operation.secondRoundBuyers,
                isOtpResolved: otp ? otp.isResolved : false
            });
        }
    }, [
        state.operation?.operationId,
        state.operation?.key
    ]);
    (0,react.useEffect)(()=>{
        if (isPiiCompletionForm) {
            dispatch({
                type: ActionTypes.SET_OPERATION,
                payload: {
                    firstRoundBuyers: piiCompletionData?.buyers?.map((buyer)=>({
                            ...buyer,
                            selected: true
                        })) ?? [],
                    secondRoundBuyers: [],
                    loadingBuyers: false,
                    operationId: piiCompletionData?.operationId,
                    key: "FETCH_BUYERS"
                }
            });
        }
    }, []);
    (0,react.useEffect)(()=>{
        dispatch({
            type: ActionTypes.SET_OPERATION,
            payload: {
                firstRoundBuyers: form.defaultBuyers.map((buyer)=>({
                        ...buyer,
                        selected: true
                    })),
                secondRoundBuyers: [],
                hasDomainConsent: true
            }
        });
    }, [
        form.defaultBuyers
    ]);
    return {
        handleFieldChange,
        handleFieldBlur,
        handlePrevStep,
        handleSubmit,
        handleOutsideFormSubmit,
        currentStep,
        steps,
        visitedSteps,
        fieldsData: fieldsState,
        isLoading: loadingForm,
        successMessage,
        jornayaIdElement,
        formError,
        formId: form.id,
        formErrors,
        formErrorsResolved,
        otp: {
            isRequired: otp.isRequired,
            isResolved: otp.isResolved,
            countDownTime: otp.countDown,
            handleSubmit: handleOtpSubmit,
            handleResend: handleOtpResend,
            handleEditPhoneNumber: handleOtpEditPhoneNumber,
            handleScrollFormTop
        },
        formSubmitted: submitted,
        stepStatus: stepStatus,
        checkIfStepHasOneField,
        showExitModal,
        showRegulations,
        showCustomListingModal,
        setLoading,
        setHasRegulations,
        setShowCustomListingModal,
        showPiiCompletionOtherFields,
        setShowPiiCompletionOtherFields,
        showFormModal,
        toggleFormModal,
        listingSlug,
        toggleShowFormInExitModal,
        showFromInExitModal,
        handleCloseFormInsideExitModal,
        dispatch,
        startSecondRoundBidding,
        operation,
        globalLoading,
        apiCallLoading,
        reloadFormData,
        instanceId: instanceIdRef.current,
        isLastStep: currentStep === steps?.length - 1
    };
};

;// CONCATENATED MODULE: ./src/hooks/useForm/index.ts


;// CONCATENATED MODULE: ./src/hooks/useScrollToTop.ts
function useScrollToTop({ enabled =true , top =22 , ...scrollOptions } = {}) {
    const scrollToTop = ()=>{
        if (enabled) {
            window.scrollTo({
                top,
                behavior: "smooth",
                ...scrollOptions
            });
        }
    };
    return scrollToTop;
}

// EXTERNAL MODULE: ./src/hooks/useBingEnhancedConversion.tsx
var useBingEnhancedConversion = __webpack_require__(28185);
// EXTERNAL MODULE: ./src/hooks/useBodyScrollLock.tsx
var useBodyScrollLock = __webpack_require__(18981);
// EXTERNAL MODULE: ./src/hooks/useContactUsForm.tsx + 1 modules
var useContactUsForm = __webpack_require__(77720);
;// CONCATENATED MODULE: ./src/hooks/useDynamicTab.tsx

const useDynamicTab = ({ title , favicon , changeEvery , event ="visibilitychange" , extraConditions =()=>true  })=>{
    const faviconElements = useRef(null);
    const oldFavicon = useRef(null);
    const oldTitle = useRef(null);
    const getFaviconElements = ()=>document.getElementsByClassName("favicon");
    const events = {
        timeout: ()=>{
            if (extraConditions()) {
                window.setInterval(()=>{
                    if (faviconElements.current && faviconElements.current.length) {
                        handleChangeFavicon(favicon);
                        handleChangeTitle(title);
                    } else {
                        handleChangeFavicon(oldFavicon.current);
                        handleChangeTitle(oldTitle.current);
                    }
                }, changeEvery ?? 1000);
            }
        },
        visibilitychange: ()=>{
            if (extraConditions()) {
                if (faviconElements.current && faviconElements.current.length) {
                    if (document.visibilityState === "hidden") {
                        handleChangeFavicon(favicon);
                        handleChangeTitle(title);
                    } else {
                        handleChangeFavicon(oldFavicon.current);
                        handleChangeTitle(oldTitle.current);
                    }
                }
            }
        },
        hiddenTimeout: ()=>{
            if (extraConditions()) {
                window.setInterval(()=>{
                    // toggle title and favicon if hidden
                    if (document.visibilityState === "hidden") {
                        // toggle favicon
                        if (faviconElements.current) {
                            [
                                ...faviconElements.current
                            ].forEach((item)=>{
                                if (item.href === oldFavicon.current) handleChangeFavicon(favicon);
                                else handleChangeFavicon(oldFavicon.current);
                            });
                        }
                        // toggle title
                        if (document.title === oldTitle.current) handleChangeTitle(title);
                        else handleChangeTitle(oldTitle.current);
                    } else {
                        // reset title and favicon if shown
                        handleChangeFavicon(oldFavicon.current);
                        handleChangeTitle(oldTitle.current);
                    }
                }, changeEvery ?? 1000);
            }
        }
    };
    const handleChangeFavicon = (currentFavicon)=>{
        if (faviconElements.current && faviconElements.current.length && currentFavicon) {
            [
                ...faviconElements.current
            ].forEach((item)=>{
                item.href = currentFavicon;
            });
        }
    };
    const handleChangeTitle = (currentTitle)=>{
        if (currentTitle) document.title = currentTitle;
    };
    useEffect(()=>{
        faviconElements.current = getFaviconElements();
        oldFavicon.current = faviconElements.current[0].href;
        oldTitle.current = document.title;
        if (document.visibilityState === "hidden") events[event]();
        if (event === "visibilitychange" || event === "hiddenTimeout") {
            window.addEventListener("visibilitychange", ()=>events[event]());
        } else {
            events[event]();
        }
        return ()=>{
            if (event === "visibilitychange" || event === "hiddenTimeout") window.removeEventListener("visibilitychange", ()=>events[event]());
        };
    }, []);
};

// EXTERNAL MODULE: ./src/hooks/useTimeOnSite.tsx
var useTimeOnSite = __webpack_require__(55135);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx
var useTranslation = __webpack_require__(70211);
;// CONCATENATED MODULE: ./src/hooks/index.ts













;// CONCATENATED MODULE: ./src/components/shared/form/consentOnlyForm/FormSkeleton.tsx


const FormSkeleton = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-8 w-[300px] md:w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "skeleton skeleton-text !w-[200px] !mb-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "skeleton skeleton-text"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "skeleton skeleton-text"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "skeleton skeleton-text"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "skeleton skeleton-text"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-start gap-2 justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col !w-[250px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "skeleton skeleton-text !w-[50px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "skeleton skeleton-input"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col !w-[250px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "skeleton skeleton-text !w-[50px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "skeleton skeleton-input"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "skeleton skeleton-button"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "skeleton skeleton-text"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "skeleton skeleton-text"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "skeleton skeleton-text"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "skeleton skeleton-text"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "skeleton skeleton-text"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "skeleton skeleton-text"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var consentOnlyForm_FormSkeleton = (FormSkeleton);

// EXTERNAL MODULE: ./src/components/shared/form/fieldWrapper/index.tsx
var fieldWrapper = __webpack_require__(62085);
// EXTERNAL MODULE: ./src/components/shared/loader/index.tsx
var loader = __webpack_require__(95301);
// EXTERNAL MODULE: ./src/components/svg/arrowRightIcon.tsx
var arrowRightIcon = __webpack_require__(78963);
// EXTERNAL MODULE: ./src/components/svg/warningAlertIcon.tsx
var warningAlertIcon = __webpack_require__(88446);
// EXTERNAL MODULE: ./src/components/shared/form/formNew/components/FormField.tsx + 1 modules
var FormField = __webpack_require__(34024);
// EXTERNAL MODULE: ./src/components/shared/form/styles.module.scss
var styles_module = __webpack_require__(67408);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/shared/form/formNew/components/FormErrorsStep.tsx







function FormErrorsStep({ formErrors , formErrorsResolved , goToThankYouPage , otp , domain , domainNameTranslation , invalidFields , classes , isExpandable , getExpandableFields , stepStatus , isSecondServiceForm , formProps , handleFieldBlur , handleFieldChange , fieldsData , finalForm , searchableMultiSelect , singleQuestion , colors , isLastStep , operation , isLoading , formSubmitted , currentStep  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).step,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["extra-step-inner"],
                children: (formErrors || formErrorsResolved && goToThankYouPage && !otp?.isRequired) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: `${(styles_module_default()).warningMessage} rounded-sm`,
                            id: "all-errors",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                    className: `text-base sm:text-lg flex items-start sm:items-center justify-start sm:justify-center`,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "px-1 pt-1 sm:pt-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningAlertIcon/* default */.Z, {})
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: domain?.translations?.[`${domainNameTranslation}_SubmissionHasFewErrors`] ?? "Your Submission Has a Few Errors"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: `${(styles_module_default()).description}  text-xs sm:text-base `,
                                    children: domain?.translations?.[`${domainNameTranslation}_PleaseCorrectTheFollowingFields`] ?? `You are
                                                                    almost done!
                                                                    Please
                                                                    correct the
                                                                    following
                                                                    fields so we
                                                                    can process
                                                                    your
                                                                    request:`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: `${(styles_module_default()).fields} ${classes?.fieldsWrapperClassName ?? ""}`,
                            children: [
                                invalidFields.map((field)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* FormField */.W, {
                                        stepStatus: stepStatus,
                                        field: field,
                                        fields: isExpandable(field) ? getExpandableFields(field) : [],
                                        asTitle: false,
                                        isSecondServiceForm: isSecondServiceForm ?? false,
                                        ...formProps,
                                        handleFieldBlur: handleFieldBlur,
                                        handleFieldChange: handleFieldChange,
                                        fieldsData: fieldsData,
                                        form: finalForm,
                                        searchableMultiSelect: searchableMultiSelect,
                                        singleQuestion: singleQuestion
                                    }, field.codeName)),
                                formErrorsResolved && goToThankYouPage && formErrors === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (styles_module_default())["line-1"]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (styles_module_default())["line-2"]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (styles_module_default())["line-2"]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (styles_module_default())["line-3"]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            style: {
                                backgroundColor: colors.primaryColor
                            },
                            className: `${(styles_module_default())["submit-button"]} ${classes?.formButtonClassName ?? ""} ${isLastStep ? classes?.formSubmitButtonClassName ?? "" : ""}`,
                            type: "submit",
                            children: operation?.loadingBuyers || isLoading || isLastStep && formSubmitted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                                size: 30
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: domain?.translations?.[`${domainNameTranslation}_SubmitButtonText`] ?? "Submit"
                                    }),
                                    currentStep === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: `${(styles_module_default()).arrow}`,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrowRightIcon/* default */.Z, {})
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/shared/form/OtpForm/index.tsx + 1 modules
var OtpForm = __webpack_require__(7004);
;// CONCATENATED MODULE: ./src/components/shared/form/formNew/components/OtpStep.tsx




function OtpStep({ showOtp , fieldsData , colors , classes , isLoading , operation , otp , handleFieldChange  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).step,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["extra-step-inner"],
                children: showOtp && // [@todo handle logic to be comptable with old form since otp and operation logic does not exist in old form]
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpForm/* default */.Z, {
                    phoneNumber: fieldsData?.phoneNumber.value,
                    colors: colors,
                    classes: classes,
                    isLoading: !!(isLoading || operation?.loadingBuyers),
                    otp: otp,
                    handleFieldChange: handleFieldChange
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/shared/form/fields/checkbox.tsx
var fields_checkbox = __webpack_require__(87217);
// EXTERNAL MODULE: ./src/components/shared/form/buyersList/styles.module.scss
var buyersList_styles_module = __webpack_require__(80121);
var buyersList_styles_module_default = /*#__PURE__*/__webpack_require__.n(buyersList_styles_module);
;// CONCATENATED MODULE: ./src/components/shared/form/buyersList/index.tsx








const BuyersList = ({ dispatch , operation , isLoading , buttonText , buttonClassName , handleSubmit  })=>{
    const { domain  } = (0,useDomainContext/* useDomainContext */.w)();
    const { 0: hasDomainConsent , 1: setHasDomainConsent  } = (0,react.useState)(true);
    const field = {
        label: "Buyers List",
        codeName: "buyersList",
        defaultValues: {
            options: [
                ...operation?.secondRoundBuyers?.map((buyer)=>({
                        id: parseInt(buyer.buyerId),
                        icon: {
                            fullPath: buyer.logo
                        },
                        label: buyer.displayName ?? buyer.buyerName,
                        value: String(buyer.buyerId)
                    })) ?? [], 
            ]
        },
        defaultValue: null,
        dataDependency: null,
        fieldType: "checkbox",
        placeholder: null,
        isRequired: true,
        pattern: null,
        errorMessage: null,
        minValue: null,
        maxValue: null,
        note: null,
        autocomplete: null,
        title: null,
        mask: null,
        meta: null,
        niceName: null,
        dependency: null,
        validationType: "zipCode",
        conditionalLogic: null
    };
    const domainBuyerField = {
        label: domain.niceName || domain.name,
        codeName: "hasDomainConsent",
        defaultValues: {
            options: [
                {
                    label: domain.niceName ?? domain.name,
                    value: "domain",
                    id: 0,
                    icon: {
                        fullPath: domain.logo?.fullPath ?? ""
                    }
                }, 
            ]
        },
        defaultValue: null,
        dataDependency: null,
        fieldType: "checkbox",
        placeholder: null,
        isRequired: true,
        pattern: null,
        errorMessage: null,
        minValue: null,
        maxValue: null,
        note: null,
        autocomplete: null,
        title: null,
        mask: null,
        meta: null,
        niceName: null,
        dependency: null,
        validationType: "zipCode",
        conditionalLogic: null
    };
    const selectAllField = {
        label: "Select All",
        codeName: "selectAll",
        defaultValues: {
            options: [
                {
                    id: 1,
                    label: "Select All - Maximize your choices!",
                    value: "selectAll",
                    icon: null
                }, 
            ]
        },
        defaultValue: null,
        dataDependency: null,
        fieldType: "checkbox",
        placeholder: null,
        isRequired: true,
        pattern: null,
        errorMessage: null,
        minValue: null,
        maxValue: null,
        note: null,
        autocomplete: null,
        title: null,
        mask: null,
        meta: null,
        niceName: null,
        dependency: null,
        validationType: "zipCode",
        conditionalLogic: null
    };
    const allBuyersSelected = (0,react.useMemo)(()=>{
        return operation?.secondRoundBuyers?.every((buyer)=>buyer.selected) && (operation?.secondRoundBuyers?.length ?? 0) > 0;
    }, [
        operation?.secondRoundBuyers
    ]);
    const handleSelectAll = ()=>{
        if (allBuyersSelected) {
            dispatch({
                type: ActionTypes.SET_OPERATION,
                payload: {
                    secondRoundBuyers: operation?.secondRoundBuyers?.map((buyer)=>({
                            ...buyer,
                            selected: false
                        }))
                }
            });
            if (!operation?.hasDomainConsent) {
                setHasDomainConsent(false);
            }
        } else {
            dispatch({
                type: ActionTypes.SET_OPERATION,
                payload: {
                    secondRoundBuyers: operation?.secondRoundBuyers?.map((buyer)=>({
                            ...buyer,
                            selected: true
                        }))
                }
            });
            if (!operation?.hasDomainConsent) {
                setHasDomainConsent(true);
            }
        }
    };
    const { category  } = (0,useDomainContext/* useDomainContext */.w)();
    const handleFieldChange = (val)=>{
        dispatch({
            type: ActionTypes.SET_OPERATION,
            payload: {
                secondRoundBuyers: operation?.secondRoundBuyers?.map((buyer)=>({
                        ...buyer,
                        selected: val.includes(String(buyer.buyerId))
                    }))
            }
        });
    };
    const handleDomainFieldChange = (val)=>{
        setHasDomainConsent(!!val);
    };
    const isNoble = operation?.secondRoundBuyers?.length === 1 && operation?.secondRoundBuyers[0].isNoble;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                className: "text-2xl font-bold mb-4 " + (buyersList_styles_module_default()).title,
                children: [
                    "Compare ",
                    category?.label ?? category?.name,
                    " Providers for Tailored Deals"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "font-light mb-4 " + (buyersList_styles_module_default()).description,
                children: "Choose Providers to Receive Personalized Quotes Tailored to Your Needs. Selecting All Providers Unlocks More Options and Special Offers Just For You!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-10",
                children: [
                    (operation?.secondRoundBuyers?.length ?? 0) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-end my-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fields_checkbox/* default */.Z, {
                            onChange: ()=>handleSelectAll(),
                            field: selectAllField,
                            value: allBuyersSelected ? "selectAll" : "",
                            className: (buyersList_styles_module_default())["select-all-checkbox-field"],
                            primaryColor: "black",
                            ignoreOptionIcons: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fields_checkbox/* default */.Z, {
                        onChange: (val)=>handleFieldChange(val),
                        field: field,
                        value: operation?.secondRoundBuyers?.filter((buyer)=>buyer.selected)?.map((buyer)=>buyer.buyerId).join(",") ?? "",
                        className: (buyersList_styles_module_default()).checkbox + " " + (buyersList_styles_module_default())["checkbox-field"],
                        primaryColor: "black",
                        iconLocation: "end",
                        iconClassName: (buyersList_styles_module_default())["checkbox-icon"],
                        addConsentTags: true
                    }),
                    !operation?.hasDomainConsent && !isNoble && /*#__PURE__*/ (0,jsx_runtime.jsx)(fields_checkbox/* default */.Z, {
                        onChange: (val)=>handleDomainFieldChange(val),
                        field: domainBuyerField,
                        value: hasDomainConsent ? "domain" : "",
                        className: (buyersList_styles_module_default()).checkbox + " " + (buyersList_styles_module_default())["checkbox-field"],
                        primaryColor: "black",
                        iconLocation: "end",
                        iconClassName: (buyersList_styles_module_default())["checkbox-icon"],
                        addConsentTags: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: `${(styles_module_default())["submit-button"]} ${buttonClassName ?? ""} mt-20`,
                disabled: operation?.secondRoundBuyers?.every((buyer)=>!buyer.selected) || isLoading,
                type: "button",
                onClick: async ()=>{
                    const tcpaText = document.querySelector('[data-tf-element-role="consent-language"]');
                    await handleSubmit({
                        selectedBuyers: operation?.secondRoundBuyers?.filter((buyer)=>buyer.selected) ?? [],
                        consentLanguage: tcpaText?.innerHTML ?? "",
                        hasDomainConsent: !!hasDomainConsent
                    });
                },
                "data-tf-element-role": "submit",
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                    size: 30
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: buttonText
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/components/BuyersListStep.tsx




function BuyersListStep({ operation , dispatch , submitButtonText , isLoading , startSecondRoundBidding , classes  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).step,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["extra-step-inner"],
                children: operation?.key === "ROUND_TWO" && /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyersList, {
                    dispatch: dispatch,
                    operation: operation,
                    buttonText: submitButtonText,
                    isLoading: isLoading,
                    handleSubmit: startSecondRoundBidding,
                    buttonClassName: classes?.formButtonClassName
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/shared/compactOffer/index.tsx
var compactOffer = __webpack_require__(34532);
// EXTERNAL MODULE: ./src/components/shared/thankyou/index.tsx + 9 modules
var thankyou = __webpack_require__(15818);
;// CONCATENATED MODULE: ./src/components/shared/form/formNew/components/InlineThankYouStep.tsx






function InlineThankYouStep({ formSubmitted , goToThankYouPage , goToListPage , compactOfferBlock , hideOffers , customThankYouStep , classes , form  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).step,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["extra-step-inner"],
                children: formSubmitted && !goToThankYouPage && !goToListPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        compactOfferBlock && !hideOffers && /*#__PURE__*/ (0,jsx_runtime.jsx)(compactOffer/* default */.Z, {
                            zone: config/* affiliateOfferZones.THANK_YOU */.ZR.THANK_YOU,
                            classes: {},
                            showAllOffers: true
                        }),
                        customThankYouStep ?? /*#__PURE__*/ (0,jsx_runtime.jsx)(thankyou/* default */.Z, {
                            inForm: true,
                            className: classes?.innerThankYouClassName,
                            form: form
                        })
                    ]
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/components/FormExtraSteps.tsx






/**
 * Renders the four "extra" virtual steps that live inside the steps wrapper
 * AFTER the real form steps: errors summary, OTP prompt, round-two buyers list,
 * and the inline thank-you screen. Each one renders a positioned slot and only
 * shows its content when its own condition matches.
 */ function FormExtraSteps(props) {
    const { formErrors , formErrorsResolved , invalidFields , isExpandable , getExpandableFields , domain , domainNameTranslation , isLastStep , currentStep , showOtp , otp , dispatch , submitButtonText , startSecondRoundBidding , formSubmitted , goToThankYouPage , goToListPage , compactOfferBlock , hideOffers , customThankYouStep , fieldsData , finalForm , handleFieldBlur , handleFieldChange , stepStatus , isSecondServiceForm , formProps , classes , colors , isLoading , operation , searchableMultiSelect , singleQuestion ,  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormErrorsStep, {
                formErrors: formErrors,
                formErrorsResolved: formErrorsResolved,
                goToThankYouPage: goToThankYouPage,
                otp: otp,
                domain: domain,
                domainNameTranslation: domainNameTranslation,
                invalidFields: invalidFields,
                classes: classes,
                isExpandable: isExpandable,
                getExpandableFields: getExpandableFields,
                stepStatus: stepStatus,
                isSecondServiceForm: isSecondServiceForm,
                formProps: formProps,
                handleFieldBlur: handleFieldBlur,
                handleFieldChange: handleFieldChange,
                fieldsData: fieldsData,
                finalForm: finalForm,
                searchableMultiSelect: searchableMultiSelect,
                singleQuestion: singleQuestion,
                colors: colors,
                isLastStep: isLastStep,
                operation: operation,
                isLoading: isLoading,
                formSubmitted: formSubmitted,
                currentStep: currentStep
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpStep, {
                showOtp: showOtp,
                fieldsData: fieldsData,
                colors: colors,
                classes: classes,
                isLoading: isLoading,
                operation: operation,
                otp: otp,
                handleFieldChange: handleFieldChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyersListStep, {
                operation: operation,
                dispatch: dispatch,
                submitButtonText: submitButtonText,
                isLoading: isLoading,
                startSecondRoundBidding: startSecondRoundBidding,
                classes: classes
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineThankYouStep, {
                formSubmitted: formSubmitted,
                goToThankYouPage: goToThankYouPage,
                goToListPage: goToListPage,
                compactOfferBlock: compactOfferBlock,
                hideOffers: hideOffers,
                customThankYouStep: customThankYouStep,
                classes: classes,
                form: finalForm
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/components/ExitOffersModal.tsx





function ExitOffersModal({ offersPopupActive , buyerPhoneNumber , hidePageOffers , showRegulations , setClicksOffers , setHasRegulations , showCustomListingModal , setPopupOffers , setShowCustomListingModal , modalSize , modalWidth , modalVariables , modalOffersContent , modalOfferClicksContent , setOffersPopupActive  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal["default"], {
        active: offersPopupActive && (!!buyerPhoneNumber || !hidePageOffers),
        onClose: ()=>{
            setOffersPopupActive(false);
            if (showRegulations) {
                setClicksOffers([]);
                setHasRegulations(false);
            }
            if (showCustomListingModal) {
                setPopupOffers([]);
                setShowCustomListingModal(false);
            }
        },
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(closeIcon["default"], {}),
        width: modalSize ?? modalWidth,
        modalClassName: (styles_module_default())["form-offers-popup"],
        pageBuilderVariables: modalVariables,
        children: [
            modalOffersContent,
            modalOfferClicksContent
        ]
    });
}

// EXTERNAL MODULE: ./src/components/shared/formOfferModal/FormOfferModal.tsx
var FormOfferModal = __webpack_require__(13677);
;// CONCATENATED MODULE: ./src/components/shared/form/formNew/components/FormInOfferModal.tsx






function FormInOfferModal({ showFromInExitModal , handleCloseFormInsideExitModal , modalVariables , formProps  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal["default"], {
        active: showFromInExitModal,
        onClose: ()=>{
            handleCloseFormInsideExitModal();
        },
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(closeIcon["default"], {}),
        width: 500,
        modalClassName: (styles_module_default())["form-inside-offers-container"],
        overflow: "visible",
        closeButtonClassName: (styles_module_default())["form-inside-offers-close-button"],
        pageBuilderVariables: modalVariables,
        children: showFromInExitModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormOfferModal/* default */.Z, {
            ...formProps,
            onInlineThankYouShown: ()=>handleCloseFormInsideExitModal({
                    wasFormSubmitted: true
                })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/components/InlineThankYouShortcut.tsx




function InlineThankYouShortcut({ formClassName , compactOfferBlock , hideOffers , customThankYouStep , innerThankYouClassName  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `${formClassName ?? ""} mx-auto`,
        children: [
            compactOfferBlock && !hideOffers && /*#__PURE__*/ (0,jsx_runtime.jsx)(compactOffer/* default */.Z, {
                zone: config/* affiliateOfferZones.THANK_YOU */.ZR.THANK_YOU,
                classes: {},
                showAllOffers: true
            }),
            customThankYouStep ?? /*#__PURE__*/ (0,jsx_runtime.jsx)(thankyou/* default */.Z, {
                inForm: true,
                className: innerThankYouClassName ?? ""
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/components/PreFirstStepTitle.tsx



function PreFirstStepTitle({ title , region , city  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).preStepTitle,
        children: (0,sharedUtils/* replacePlaceholders */.wT)(title, {
            region,
            city
        })
    });
}

// EXTERNAL MODULE: ./src/hooks/useWindowSize.tsx
var useWindowSize = __webpack_require__(91173);
// EXTERNAL MODULE: ./src/api/trackingTime.ts
var trackingTime = __webpack_require__(82442);
// EXTERNAL MODULE: ./src/components/shared/s3Icon/index.tsx
var s3Icon = __webpack_require__(65984);
// EXTERNAL MODULE: ./node_modules/rc-tooltip/es/index.js + 84 modules
var es = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/components/svg/tooltipIcon.tsx
var tooltipIcon = __webpack_require__(88736);
// EXTERNAL MODULE: ./src/components/shared/form/piiCompletion/MissingFieldsHeadline.tsx
var MissingFieldsHeadline = __webpack_require__(6515);
// EXTERNAL MODULE: ./src/components/shared/form/TCPA/smsTCPA.tsx
var smsTCPA = __webpack_require__(89036);
// EXTERNAL MODULE: ./src/components/shared/form/piiCompletion/OtherFieldsHeadline.tsx
var OtherFieldsHeadline = __webpack_require__(50752);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/shared/form/ApiLoadingLabels.tsx
var ApiLoadingLabels = __webpack_require__(98778);
;// CONCATENATED MODULE: ./src/components/shared/form/formNew/components/FormStep.tsx
// needs refactor












const AnswerSummary = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69531).then(__webpack_require__.bind(__webpack_require__, 69531)));









const FormStep = (props)=>{
    const { setSkipToThankYou  } = (0,useFormContext/* useFormContext */.G)();
    const { width  } = (0,useWindowSize/* default */.Z)();
    const { 0: isSubmitStepButtonBlocked , 1: setSubmitStepButtonBlocked  } = (0,react.useState)(true);
    const { step , index , colors , classes , handleFieldBlur , handleFieldChange , currentStep , isLoading , formError , fieldsData , form , customMainTitle , steps , visitedSteps , hideStepTitle , hideStepDescription , forceStepTitle , checkIfStepHasOneField , formSubmitted , formId , overrideStepTitle , overrideStepDescription , stepStatus , formErrors , isSecondServiceForm , formButtonClassName , textBlocks , updateSecondServices , tags , isPiiCompletionForm , showPiiCompletionOtherFields , setShowPiiCompletionOtherFields , searchableMultiSelect , showFormModal , answerSummaryConfigs , isFormInsideOffersModal , operation , ignoreTextBlocks , tcpa , globalLoading , singleQuestion , mergeInputWithSubmitOnFirstStep , apiCallLoading , disableAutoFocus ,  } = props;
    const { formattedTitle , visitDetails , category , piiCompletionData , domain , buyerPhoneNumber , locale ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const { 0: buttonDisabled , 1: setButtonDisabled  } = (0,react.useState)({
        getQuote: false,
        noThankYou: false
    });
    const isSecondServiceSelected = (0,react.useMemo)(()=>{
        if (tags) {
            const tagsKeys = Object.keys(tags);
            let tagsSelected = false;
            tagsKeys.forEach((tag)=>{
                tagsSelected = tagsSelected || tags[tag].active;
            });
            return tagsSelected;
        }
        return false;
    }, [
        tags
    ]);
    const isLastStep = (0,react.useMemo)(()=>{
        return currentStep === steps?.length - 1;
    }, [
        currentStep,
        steps
    ]);
    const stepTitle = (0,sharedUtils/* replacePlaceholders */.wT)(step.title, {
        region: visitDetails.region,
        city: visitDetails?.city,
        category: category?.label ?? category?.name
    });
    (0,react.useEffect)(()=>{
        setSubmitStepButtonBlocked(isSecondServiceForm && !isSecondServiceSelected || buttonDisabled.getQuote || isLoading);
    }, [
        isSecondServiceForm,
        isSecondServiceSelected,
        buttonDisabled,
        isLoading, 
    ]);
    //@todo check usage since it does not exist in old form
    const buttonIsLoading = (0,react.useMemo)(()=>{
        return isLoading || isLastStep && formSubmitted || isLastStep && operation?.loadingBuyers;
    }, [
        isLoading,
        isLastStep,
        formSubmitted,
        operation?.loadingBuyers
    ]);
    // const showLogos = useMemo(() => {
    //     return !!operation?.firstRoundBuyers?.length && isLastStep;
    // }, [isLastStep, operation?.firstRoundBuyers]);
    const secondStepButtonText = textBlocks?.find((item)=>item.position === "form-inside-exit-modal-submit-button-text-second-step");
    const checkIfShowNextButton = ()=>{
        if (checkIfStepHasOneField(fieldsData) || form.testConfig?.config?.mergeFirstInput && !showFormModal || mergeInputWithSubmitOnFirstStep && currentStep === 0) {
            return null;
        }
        const firstStepButtonText = textBlocks?.find((item)=>item.position === "form-inside-exit-modal-submit-button-text");
        const buttonText = currentStep === 0 ? firstStepButtonText : secondStepButtonText;
        return(//@todo handle logic related to operations
        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            style: {
                backgroundColor: colors.primaryColor || "var(--global-form-buttons-background-color)"
            },
            className: `${(styles_module_default())["submit-button"]}  ${classes?.formButtonClassName ?? ""} ${isLastStep ? classes?.formSubmitButtonClassName ?? "" : ""} ${isLastStep ? "final-step" : ""} ${currentStep === 0 && isSubmitStepButtonBlocked // used for the first step to disable the submit button but without showing it.
             ? `${(styles_module_default())["disable-without-opacity"]}` // because marketing team is claiming that the disabled button lowers the conversion!!
             : ""}`,
            "data-tf-element-role": isLastStep ? "submit" : undefined,
            type: "submit",
            id: "frmMainBtn",
            disabled: isSubmitStepButtonBlocked || buttonIsLoading || !!operation?.firstRoundBuyers?.length && !operation?.firstRoundBuyers?.filter((buyer)=>buyer.selected)?.length && isLastStep,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: !isSecondServiceForm ? (styles_module_default()).progressBtn : ""
                }),
                buttonIsLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                            size: 30
                        }),
                        " ",
                        isLastStep ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (styles_module_default()).submittingLabel,
                            children: operation?.loadingBuyers ? category?.config?.submittingButtonFormFinding?.[locale] ?? "Finding the Best Match" : category?.config?.submittingButtonFormSubmitting?.[locale] ?? "Submitting"
                        }) : ""
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        isFormInsideOffersModal && buttonText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: buttonText.text
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: step.buttonText ?? "Next"
                        }),
                        currentStep === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: `${(styles_module_default()).arrow}`,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrowRightIcon/* default */.Z, {})
                        })
                    ]
                })
            ]
        }));
    };
    const showMergedButton = ()=>{
        if (form.testConfig?.config?.mergeFirstInput && !showFormModal) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                style: {
                    backgroundColor: colors.primaryColor || "var(--global-form-buttons-background-color)"
                },
                className: `${(styles_module_default())["first-step-button-merged"]}  ${classes?.formButtonClassName ?? ""}`,
                type: "submit",
                id: "frmMainBtn",
                disabled: isSubmitStepButtonBlocked,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "progressBtn"
                    }),
                    isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                                size: 30
                            }),
                            " ",
                            isLastStep ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (styles_module_default()).submittingLabel,
                                children: "Submitting"
                            }) : ""
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: step.buttonText ?? "Next"
                            }),
                            currentStep === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: `${(styles_module_default()).arrow}`,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrowRightIcon/* default */.Z, {})
                            })
                        ]
                    })
                ]
            });
        }
    };
    // [@todo check since it does not exist in old form]
    const getDescription = ()=>{
        if (buyerPhoneNumber && index === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: category?.config?.buyerPhoneNumberDescription || "Talk to a nearby restoration pro now and stop the damage before it spreads."
            });
        }
        const textBlockDescription = !ignoreTextBlocks && index === 0 && textBlocks && textBlocks.length && (textBlocks.find((item)=>item.position === "form_description")?.text);
        const description = textBlockDescription || overrideStepDescription || step.description;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: (0,decodeFieldsFromText/* decodeFieldsFromText */.l)(description, fieldsData)
            }
        });
    };
    const getTitleSource = ()=>{
        if (formattedTitle && formattedTitle.length) {
            return "url";
        } else if (textBlocks && textBlocks.length && textBlocks.find((item)=>item.position === "form_title" || item.position === "form-inside-exit-modal-first-step-title" || item.position === "form-inside-exit-modal-second-step-title")) {
            return "text_block";
        } else if (customMainTitle || overrideStepTitle) {
            return "code";
        } else {
            return "form";
        }
    };
    const title = (0,react.useMemo)(()=>{
        return (0,sharedUtils/* getTitle */.YQ)({
            formattedTitle,
            textBlocks,
            category,
            visitDetails,
            ignoreTextBlocks,
            isFormInsideOffersModal,
            overrideStepTitle,
            forceStepTitle,
            stepTitle,
            customMainTitle
        });
    }, [
        formattedTitle,
        textBlocks,
        category,
        visitDetails,
        ignoreTextBlocks,
        isFormInsideOffersModal,
        overrideStepTitle,
        forceStepTitle,
        stepTitle,
        customMainTitle, 
    ]);
    (0,react.useEffect)(()=>{
        if (index === 0 && !isSecondServiceForm && !isPiiCompletionForm) {
            void (0,trackingTime/* sendTrackingTime */.X)({
                event: "formTitle",
                eventValue: title ? title : Array.isArray(form.domainFormId) && form.domainFormId.length > 1 ? "Multiple Forms" : "Unknown",
                eventCategory: "meta"
            });
            void (0,trackingTime/* sendTrackingTime */.X)({
                event: "formTitleSource",
                eventValue: getTitleSource(),
                eventCategory: "meta"
            });
            if (steps[0]?.fields[0]?.fieldType === "hidden") {
                void (0,trackingTime/* sendTrackingTime */.X)({
                    event: "hiddenFormField",
                    eventValue: getTitleSource(),
                    eventCategory: "meta"
                });
            }
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (index === 0 && window.innerWidth > 767 && !singleQuestion && !disableAutoFocus) {
            const selector = "input[type=text], input[type=tel], input[type=number], input[type=date],input[type=email], textarea";
            if (document.getElementById(`form_${form.id}`)?.querySelectorAll(selector).length) {
                setTimeout(()=>{
                    const element = document.getElementById(`form_${form.id}`)?.querySelectorAll(selector);
                    if (element && element.length) {
                        element[0].focus();
                    }
                }, 500);
            }
        }
    }, [
        index
    ]);
    // excludedFields = list of fields that should not displayed in the form step
    const excludedFields = (0,react.useMemo)(()=>{
        const excludedFieldsArray = [];
        step.fields.forEach((field)=>{
            const metaKeys = field.meta ? Object.keys(field.meta) : [];
            // check if field has expandable meta key
            const isExpandable = Array.isArray(metaKeys) && metaKeys.length ? metaKeys[0] === "expandable" ? true : false : false;
            if (isExpandable) {
                const expandableFields = JSON.parse(field.meta?.expandable);
                const fieldsCodeName = Object.keys(expandableFields);
                for(let i = 0; i < fieldsCodeName.length; i++){
                    if (expandableFields[fieldsCodeName[i]].ignoreField === "true") {
                        excludedFieldsArray.push(fieldsCodeName[i]);
                    }
                }
            }
        });
        return excludedFieldsArray;
    }, [
        step.fields
    ]);
    const fieldsList = [];
    const sharedFieldsList = [];
    const fieldsListLength = step.fields.length;
    for(let i = 0; i < fieldsListLength; i++){
        if (!excludedFields.includes(step.fields[i].codeName)) {
            if (step.fields[i].tag === "common" || step.fields[i].tag === "pii") {
                if (config/* SHARED_FIELDS_CODENAME.includes */.gA.includes(step.fields[i].codeName)) {
                    sharedFieldsList.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: config/* COMMON_FIELDS_CODENAME.includes */.iF.includes(step.fields[i].codeName) ? {
                            width: "100%"
                        } : {},
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* FormField */.W, {
                            field: step.fields[i],
                            fields: step.fields,
                            asTitle: step.fields.length === 1 && !step.title,
                            ...props,
                            handleFieldBlur: handleFieldBlur,
                            handleFieldChange: handleFieldChange,
                            fieldsData: fieldsData,
                            visitedSteps: visitedSteps,
                            currentStep: currentStep,
                            colors: colors,
                            isLoading: isLoading,
                            isLastStep: isLastStep,
                            formSubmitted: formSubmitted,
                            stepStatus: stepStatus,
                            formId: formId,
                            form: form,
                            isSecondServiceForm: isSecondServiceForm,
                            searchableMultiSelect: searchableMultiSelect,
                            apiCallLoading: apiCallLoading
                        }, i)
                    }, i));
                } else {
                    sharedFieldsList.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* FormField */.W, {
                            field: step.fields[i],
                            fields: step.fields,
                            asTitle: step.fields.length === 1 && !step.title,
                            ...props,
                            handleFieldBlur: handleFieldBlur,
                            handleFieldChange: handleFieldChange,
                            fieldsData: fieldsData,
                            visitedSteps: visitedSteps,
                            currentStep: currentStep,
                            colors: colors,
                            isLoading: isLoading,
                            isLastStep: isLastStep,
                            formSubmitted: formSubmitted,
                            stepStatus: stepStatus,
                            formId: formId,
                            form: form,
                            isSecondServiceForm: isSecondServiceForm,
                            searchableMultiSelect: searchableMultiSelect,
                            apiCallLoading: apiCallLoading
                        }, i)
                    }, i));
                }
            } else {
                if (config/* SHARED_FIELDS_CODENAME.includes */.gA.includes(step.fields[i].codeName) && !isPiiCompletionForm && !props.goToListPage) {
                    sharedFieldsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: config/* COMMON_FIELDS_CODENAME.includes */.iF.includes(step.fields[i].codeName) ? {
                            width: "100%",
                            ...form.testConfig?.config?.mergeFirstInput ? {
                                display: "flex",
                                alignItems: "center",
                                ...width <= 767 ? {
                                    flexDirection: "column"
                                } : {}
                            } : {}
                        } : {},
                        className: step.fields[i].fieldType === "hidden" ? "hidden" : "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* FormField */.W, {
                                field: step.fields[i],
                                fields: step.fields,
                                asTitle: step.fields.length === 1 && !step.title,
                                ...props,
                                handleFieldBlur: handleFieldBlur,
                                handleFieldChange: handleFieldChange,
                                fieldsData: fieldsData,
                                visitedSteps: visitedSteps,
                                currentStep: currentStep,
                                colors: colors,
                                isLoading: isLoading,
                                isLastStep: isLastStep,
                                formSubmitted: formSubmitted,
                                stepStatus: stepStatus,
                                formId: formId,
                                form: form,
                                isSecondServiceForm: isSecondServiceForm,
                                searchableMultiSelect: searchableMultiSelect,
                                apiCallLoading: apiCallLoading
                            }, i),
                            showMergedButton()
                        ]
                    }, i));
                } else {
                    if (!piiCompletionData?.missingFields?.includes(step.fields[i].codeName)) {
                        fieldsList.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* FormField */.W, {
                            field: step.fields[i],
                            fields: step.fields,
                            asTitle: step.fields.length === 1 && !step.title,
                            ...props,
                            handleFieldBlur: handleFieldBlur,
                            handleFieldChange: handleFieldChange,
                            fieldsData: fieldsData,
                            visitedSteps: visitedSteps,
                            currentStep: currentStep,
                            colors: colors,
                            isLoading: isLoading,
                            isLastStep: isLastStep,
                            formSubmitted: formSubmitted,
                            stepStatus: stepStatus,
                            formId: formId,
                            form: form,
                            isSecondServiceForm: isSecondServiceForm,
                            searchableMultiSelect: searchableMultiSelect,
                            apiCallLoading: apiCallLoading
                        }, i));
                    }
                }
            }
        }
    }
    const getFieldsGroup = (fieldsList)=>{
        const groupByTag = {};
        fieldsList.forEach((field)=>{
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (!groupByTag[field?.props?.field?.tag]) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                groupByTag[field?.props?.field?.tag] = [];
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            groupByTag[field?.props?.field?.tag].push(field);
        });
        const tagsElements = Object.keys(tags);
        return tagsElements.map((tag)=>{
            const categoryIcon = (0,sharedUtils/* getSecondServiceCategoryIcon */.fd)(tag, category, form);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    tag !== "common" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: `${(styles_module_default()).serviceLabel} ${tags[tag].active ? (styles_module_default()).activeService : ""} flex items-center `,
                        onClick: ()=>{
                            if (updateSecondServices) updateSecondServices(tag);
                        },
                        children: [
                            categoryIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(s3Icon/* default */.Z, {
                                    image: categoryIcon,
                                    svgClassName: (styles_module_default())["category-icon"]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: tag === "undefined" ? form.categoryName : tag
                            })
                        ]
                    }),
                    tags[tag].active && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).tagGroup,
                        children: groupByTag[tag] ? groupByTag[tag].map((f)=>f) : groupByTag["undefined"] ? groupByTag["undefined"].map((f)=>f) : []
                    })
                ]
            }, tag);
        });
    };
    const extendAnswerSummaryConfig = answerSummaryConfigs?.find((config)=>{
        return config.extend;
    });
    const answerSummaryConfig = answerSummaryConfigs?.find((config)=>config.stepIndex === index) ?? (extendAnswerSummaryConfig && currentStep > extendAnswerSummaryConfig.stepIndex ? extendAnswerSummaryConfig : undefined);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `${(styles_module_default()).step} rtlStyle ${classes?.stepClassName ?? ""} ${index === 0 && !step.description && step.title ? (classes?.firstStepClass) : ""}`,
        children: currentStep === index && !formErrors && operation?.key !== "ROUND_TWO" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: apiCallLoading && index === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center justify-center py-20 text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                            size: 60,
                            className: `text-white ${(styles_module_default())["loading-spinner"]}`
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: `${(styles_module_default())["loading-title"] ?? ""}`,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-center",
                                children: category?.config?.apiLoadingLabel || "Finding the best match for you..."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ApiLoadingLabels/* ApiLoadingLabels */.U, {})
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    answerSummaryConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerSummary, {
                        answerSummaryConfig: answerSummaryConfig,
                        fieldsState: fieldsData
                    }),
                    step.tag && ![
                        "pii",
                        "common"
                    ].includes(step.tag) && !isSecondServiceForm && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes?.stepTagClassName ?? "",
                        children: step.tag
                    }),
                    buyerPhoneNumber && index === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: `${(styles_module_default()).title} ${(styles_module_default()).phoneNumberTitle} ${classes?.stepTitleClassName ?? ""}`,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Don't wait—call now!"
                            })
                        })
                    }) : (step.title || customMainTitle) && !hideStepTitle ? index === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                            className: `${(styles_module_default()).title} ${classes?.stepTitleClassName ?? ""}`,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: title ?? ""
                                    }
                                }),
                                step.tooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                                    placement: "bottom",
                                    overlay: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: step.tooltip
                                    }),
                                    trigger: [
                                        "hover"
                                    ],
                                    overlayClassName: (styles_module_default()).tooltip,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default())["tooltip-icon"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltipIcon/* default */.Z, {})
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: `${(styles_module_default()).title} ${classes?.stepTitleClassName ?? ""}`,
                        children: [
                            isFormInsideOffersModal && textBlocks.find((item)=>item.position === "form-inside-exit-modal-second-step-title")?.text ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: (0,sharedUtils/* replacePlaceholders */.wT)(textBlocks.find((item)=>item.position === "form-inside-exit-modal-second-step-title")?.text, {
                                        category: category?.name,
                                        region: visitDetails.region,
                                        city: visitDetails?.city
                                    })
                                }
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: (0,decodeFieldsFromText/* decodeFieldsFromText */.l)(step.title, fieldsData)
                            }),
                            step.tooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                                placement: "bottom",
                                overlay: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: step.tooltip
                                }),
                                trigger: [
                                    "hover"
                                ],
                                overlayClassName: (styles_module_default()).tooltip,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default())["tooltip-icon"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltipIcon/* default */.Z, {})
                                })
                            })
                        ]
                    }) : null,
                    step.description && !hideStepDescription && !isFormInsideOffersModal && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `${(styles_module_default()).description}
                                            ${buyerPhoneNumber && index === 0 ? (styles_module_default()).phoneNumberDescription : ""}  
                                            ${classes?.stepDescriptionClassName ?? ""} ${hideStepTitle ? `${(styles_module_default()).title} ${classes?.stepTitleClassName ?? ""}` : ""}`,
                        children: getDescription()
                    }),
                    isPiiCompletionForm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: `pii-completion-missing-fields`,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MissingFieldsHeadline/* default */.Z, {}),
                                piiCompletionData?.missingFields?.map((field)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* FormField */.W, {
                                            field: step.fields.find((i)=>i.codeName === field),
                                            fields: step.fields,
                                            asTitle: step.fields.length === 1 && !step.title,
                                            ...props,
                                            handleFieldBlur: handleFieldBlur,
                                            handleFieldChange: handleFieldChange,
                                            fieldsData: fieldsData,
                                            visitedSteps: visitedSteps,
                                            currentStep: currentStep,
                                            colors: colors,
                                            isLoading: isLoading,
                                            isLastStep: isLastStep,
                                            formSubmitted: formSubmitted,
                                            stepStatus: stepStatus,
                                            formId: formId,
                                            form: form,
                                            isSecondServiceForm: false,
                                            searchableMultiSelect: searchableMultiSelect,
                                            apiCallLoading: apiCallLoading
                                        })
                                    }, field)),
                                !showPiiCompletionOtherFields && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    onClick: ()=>{
                                        setShowPiiCompletionOtherFields(true);
                                    },
                                    className: "text-[#848484] font-semibold text-center cursor-pointer mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-[#328df8]",
                                            children: "Edit"
                                        }),
                                        " ",
                                        "Your Answers"
                                    ]
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${isSecondServiceForm ? (styles_module_default()).serviceListWrapper : ""} ${(styles_module_default()).fields} ${classes?.fieldsWrapperClassName ?? ""}`,
                                children: isSecondServiceForm ? getFieldsGroup(fieldsList) : fieldsList
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `
                                ${isSecondServiceForm ? (styles_module_default()).sharedFieldsContainer : ""}
                                ${isSecondServiceForm && !isSecondServiceSelected ? "hidden" : ""}
                                    `,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: `${(styles_module_default()).fields} ${classes?.fieldsWrapperClassName ?? ""} ${isSecondServiceForm ? `${(styles_module_default()).sharedFieldsWrapper} flex flex-wrap` : ""}`,
                                    children: sharedFieldsList
                                })
                            })
                        ]
                    }),
                    isLastStep && !isSecondServiceForm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(smsTCPA/* default */.Z, {
                        isFormInsideOffersModal: isFormInsideOffersModal,
                        buttonText: secondStepButtonText?.text && isFormInsideOffersModal ? (0,sharedUtils/* extractContentFromHtml */.qZ)(secondStepButtonText.text).trim() : steps[currentStep]?.buttonText
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col md:gap-3 sm:flex-row justify-between items-center",
                        children: [
                            isSecondServiceForm ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(styles_module_default()).buttons} order-2 sm:order-1`,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: ` ${(styles_module_default())["submit-button"]} ${(styles_module_default())["form-button"]} ${formButtonClassName ?? ""}`,
                                    style: {
                                        border: `1px solid ${colors.primaryColor || "var(--global-form-buttons-background-color)"}`,
                                        backgroundColor: "#fff",
                                        color: "#000"
                                    },
                                    type: "button",
                                    onClick: ()=>{
                                        setSkipToThankYou(true);
                                        if (isSecondServiceForm) {
                                            setButtonDisabled({
                                                noThankYou: false,
                                                getQuote: true
                                            });
                                        }
                                    },
                                    disabled: isLoading,
                                    children: "No Thank You"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: `${(styles_module_default()).buttons} order-1 sm:order-2`,
                                children: [
                                    isPiiCompletionForm && showPiiCompletionOtherFields && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherFieldsHeadline/* default */.Z, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: `${(styles_module_default()).fields} ${classes?.fieldsWrapperClassName ?? ""} `,
                                                    children: fieldsList
                                                })
                                            ]
                                        })
                                    }),
                                    !showFormModal && !globalLoading && (domain.config?.tcpaPosition === "aboveSubmitButton" || domain.categories?.[0].config?.tcpaPosition === "aboveSubmitButton") && tcpa,
                                    checkIfShowNextButton()
                                ]
                            })
                        ]
                    }),
                    formError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default())["form-error"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: formError
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/components/FormStepsWrapper.tsx





function FormStepsWrapper({ slideFormValue , steps , stepsConfig , formProps , isSecondServiceForm , operation , classes , isFormInsideOffersModal , formErrors , handleFieldBlur , handleFieldChange , currentStep , isLoading , globalLoading , formError , fieldsData , visitedSteps , checkIfStepHasOneField , formSubmitted , formId , finalForm , stepStatus , form , updateSecondServices , tags , activeSecondServices , secondServiceLoading , showPiiCompletionOtherFields , setShowPiiCompletionOtherFields , searchableMultiSelect , finalAnswerSummaryConfigs , tcpa , singleQuestion , mergeInputWithSubmitOnFirstStep , apiCallLoading , formErrorsResolved , invalidFields , isExpandable , getExpandableFields , domain , domainNameTranslation , isLastStep , showOtp , otp , dispatch , submitButtonText , startSecondRoundBidding , goToThankYouPage , goToListPage , compactOfferBlock , hideOffers , customThankYouStep , colors , isLoading2 , disableAutoFocus  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            transform: `translate(${slideFormValue}%, 0)`
        },
        className: `${(styles_module_default())["steps-wrapper"]} ltrStyle`,
        id: "stepsWrapper",
        children: [
            steps?.map((step, stepIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FormStep, {
                    isSecondServiceForm: isSecondServiceForm,
                    operation: operation,
                    formButtonClassName: classes?.formButtonClassName,
                    isFormInsideOffersModal: isFormInsideOffersModal,
                    formErrors: formErrors,
                    step: step,
                    index: stepIndex,
                    handleFieldBlur: handleFieldBlur,
                    handleFieldChange: handleFieldChange,
                    currentStep: currentStep,
                    isLoading: isLoading || globalLoading,
                    formError: formError,
                    fieldsData: fieldsData,
                    steps: steps,
                    visitedSteps: visitedSteps,
                    ...formProps,
                    hideStepTitle: stepsConfig?.[stepIndex]?.hideTitle ?? false,
                    hideStepDescription: stepsConfig?.[stepIndex]?.hideDescription ?? false,
                    forceStepTitle: stepsConfig?.[stepIndex]?.forceStepTitle ?? false,
                    checkIfStepHasOneField: checkIfStepHasOneField,
                    formSubmitted: formSubmitted,
                    formId: formId,
                    form: finalForm,
                    overrideStepTitle: stepsConfig?.[stepIndex]?.title ?? "",
                    overrideStepDescription: stepsConfig?.[stepIndex]?.description ?? "",
                    stepStatus: stepStatus,
                    textBlocks: form?.textBlocks ?? [],
                    updateSecondServices: updateSecondServices,
                    tags: tags,
                    activeSecondServices: activeSecondServices,
                    secondServiceLoading: secondServiceLoading,
                    showPiiCompletionOtherFields: showPiiCompletionOtherFields,
                    setShowPiiCompletionOtherFields: setShowPiiCompletionOtherFields,
                    searchableMultiSelect: searchableMultiSelect,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    answerSummaryConfigs: finalAnswerSummaryConfigs,
                    globalLoading: globalLoading,
                    tcpa: tcpa,
                    singleQuestion: singleQuestion,
                    mergeInputWithSubmitOnFirstStep: mergeInputWithSubmitOnFirstStep,
                    apiCallLoading: apiCallLoading,
                    disableAutoFocus: disableAutoFocus
                }, stepIndex)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormExtraSteps, {
                formErrors: formErrors,
                formErrorsResolved: formErrorsResolved,
                invalidFields: invalidFields,
                isExpandable: isExpandable,
                getExpandableFields: getExpandableFields,
                domain: domain,
                domainNameTranslation: domainNameTranslation,
                isLastStep: isLastStep,
                currentStep: currentStep,
                showOtp: showOtp,
                otp: otp,
                dispatch: dispatch,
                submitButtonText: submitButtonText,
                startSecondRoundBidding: startSecondRoundBidding,
                formSubmitted: formSubmitted,
                goToThankYouPage: goToThankYouPage,
                goToListPage: goToListPage,
                compactOfferBlock: compactOfferBlock,
                hideOffers: hideOffers,
                customThankYouStep: customThankYouStep,
                fieldsData: fieldsData,
                finalForm: finalForm,
                handleFieldBlur: handleFieldBlur,
                handleFieldChange: handleFieldChange,
                stepStatus: stepStatus,
                isSecondServiceForm: isSecondServiceForm,
                formProps: formProps,
                classes: classes,
                colors: colors,
                isLoading: isLoading2,
                operation: operation,
                searchableMultiSelect: searchableMultiSelect,
                singleQuestion: singleQuestion
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/components/index.ts













// EXTERNAL MODULE: ./src/utils/domTracing.ts + 1 modules
var domTracing = __webpack_require__(87605);
;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useFormInit.ts


function useFormInit({ router , visitDetails , domain , goToThankYouPage , setGoToThankYouPage  }) {
    (0,react.useEffect)(()=>{
        if (router.query.lander) {
            localStorage.setItem("lander", router.query.lander);
        }
        setGoToThankYouPage(goToThankYouPage ?? false);
        // Initialize DOM change tracking
        const cleanup = (0,domTracing/* initDomTracingSafe */.M)({
            visitDetails,
            domain
        });
        return cleanup; // Cleanup observer on unmount
    }, []);
}

// EXTERNAL MODULE: ./src/components/shared/offer/index.tsx
var shared_offer = __webpack_require__(27602);
// EXTERNAL MODULE: ./src/components/shared/insuranceOffer/index.tsx
var insuranceOffer = __webpack_require__(62070);
// EXTERNAL MODULE: ./src/components/shared/regulationsContent/RegulationsContent.tsx
var RegulationsContent = __webpack_require__(77886);
;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useExitOffersModal.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 








const PopupCallUs = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(92592), __webpack_require__.e(86393)]).then(__webpack_require__.bind(__webpack_require__, 86393)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(86393)
            ]
    }
});
const CustomOfferExitModal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5110).then(__webpack_require__.bind(__webpack_require__, 5110)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5110)
            ]
    }
});
function useExitOffersModal({ exitModalOffer , category , currentCategorySlug , buyerPhoneNumber , routeConfig , showFormModal , isFormInsideOffersModal , singleQuestion , showFromInExitModal , showExitModal , showRegulations , clicksOffers , listRequestId , visitDetails , popupOffers , popupStyle , offersPopupActive , setOffersPopupActive , setPopupOffers , toggleShowFormInExitModal , disableExitModal , customOfferExitModal , customOfferExitModalImage , customOfferExitModalContent  }) {
    const popupShowCountRef = (0,react.useRef)(0);
    const modalWidthRef = (0,react.useRef)(900);
    const doesTheOfferHaveANumber = (offer)=>!!(offer?.proxiedNumber?.phoneNumber || offer?.hiddenAttributes?.phoneNumber || offer?.phoneValue || offer?.attributes?.phoneNumber || buyerPhoneNumber);
    const handleOffersPopupVisibility = ()=>{
        if (disableExitModal) return;
        const offers = exitModalOffer?.filter((offer)=>{
            if (!category?.slug && currentCategorySlug && offer.category.slug === currentCategorySlug || category?.slug && offer.category.slug === category?.slug) {
                return offer;
            }
        });
        const hideExitModalWithForm = (category?.config?.hideExitModalWithForm) ?? false;
        const isFirstShow = popupShowCountRef.current === 0;
        const shouldShowOffersPopup = !!offers?.length && !offersPopupActive && isFirstShow && !showFromInExitModal;
        const shouldShowPhonePopup = !!buyerPhoneNumber && isFirstShow;
        if (shouldShowOffersPopup || shouldShowPhonePopup) {
            if (offers?.length) {
                setPopupOffers(offers);
            }
            const shouldShowModal = !!buyerPhoneNumber || !routeConfig?.config?.settings?.hidePageOffers;
            if (shouldShowModal) {
                setOffersPopupActive(!showFormModal);
                popupShowCountRef.current++;
            }
        } else if (!isFormInsideOffersModal && popupShowCountRef.current === 0 && !singleQuestion && !hideExitModalWithForm) {
            toggleShowFormInExitModal(true);
            popupShowCountRef.current++;
            return;
        }
    };
    const displayExitModal = (0,react.useMemo)(()=>{
        if (showExitModal) {
            return true;
        }
        return false;
    }, [
        showExitModal
    ]);
    const displayFormInOfferModal = (0,react.useMemo)(()=>showFromInExitModal, [
        showFromInExitModal
    ]);
    //[todo] should review this use effect i think we can remove it
    (0,react.useEffect)(()=>{
        if (displayExitModal || displayFormInOfferModal) {
            handleOffersPopupVisibility();
        }
    }, [
        displayExitModal,
        displayFormInOfferModal
    ]);
    const modalOffersContent = (0,react.useMemo)(()=>{
        if (customOfferExitModal && Array.isArray(popupOffers) && popupOffers.length === 1 && doesTheOfferHaveANumber(popupOffers[0])) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomOfferExitModal, {
                image: customOfferExitModalImage,
                content: customOfferExitModalContent,
                offer: popupOffers[0]
            });
        }
        if (Array.isArray(popupOffers) && popupOffers.length === 1 && doesTheOfferHaveANumber(popupOffers[0]) && popupOffers[0]?.features?.length === 0 || doesTheOfferHaveANumber(popupOffers[0])) {
            modalWidthRef.current = 500;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupCallUs, {
                popupStyle: popupStyle,
                offerAsProp: popupOffers[0]
            });
        }
        return popupOffers.map((offer)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(shared_offer["default"], {
                zone: config/* affiliateOfferZones.EXIT_MODAL */.ZR.EXIT_MODAL,
                offer: offer,
                className: (styles_module_default()).offer,
                displayLinkAndPhoneNumber: (0,sharedUtils/* doesOfferHaveALink */.hn)(offer)
            }, offer.id));
    }, [
        popupOffers,
        buyerPhoneNumber,
        customOfferExitModal,
        customOfferExitModalImage,
        customOfferExitModalContent, 
    ]);
    const modalOfferClicksContent = (0,react.useMemo)(()=>{
        if (showRegulations && clicksOffers && clicksOffers.length) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegulationsContent/* RegulationsContent */.q, {
                title: "Hey Californians!",
                description: "Your state restricts extended auto warranties. You can get complete coverage by looking into mechanical breakdown insurance (MBI). Visit these websites to find out more:",
                children: clicksOffers?.slice(0, 2)?.map((clickOffer, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(insuranceOffer/* default */.Z, {
                        index: index,
                        item: {
                            ...clickOffer,
                            slug: `${clickOffer.slug}?id=${listRequestId}`
                        },
                        category: "Auto Insurance",
                        state: visitDetails?.region ?? undefined,
                        primaryColor: "#f79626",
                        textColor: "#266199"
                    }, index))
            });
        }
        return null;
    }, [
        clicksOffers
    ]);
    return {
        handleOffersPopupVisibility,
        displayExitModal,
        displayFormInOfferModal,
        modalOffersContent,
        modalOfferClicksContent,
        modalWidth: modalWidthRef.current
    };
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useBlockOtherSections.ts

/**
 * Toggles the body `hideOtherSections` class once the form moves past step 0,
 * gated by domain / category / route config flags.
 *
 * Returns the resolved `blockOtherSections` boolean for any consumers that
 * also need it.
 */ function useBlockOtherSections({ routeConfig , domain , category , currentStep , prevStepRef  }) {
    const blockOtherSections = (0,react.useMemo)(()=>{
        return Boolean(routeConfig?.templateConfig?.variantConfig?.shouldHideSectionsAfterFirstAnswer ?? domain?.config?.shouldHideSectionsAfterFirstAnswer ?? category?.config?.shouldHideSectionsAfterFirstAnswer ?? false);
    }, [
        routeConfig,
        domain,
        category
    ]);
    (0,react.useEffect)(()=>{
        if (!blockOtherSections) return;
        const bodyClass = "hideOtherSections";
        if (currentStep > 0 || prevStepRef.current && prevStepRef.current > 0) {
            document.body.classList.add(bodyClass);
        } else {
            document.body.classList.remove(bodyClass);
        }
    }, [
        currentStep,
        blockOtherSections
    ]);
    (0,react.useEffect)(()=>{
        prevStepRef.current = currentStep;
    }, [
        currentStep
    ]);
    return blockOtherSections;
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useFormPersistence.ts

/**
 * Manages form data persistence:
 * - Mirrors form state into `localStorage` (dynamic fields, global form values, success message).
 * - Listens for `formDataUpdated` window events to sync state between
 *   modal and page form instances.
 */ function useFormPersistence({ fieldsData , dynamicThankYouFields , isSecondServiceForm , isPiiCompletionForm , piiCompletionData , successMessage , formId , isFormInsideOffersModal , reloadFormData  }) {
    // Storage sync
    (0,react.useEffect)(()=>{
        const params = {};
        if (dynamicThankYouFields && !isSecondServiceForm) {
            dynamicThankYouFields.forEach((field)=>{
                params[field] = fieldsData[field]?.value;
            });
            localStorage.setItem("dynamicFields", JSON.stringify(params));
        }
        if (isPiiCompletionForm) {
            piiCompletionData?.fields.forEach((field)=>{
                params[field.codeName] = fieldsData[field.codeName]?.value;
            });
            localStorage.setItem("dynamicFields", JSON.stringify(params));
        }
        if (!isSecondServiceForm) {
            const formAnswers = Object.keys(fieldsData).reduce((res, key)=>{
                res = {
                    ...res,
                    [key]: fieldsData[key].value
                };
                return res;
            }, {});
            // @ts-ignore
            window.formAnswers = formAnswers;
            localStorage.setItem("globalFormValues", JSON.stringify(formAnswers));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fieldsData
    ]);
    (0,react.useEffect)(()=>{
        if (!isSecondServiceForm) {
            localStorage.setItem("successMessage", JSON.stringify(successMessage));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Cross-instance data update listener
    (0,react.useEffect)(()=>{
        const handleStorageUpdate = (event)=>{
            const detail = event.detail;
            if (detail?.formId === String(formId) && !isFormInsideOffersModal && reloadFormData && typeof reloadFormData === "function") {
                reloadFormData();
            }
        };
        window.addEventListener("formDataUpdated", handleStorageUpdate);
        return ()=>{
            window.removeEventListener("formDataUpdated", handleStorageUpdate);
        };
    }, [
        formId,
        isFormInsideOffersModal,
        reloadFormData
    ]);
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/usePreventPageClose.ts


/**
 * Wires up the legacy mouse-exit + beforeunload handlers used by the new form.
 *
 * - Registers an exit-intent mousemove listener that pops the offers modal.
 * - Registers a `beforeunload` handler when `preventWindowClose` is on and the
 *   visit has a `ts` query param, except for Propel Media traffic.
 * - Removes the `beforeunload` handler on the last step.
 *
 * Behavior is preserved verbatim from the previous inline implementation,
 * including the existing dep arrays.
 */ function usePreventPageClose({ isFormSubmitted , preventWindowClose , router , visitDetails , isLastStep , setSetPopupFormSubmittedFunction , handleOutsideFormSubmit , handleOffersPopupVisibility , currentCategorySlug , exitModalOffer , buyerPhoneNumber  }) {
    // Store the handler in a ref so we can add/remove the same function reference
    const handlePreventPageCloseRef = (0,react.useRef)(null);
    // Create the handler once and store it
    if (!handlePreventPageCloseRef.current) {
        handlePreventPageCloseRef.current = (0,sharedUtils/* createHandlePreventPageClose */.Qk)(()=>isFormSubmitted.current);
    }
    // [SAME AS OLD FORM]
    (0,react.useEffect)(()=>{
        setSetPopupFormSubmittedFunction({
            function: handleOutsideFormSubmit
        });
        //[todo] check if we should move the  mouse move logic to useExitOffersModal
        const exitHandler = (e)=>{
            // Don't show exit modal if form already submitted
            if (isFormSubmitted.current) {
                return;
            }
            const mouseY = e.clientY;
            if (mouseY <= 10 && visitDetails?.trafficSourceNetwork !== "Propel Media") {
                handleOffersPopupVisibility();
            }
        };
        document.body.addEventListener("mousemove", exitHandler);
        if (preventWindowClose && router.query.ts && visitDetails?.trafficSourceNetwork !== "Propel Media" && handlePreventPageCloseRef.current) {
            window.addEventListener("beforeunload", handlePreventPageCloseRef.current);
        }
        return ()=>{
            document.body.removeEventListener("mousemove", exitHandler);
            // Also remove beforeunload listener on cleanup
            if (handlePreventPageCloseRef.current) {
                window.removeEventListener("beforeunload", handlePreventPageCloseRef.current);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentCategorySlug,
        exitModalOffer,
        buyerPhoneNumber
    ]);
    (0,react.useEffect)(()=>{
        if (isLastStep && handlePreventPageCloseRef.current) {
            window.removeEventListener("beforeunload", handlePreventPageCloseRef.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLastStep
    ]);
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useThankYouRedirect.ts



/**
 * Triggers the thank-you page redirect once the form has been submitted and
 * (for one-to-one flows) a winner buyer has been resolved. Behavior is
 * preserved verbatim from the previous inline implementation including the
 * existing dep array.
 */ function useThankYouRedirect({ formSubmitted , goToThankYouPage , skipToThankYou , otp , category , isSecondServiceForm , dynamicThankYouFields , fieldsData , loadOneToOneForm , operation , router , isFormSubmitted , domain , locale , defaultLocale , form , ignoreCategoryInThankYouPagePath , onInlineThankYouShown  }) {
    // The exit-modal form re-renders continuously (its `result` form object is
    // rebuilt on every render in FormOfferModal), so the effects below would
    // otherwise re-fire on every render once the form is submitted. The first
    // one would re-assign `window.location.href` on every render — the browser
    // keeps restarting the navigation and never settles, which surfaces as
    // "infinite redirections" when submitting from the exit modal. These refs
    // make the redirect / inline-thank-you handoff fire exactly once.
    const hasRedirectedRef = (0,react.useRef)(false);
    const hasShownInlineThankYouRef = (0,react.useRef)(false);
    const goToThankYou = (0,react.useCallback)((queryString, params, leadUuid)=>buildThankYouUrl({
            domain,
            category,
            locale,
            defaultLocale,
            operation,
            form,
            fieldsData,
            ignoreCategoryInThankYouPagePath,
            queryString,
            params,
            leadUuid
        }), [
        domain,
        category,
        locale,
        fieldsData,
        operation
    ]);
    (0,react.useEffect)(()=>{
        const params = {};
        const hasNoSecondService = !category?.secondServiceCategories || category.secondServiceCategories.length === 0 || !!isSecondServiceForm;
        const shouldRedirectAfterSubmit = formSubmitted && !!goToThankYouPage && !otp.isRequired && hasNoSecondService;
        const shouldRedirectOnSkip = skipToThankYou && !!goToThankYouPage;
        if (shouldRedirectAfterSubmit || shouldRedirectOnSkip) {
            const queryString = (0,routerQueriesToString/* gettingQueriesAsString */.r)(router.query, "start");
            if (dynamicThankYouFields && !isSecondServiceForm) {
                dynamicThankYouFields.forEach((field)=>{
                    params[field] = fieldsData[field]?.value;
                });
            }
            // For one-to-one consent flows, wait until a winner buyer is
            // resolved before redirecting; for the legacy (non-OTO) flow,
            // proceed to thank-you immediately as soon as the form is submitted.
            const isNonOtoFlow = !loadOneToOneForm;
            const winnerBuyerResolved = operation?.winnerBuyer !== undefined || operation?.winnerBuyer !== null;
            if ((isNonOtoFlow || winnerBuyerResolved) && !hasRedirectedRef.current) {
                hasRedirectedRef.current = true;
                isFormSubmitted.current = true;
                window.__anyFormSubmitted = true;
                const leadUuid = localStorage.getItem("mainId") ?? undefined;
                window.location.href = goToThankYou(queryString, params, leadUuid);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formSubmitted,
        router,
        goToThankYouPage,
        dynamicThankYouFields,
        skipToThankYou,
        category,
        operation,
        loadOneToOneForm, 
    ]);
    // Call the callback when form is submitted with inline thank you (no redirect).
    // Guarded so it fires only once even though `onInlineThankYouShown` is a new
    // closure on every render (recreated inline in FormInOfferModal), which would
    // otherwise re-invoke the exit-modal close/submit handoff on every re-render.
    (0,react.useEffect)(()=>{
        if (formSubmitted && !goToThankYouPage && onInlineThankYouShown && !hasShownInlineThankYouRef.current) {
            hasShownInlineThankYouRef.current = true;
            onInlineThankYouShown();
        }
    }, [
        formSubmitted,
        goToThankYouPage,
        onInlineThankYouShown
    ]);
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useFormSideFetches.ts


/**
 * Side-effect fetches that mirror the legacy `formNew.tsx` behavior:
 * - When `showRegulations` flips on, fetch cross-selling clicks offers and
 *   open the popup with the resulting list.
 * - When `showCustomListingModal` flips on with a `listingSlug`, fetch that
 *   listing and open the popup with its offers.
 *
 * Behavior is preserved verbatim including the existing single-dep arrays.
 */ function useFormSideFetches({ domain , category , fieldsData , showRegulations , showCustomListingModal , listingSlug , setLoading , setOffersPopupActive , setClicksOffers , setListRequestId , setPopupOffers  }) {
    // [SAME AS OLD FORM]
    (0,react.useEffect)(()=>{
        const fetchInsuranceOffers = async ()=>{
            const crossSellingDomainFormId = domain.categories.find((item)=>item.slug === category?.slug)?.crossSellingDomainFormId;
            if (crossSellingDomainFormId) {
                setLoading(true);
                const { data: clicksSearchList  } = await (0,api/* getClicksSearchList */.zm)({
                    questions: {
                        zipCode: {
                            value: fieldsData["zipCode"].value,
                            name: "zipCode"
                        }
                    },
                    categorySlug: "auto-insurance",
                    crossSellingDomainFormId: crossSellingDomainFormId
                });
                setLoading(false);
                return clicksSearchList;
            }
            return [];
        };
        if (showRegulations) {
            fetchInsuranceOffers().then((res)=>{
                setOffersPopupActive(true);
                if (res && !Array.isArray(res)) {
                    setClicksOffers(res.result);
                    setListRequestId(res.listRequestId);
                }
            }).catch(()=>{
                setClicksOffers([]);
                setOffersPopupActive(false);
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showRegulations
    ]);
    // [SAME AS OLD FORM]
    (0,react.useEffect)(()=>{
        const fetchListingBySlug = async (slug)=>{
            const { data  } = await (0,api/* getListingBySlugV3 */.Ao)({
                slug
            });
            return data;
        };
        if (showCustomListingModal && listingSlug) {
            fetchListingBySlug(listingSlug).then((res)=>{
                if (res && res.offers && res.offers.length) {
                    setOffersPopupActive(true);
                    setPopupOffers(res?.offers);
                }
            }).catch(()=>{
                setPopupOffers([]);
                setOffersPopupActive(false);
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showCustomListingModal
    ]);
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useSlideFormValue.ts

/**
 * Computes the horizontal translate percentage applied to the form slider.
 *
 * Each "extra" step (errors / buyers list / otp / thankyou) shifts the slider
 * by an additional -100/-200/-300/-400 on top of the base step offset.
 */ function useSlideFormValue({ isLastStep , formErrors , operation , formSubmitted , goToThankYouPage , goToListPage , otp , currentStep , formErrorsResolved  }) {
    return (0,react.useMemo)(()=>{
        // form errors step
        if (isLastStep && formErrors) {
            return currentStep * -100 - 100;
        }
        // buyers list step
        if (operation?.key === "ROUND_TWO" && (!formSubmitted || formSubmitted && goToThankYouPage)) {
            return currentStep * -100 - 300;
        }
        // otp step
        if (otp?.isRequired || otp?.isResolved && goToThankYouPage && operation?.key !== "ROUND_TWO") {
            return currentStep * -100 - 200;
        }
        // thankyou step
        if (formSubmitted && !goToThankYouPage && !goToListPage) {
            return currentStep * -100 - 400;
        }
        // form steps (default)
        return currentStep * -100;
    }, [
        formSubmitted,
        goToThankYouPage,
        isLastStep,
        otp,
        currentStep,
        formErrorsResolved,
        formErrors,
        operation?.key
    ]);
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useInvalidFields.ts


/**
 * Computes the array of fields that failed validation when `formErrors` is
 * truthy. Also performs the legacy in-place slicing of the first field's
 * options when `singleQuestion` is enabled (preserving existing behavior).
 */ function useInvalidFields({ steps , singleQuestion , singleQuestionMaxOptions , formErrors , fieldsData  }) {
    return (0,react.useMemo)(()=>{
        const fields = (0,lodash/* flatten */.xH)(steps.map((step)=>step.fields));
        if (singleQuestion && singleQuestionMaxOptions && fields[0].fieldType == "select" && fields[0].defaultValues?.options) {
            fields[0].defaultValues.options = fields[0].defaultValues.options.slice(0, Number(singleQuestionMaxOptions) - 1);
            //add older option
            fields[0].defaultValues.options.push({
                label: "Older",
                value: "",
                id: 1,
                icon: null
            });
        }
        if (formErrors) {
            const allFields = Object.keys(fieldsData);
            const invalidFieldsArray = [];
            allFields.forEach((field)=>{
                if (fieldsData[field].valid === false) {
                    invalidFieldsArray.push({
                        ...fieldsData[field],
                        ...fields.find((f)=>f.codeName === field) ?? {}
                    });
                }
            });
            return invalidFieldsArray;
        }
        return [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formErrors
    ]);
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useSecondServiceState.ts

function useSecondServiceState({ isSecondServiceForm , formSubmitted , setSecondServiceSubmitted , tags  }) {
    (0,react.useEffect)(()=>{
        if (isSecondServiceForm && formSubmitted) {
            setSecondServiceSubmitted(true);
        }
    }, [
        formSubmitted
    ]);
    const isSecondServiceSelected = (0,react.useMemo)(()=>{
        if (tags) {
            const tagsKeys = Object.keys(tags);
            let tagsSelected = false;
            tagsKeys.forEach((tag)=>{
                tagsSelected = tagsSelected || tags[tag].active;
            });
            return tagsSelected;
        }
        return false;
    }, [
        tags
    ]);
    return {
        isSecondServiceSelected
    };
}

// EXTERNAL MODULE: ./src/components/shared/form/answerSummary/preDefinedConfigs.ts
var preDefinedConfigs = __webpack_require__(66891);
;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useFormRenderConditions.ts



function useFormRenderConditions({ showProgress , globalLoading , otp , formErrors , showFormModal , operation , stepsConfig , currentStep , formSubmitted , steps , domain , preFirstStepTitle , formTemplate , formTemplateProp , sellingPointsSteps , sellingPoint , isLastStep , visitDetails , locale , backButton , handlePrevStep , isFormInsideOffersModal , goToListPage , category , formOffer , form , isMainFormSubmitted , isPiiCompletionForm , isSecondServiceForm , skipToThankYou , goToThankYouPage  }) {
    const showOtp = otp?.isRequired || !otp?.isRequired && otp?.isResolved || false;
    const showTCPAMessage = (0,react.useMemo)(()=>{
        return !!(steps && steps[currentStep]?.includeTCPAMessage && !formSubmitted && (!otp?.isRequired || operation?.key === "ROUND_TWO"));
    }, [
        formSubmitted,
        otp,
        operation?.key
    ]);
    const showBackButton = (0,react.useMemo)(()=>{
        return currentStep !== 0 && !formSubmitted && !otp.isRequired || !!(backButton?.firstStepAction && currentStep === 0);
    }, [
        backButton,
        currentStep,
        steps,
        formSubmitted
    ]);
    const showOfferInForm = currentStep === 0 && !!formOffer?.length && !!(formTemplate === "v1" || formTemplate === "v2" || formTemplateProp);
    const isSecondServiceSupported = (0,react.useMemo)(()=>{
        const selectedCategory = domain.categories.find((categoryElement)=>categoryElement.slug === category?.slug);
        return !!(selectedCategory && selectedCategory?.secondServiceCategories?.length);
    }, [
        category
    ]);
    const submitButtonText = (0,react.useMemo)(()=>{
        const textBlocks = form?.textBlocks;
        const secondStepButtonText = textBlocks?.find((item)=>item.position === "form-inside-exit-modal-submit-button-text-second-step");
        return secondStepButtonText?.text && isFormInsideOffersModal ? (0,sharedUtils/* extractContentFromHtml */.qZ)(secondStepButtonText.text).trim() : steps[currentStep]?.buttonText;
    }, [
        form,
        isFormInsideOffersModal,
        currentStep
    ]);
    const shouldShowSkipThankYouShortcut = skipToThankYou && !goToThankYouPage || !!(formSubmitted && isSecondServiceForm && !goToThankYouPage);
    const shouldRenderSecondServiceForm = isSecondServiceSupported && isMainFormSubmitted && !isPiiCompletionForm && !isSecondServiceForm && !showFormModal;
    const finalAnswerSummaryConfigs = domain.config?.preDefinedAnswerSummaryConfigs ? preDefinedConfigs/* default */.Z[domain.config.preDefinedAnswerSummaryConfigs] : undefined;
    const isRoundTwo = operation?.key === "ROUND_TWO";
    const shouldShowProgressBar = showProgress && !globalLoading && !otp?.isRequired && !formErrors && !showOfferInForm && !showFormModal && !isRoundTwo && !stepsConfig?.[currentStep]?.hideProgress;
    const shouldShowBackButton = showBackButton && !formErrors && !showOtp && !showFormModal && !globalLoading && !isRoundTwo;
    const progressTotal = formSubmitted ? steps?.length : steps?.length + 1;
    const shouldShowPreFirstStepTitle = !!(domain?.config?.showPreFirstStepTitle && preFirstStepTitle && currentStep === 0);
    const isV1Template = formTemplate === "v1" || formTemplateProp === "v1";
    const isV2Template = formTemplate === "v2" || formTemplateProp === "v2";
    const shouldShowOffersInFormTop = showOfferInForm && isV1Template;
    const shouldShowOffersInFormBottom = showOfferInForm && isV2Template;
    const shouldShowFieldWrapperProgress = showProgress && !otp?.isRequired && !formErrors && !showOfferInForm;
    const shouldShowFieldWrapperBackButton = !!showBackButton && !formErrors && !showOtp;
    const isSellingPointForFirstStepOnly = sellingPointsSteps === "FIRST_STEP" && currentStep === 0;
    const isSellingPointForAllSteps = sellingPointsSteps === "ALL_STEPS";
    const shouldShowSellingPoint = !!sellingPoint && !isLastStep && (isSellingPointForAllSteps || isSellingPointForFirstStepOnly);
    const sellingPointLabel = !visitDetails?.region && locale === "es" ? "Mejores abogados de accidentes de auto cerca de m\xed" : sellingPoint;
    const isTcpaPositionAboveSubmit = domain.config?.tcpaPosition === "aboveSubmitButton" || domain.categories?.[0].config?.tcpaPosition === "aboveSubmitButton";
    const shouldShowFloatingTcpa = !showFormModal && !globalLoading && !isTcpaPositionAboveSubmit;
    const handleBackClick = ()=>{
        if (backButton?.firstStepAction && currentStep === 0) {
            backButton.firstStepAction();
        } else {
            handlePrevStep();
        }
    };
    const shouldShowFormInOffersExitModal = !isFormInsideOffersModal && !goToListPage && !category?.config?.hideExitModalWithForm;
    return {
        finalAnswerSummaryConfigs,
        isRoundTwo,
        shouldShowProgressBar,
        shouldShowBackButton,
        progressTotal,
        shouldShowPreFirstStepTitle,
        isV1Template,
        isV2Template,
        shouldShowOffersInFormTop,
        shouldShowOffersInFormBottom,
        shouldShowFieldWrapperProgress,
        shouldShowFieldWrapperBackButton,
        shouldShowSellingPoint,
        sellingPointLabel,
        shouldShowFloatingTcpa,
        handleBackClick,
        shouldShowFormInOffersExitModal,
        showOtp,
        showBackButton,
        showOfferInForm,
        showTCPAMessage,
        isSecondServiceSupported,
        shouldShowSkipThankYouShortcut,
        shouldRenderSecondServiceForm,
        submitButtonText
    };
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useFormTcpa.ts


function useFormTcpa({ isSecondServiceForm , isSecondServiceSelected , showTCPAMessage , formErrors , operation , domain , finalForm , steps , currentStep , classes , submitButtonText , dispatch , isFormInsideOffersModal  }) {
    return (0,react.useMemo)(()=>buildTcpaElement({
            isSecondServiceForm,
            isSecondServiceSelected,
            showTCPAMessage,
            formErrors,
            operation,
            domain,
            finalForm,
            steps,
            currentStep,
            classes,
            submitButtonText,
            dispatch
        }), [
        isSecondServiceForm,
        isSecondServiceSelected,
        showTCPAMessage,
        formErrors,
        isFormInsideOffersModal,
        currentStep,
        submitButtonText,
        domain,
        operation, 
    ]);
}

// EXTERNAL MODULE: ./src/page-builder/utils.ts
var utils = __webpack_require__(79961);
;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/useModalVariables.ts

function useModalVariables(routeConfig) {
    const templateConfig = routeConfig?.templateConfig;
    if (!templateConfig) {
        return {};
    }
    return (0,utils/* generateGlobalVariables */.OZ)({
        headerAndFooter: templateConfig.headerAndFooter,
        theme: templateConfig.theme
    });
}

;// CONCATENATED MODULE: ./src/components/shared/form/formNew/hooks/index.ts














// EXTERNAL MODULE: ./src/components/shared/form/offersInForm/index.tsx
var offersInForm = __webpack_require__(22366);
// EXTERNAL MODULE: ./src/components/shared/form/progressBar/index.tsx
var progressBar = __webpack_require__(91354);
// EXTERNAL MODULE: ./src/components/shared/form/secondService/index.tsx
var secondService = __webpack_require__(70790);
;// CONCATENATED MODULE: ./src/components/shared/form/formNew.tsx
/* eslint-disable react-hooks/rules-of-hooks */ 












function Form(props) {
    const { form , domain , category , formTemplate , formOffer , visitDetails , exitModalOffer , locale , piiCompletionData , routeConfig , buyerPhoneNumber , defaultLocale , domainNameTranslation , loadOneToOneForm ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const { setSetPopupFormSubmittedFunction , skipToThankYou , setSecondServiceSubmitted , setGoToThankYouPage , formSubmitted: isMainFormSubmitted ,  } = (0,useFormContext/* useFormContext */.G)();
    const router = (0,next_router.useRouter)();
    const { 0: offersPopupActive , 1: setOffersPopupActive  } = (0,react.useState)(false);
    const { 0: popupOffers , 1: setPopupOffers  } = (0,react.useState)([]);
    const prevStepRef = (0,react.useRef)(null);
    const { 0: clicksOffers , 1: setClicksOffers  } = (0,react.useState)([]);
    const { 0: listRequestId , 1: setListRequestId  } = (0,react.useState)("");
    useFormInit({
        router,
        visitDetails,
        domain,
        goToThankYouPage: props.goToThankYouPage,
        setGoToThankYouPage
    });
    const compactOfferBlock = domain.defaultOffers?.find((offer)=>offer.category?.slug === category?.slug);
    const { form: formAsProp  } = props;
    const finalForm = formAsProp ?? form;
    if (finalForm) {
        const { classes , colors , showProgress , progressPosition , progressMode , progressTitle , progressIcon , backButton , sellingPoint , sellingPointsSteps , preventWindowClose , progressShift , stepsConfig , goToThankYouPage , dynamicThankYouFields , scrollToTop =true , modalSize , currentCategorySlug , popupStyle , hideOffers , customThankYouStep , isSecondServiceForm , isPiiCompletionForm , secondServiceColors , secondServiceClasses , updateSecondServices , tags , activeSecondServices , secondServiceLoading , showStepNumberOnly , formTemplateProp , resetLeadId =false , searchableMultiSelect , secondServiceSearchableMultiSelect , onModalClickClose , onInlineThankYouShown , ignoreCategoryInThankYouPagePath =false , isFormInsideOffersModal =false , goToListPage , initialFieldData , progressBesideBackButton , singleQuestion , singleQuestionMaxOptions , urlToRedirectFromSingleQuestion , mergeInputWithSubmitOnFirstStep , enableApiCall , apiCallField , disableExitModal , disableAutoFocus , isGeneralModalForm , customOfferExitModal , customOfferExitModalImage , customOfferExitModalContent ,  } = props;
        const isFormSubmitted = (0,react.useRef)(false);
        // Synchronously keep the ref in sync during render so the beforeunload
        // guard sees it before window.location.href fires (effects are too late).
        if (isMainFormSubmitted && !isFormInsideOffersModal) {
            isFormSubmitted.current = true;
        }
        const { handleFieldBlur , handleFieldChange , handleSubmit , handlePrevStep , formId , formError , jornayaIdElement , steps , currentStep , isLoading , fieldsData , successMessage , handleOutsideFormSubmit , formSubmitted , otp , checkIfStepHasOneField , visitedSteps , formErrors , formErrorsResolved , showExitModal , stepStatus , showRegulations , setLoading , setHasRegulations , showCustomListingModal , setShowCustomListingModal , showPiiCompletionOtherFields , setShowPiiCompletionOtherFields , showFormModal , toggleFormModal , listingSlug , toggleShowFormInExitModal , showFromInExitModal , handleCloseFormInsideExitModal , dispatch , startSecondRoundBidding , operation , globalLoading , apiCallLoading , reloadFormData , isLastStep ,  } = useForm(finalForm, isSecondServiceForm, isPiiCompletionForm, goToListPage, resetLeadId, scrollToTop, !!props.showInModal, isFormInsideOffersModal, isFormSubmitted, initialFieldData, singleQuestion, urlToRedirectFromSingleQuestion, isGeneralModalForm);
        useFormPersistence({
            fieldsData,
            dynamicThankYouFields,
            isSecondServiceForm,
            isPiiCompletionForm,
            piiCompletionData,
            successMessage,
            formId: finalForm.id,
            isFormInsideOffersModal,
            reloadFormData: reloadFormData
        });
        useBlockOtherSections({
            routeConfig,
            domain,
            category,
            currentStep,
            prevStepRef
        });
        const { isSecondServiceSelected  } = useSecondServiceState({
            isSecondServiceForm,
            formSubmitted,
            setSecondServiceSubmitted,
            tags
        });
        const scrollToTopHandler = useScrollToTop({
            enabled: scrollToTop
        });
        useFormSideFetches({
            domain,
            category,
            fieldsData,
            showRegulations,
            showCustomListingModal,
            listingSlug,
            setLoading,
            setOffersPopupActive,
            setClicksOffers,
            setListRequestId,
            setPopupOffers
        });
        const { handleOffersPopupVisibility , modalOffersContent , modalOfferClicksContent , modalWidth ,  } = useExitOffersModal({
            exitModalOffer,
            category,
            currentCategorySlug: props.currentCategorySlug,
            buyerPhoneNumber,
            routeConfig,
            showFormModal,
            isFormInsideOffersModal,
            singleQuestion,
            showFromInExitModal,
            showExitModal,
            showRegulations,
            clicksOffers,
            listRequestId,
            visitDetails,
            popupOffers,
            popupStyle,
            offersPopupActive,
            setOffersPopupActive,
            setPopupOffers,
            toggleShowFormInExitModal,
            disableExitModal,
            customOfferExitModal,
            customOfferExitModalImage,
            customOfferExitModalContent
        });
        usePreventPageClose({
            isFormSubmitted,
            preventWindowClose,
            router,
            visitDetails,
            isLastStep,
            setSetPopupFormSubmittedFunction,
            handleOutsideFormSubmit,
            handleOffersPopupVisibility,
            currentCategorySlug,
            exitModalOffer,
            buyerPhoneNumber
        });
        useThankYouRedirect({
            formSubmitted,
            goToThankYouPage,
            skipToThankYou,
            otp,
            category,
            isSecondServiceForm,
            dynamicThankYouFields,
            fieldsData,
            loadOneToOneForm,
            operation,
            router,
            isFormSubmitted,
            domain,
            locale,
            defaultLocale: defaultLocale ?? undefined,
            form: finalForm,
            ignoreCategoryInThankYouPagePath,
            onInlineThankYouShown
        });
        const slideFormValue = useSlideFormValue({
            isLastStep,
            formErrors,
            formErrorsResolved,
            operation,
            formSubmitted,
            goToThankYouPage,
            goToListPage,
            otp,
            currentStep
        });
        const { finalAnswerSummaryConfigs , shouldShowProgressBar , shouldShowBackButton , progressTotal , shouldShowPreFirstStepTitle , shouldShowOffersInFormTop , shouldShowOffersInFormBottom , shouldShowFieldWrapperProgress , shouldShowFieldWrapperBackButton , shouldShowSellingPoint , sellingPointLabel , shouldShowFloatingTcpa , handleBackClick , shouldShowFormInOffersExitModal , showOtp , showTCPAMessage , shouldShowSkipThankYouShortcut , shouldRenderSecondServiceForm , submitButtonText ,  } = useFormRenderConditions({
            showProgress,
            globalLoading,
            otp,
            formErrors,
            showFormModal,
            operation,
            stepsConfig,
            currentStep,
            formSubmitted,
            steps,
            domain,
            preFirstStepTitle: props.preFirstStepTitle,
            formTemplate,
            formTemplateProp,
            sellingPointsSteps,
            sellingPoint,
            isLastStep,
            visitDetails,
            locale,
            backButton,
            handlePrevStep,
            isFormInsideOffersModal,
            goToListPage,
            category,
            formOffer,
            form,
            isMainFormSubmitted,
            isPiiCompletionForm,
            isSecondServiceForm,
            skipToThankYou,
            goToThankYouPage
        });
        const tcpa = useFormTcpa({
            isSecondServiceForm,
            isSecondServiceSelected,
            showTCPAMessage,
            formErrors,
            operation,
            domain,
            finalForm,
            steps,
            currentStep,
            classes,
            submitButtonText,
            dispatch,
            isFormInsideOffersModal
        });
        const invalidFields = useInvalidFields({
            steps,
            singleQuestion,
            singleQuestionMaxOptions,
            formErrors,
            fieldsData
        });
        const modalVariables = useModalVariables(routeConfig);
        const isExpandable = expandableFields_isExpandable;
        const getExpandableFields = (field)=>expandableFields_getExpandableFields(field, fieldsData);
        if (shouldShowSkipThankYouShortcut) {
            scrollToTopHandler();
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineThankYouShortcut, {
                formClassName: classes?.formClassName,
                compactOfferBlock: compactOfferBlock,
                hideOffers: hideOffers,
                customThankYouStep: customThankYouStep,
                innerThankYouClassName: classes?.innerThankYouClassName
            });
        }
        if (shouldRenderSecondServiceForm) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(secondService/* default */.Z, {
                classes: secondServiceClasses,
                colors: {
                    ...colors,
                    ...secondServiceColors
                },
                goToThankYou: goToThankYouPage ? true : false,
                secondServiceSearchableMultiSelect: secondServiceSearchableMultiSelect
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                finalForm.testConfig?.config?.css && /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                    dangerouslySetInnerHTML: {
                        __html: finalForm.testConfig?.config?.css
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    "data-tf-element-role": "offer",
                    onSubmit: (e)=>{
                        handleSubmit(e, {
                            isSecondForm: isSecondServiceForm ? true : false,
                            enableApiCall,
                            apiCallField: apiCallField
                        });
                    },
                    className: `${classes?.formClassName ?? ""} ${(styles_module_default()).form}`,
                    style: {
                        color: colors.textColor,
                        ...showFormModal ? {
                            backgroundColor: "transparent",
                            boxShadow: "none"
                        } : {}
                    },
                    noValidate: true,
                    id: `form_${formId}`,
                    method: "post",
                    children: [
                        shouldShowPreFirstStepTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreFirstStepTitle, {
                            title: props.preFirstStepTitle,
                            region: visitDetails.region,
                            city: visitDetails?.city
                        }),
                        shouldShowOffersInFormTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(offersInForm/* default */.Z, {
                            classes: classes?.freeConsultationOfferClassName,
                            offer: formOffer?.length ? formOffer[0] : undefined,
                            shape: formTemplate ?? formTemplateProp ?? undefined
                        }),
                        shouldShowProgressBar && progressPosition === "top" && /*#__PURE__*/ (0,jsx_runtime.jsx)(progressBar/* default */.Z, {
                            color: colors?.progressBar,
                            current: currentStep,
                            className: `${(styles_module_default())["top-progress-bar"]} ${classes?.formTopProgressbarClassName ?? ""}`,
                            total: progressTotal,
                            shift: progressShift,
                            mode: progressMode,
                            titleIcon: progressIcon,
                            title: progressTitle,
                            activeSegmentClassName: classes?.activeSegmentClassName ?? ""
                        }),
                        globalLoading && initialFieldData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(consentOnlyForm_FormSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldWrapper/* default */.Z, {
                            type: showFormModal ? "modal" : "div",
                            classes: classes,
                            current: currentStep,
                            total: progressTotal,
                            colors: colors,
                            shift: progressShift,
                            showProgress: shouldShowFieldWrapperProgress,
                            showStepNumberOnly: showStepNumberOnly,
                            showBackButton: shouldShowFieldWrapperBackButton,
                            handlePrevStep: handlePrevStep,
                            backButton: backButton,
                            onModalCloseClick: ()=>{
                                toggleFormModal(false);
                                onModalClickClose?.();
                            },
                            tcpa: tcpa,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormStepsWrapper, {
                                slideFormValue: slideFormValue,
                                steps: steps,
                                stepsConfig: stepsConfig,
                                formProps: props,
                                isSecondServiceForm: isSecondServiceForm,
                                operation: operation,
                                classes: classes,
                                isFormInsideOffersModal: isFormInsideOffersModal,
                                formErrors: formErrors,
                                handleFieldBlur: handleFieldBlur,
                                handleFieldChange: handleFieldChange,
                                currentStep: currentStep,
                                isLoading: isLoading,
                                globalLoading: globalLoading,
                                formError: formError,
                                fieldsData: fieldsData,
                                visitedSteps: visitedSteps,
                                checkIfStepHasOneField: checkIfStepHasOneField,
                                formSubmitted: formSubmitted,
                                formId: formId,
                                finalForm: finalForm,
                                stepStatus: stepStatus,
                                form: form,
                                updateSecondServices: updateSecondServices,
                                tags: tags,
                                activeSecondServices: activeSecondServices,
                                secondServiceLoading: secondServiceLoading,
                                showPiiCompletionOtherFields: showPiiCompletionOtherFields,
                                setShowPiiCompletionOtherFields: setShowPiiCompletionOtherFields,
                                searchableMultiSelect: searchableMultiSelect,
                                finalAnswerSummaryConfigs: finalAnswerSummaryConfigs,
                                tcpa: tcpa,
                                singleQuestion: singleQuestion,
                                mergeInputWithSubmitOnFirstStep: mergeInputWithSubmitOnFirstStep,
                                apiCallLoading: apiCallLoading,
                                formErrorsResolved: formErrorsResolved,
                                invalidFields: invalidFields,
                                isExpandable: isExpandable,
                                getExpandableFields: getExpandableFields,
                                domain: domain,
                                domainNameTranslation: domainNameTranslation,
                                isLastStep: isLastStep,
                                showOtp: showOtp,
                                otp: otp,
                                dispatch: dispatch,
                                submitButtonText: submitButtonText,
                                startSecondRoundBidding: startSecondRoundBidding,
                                goToThankYouPage: goToThankYouPage,
                                goToListPage: goToListPage,
                                compactOfferBlock: compactOfferBlock,
                                hideOffers: hideOffers,
                                customThankYouStep: customThankYouStep,
                                colors: colors,
                                isLoading2: isLoading,
                                disableAutoFocus: disableAutoFocus
                            })
                        }),
                        jornayaIdElement,
                        shouldShowSellingPoint && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: `${(styles_module_default()).sellingPoint} ${classes?.sellingPointClassName ?? ""}`,
                            children: sellingPointLabel
                        }),
                        progressBesideBackButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).progressBesideBackButton,
                            children: [
                                shouldShowBackButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    className: `${(styles_module_default())["back-button-beside"]} ${backButton?.class ?? ""}`,
                                    onClick: handleBackClick,
                                    children: [
                                        backButton?.label ?? "Previous",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: (styles_module_default())["arrow-back"]
                                        })
                                    ]
                                }),
                                shouldShowProgressBar && progressPosition !== "top" && /*#__PURE__*/ (0,jsx_runtime.jsx)(progressBar/* default */.Z, {
                                    className: `${(styles_module_default())["progress-bar"]} ${classes?.formProgressbarClassName ?? ""}`,
                                    current: currentStep,
                                    total: progressTotal,
                                    color: colors?.progressBar,
                                    shift: progressShift,
                                    showStepNumberOnly: showStepNumberOnly,
                                    style: progressMode
                                })
                            ]
                        }),
                        shouldShowProgressBar && progressPosition !== "top" && !progressBesideBackButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(progressBar/* default */.Z, {
                            className: `${(styles_module_default())["progress-bar"]} ${classes?.formProgressbarClassName ?? ""}`,
                            current: currentStep,
                            total: progressTotal,
                            color: colors?.progressBar,
                            shift: progressShift,
                            showStepNumberOnly: showStepNumberOnly,
                            style: progressMode
                        }),
                        shouldShowOffersInFormBottom && /*#__PURE__*/ (0,jsx_runtime.jsx)(offersInForm/* default */.Z, {
                            classes: classes?.freeConsultationOfferClassName,
                            offer: formOffer?.length ? formOffer[0] : undefined,
                            shape: formTemplate || formTemplateProp || undefined
                        }),
                        shouldShowFloatingTcpa && tcpa,
                        shouldShowBackButton && !progressBesideBackButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: `ltrStyle ${(styles_module_default())["back-button"]} ${backButton?.class ?? ""}`,
                            onClick: handleBackClick,
                            children: [
                                backButton?.label ?? "Previous",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: (styles_module_default())["arrow-back"]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitOffersModal, {
                            offersPopupActive: offersPopupActive,
                            buyerPhoneNumber: buyerPhoneNumber,
                            hidePageOffers: routeConfig?.config?.settings?.hidePageOffers,
                            onClose: ()=>{
                                setOffersPopupActive(false);
                                if (showRegulations) {
                                    setClicksOffers([]);
                                    setHasRegulations(false);
                                }
                                if (showCustomListingModal) {
                                    setPopupOffers([]);
                                    setShowCustomListingModal(false);
                                }
                            },
                            showRegulations: showRegulations,
                            setClicksOffers: setClicksOffers,
                            setHasRegulations: setHasRegulations,
                            showCustomListingModal: showCustomListingModal,
                            setPopupOffers: setPopupOffers,
                            setShowCustomListingModal: setShowCustomListingModal,
                            modalSize: modalSize,
                            modalWidth: modalWidth,
                            modalVariables: modalVariables,
                            modalOffersContent: modalOffersContent,
                            modalOfferClicksContent: modalOfferClicksContent,
                            setOffersPopupActive: setOffersPopupActive
                        }),
                        shouldShowFormInOffersExitModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInOfferModal, {
                            showFromInExitModal: showFromInExitModal,
                            handleCloseFormInsideExitModal: handleCloseFormInsideExitModal,
                            modalVariables: modalVariables,
                            formProps: props
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}


/***/ }),

/***/ 18981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useBodyScrollLock; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useBodyScrollLock(isLocked) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isLocked) {
            document.body.style.overflow = "hidden";
            document.body.style.position = "fixed";
            document.body.style.width = "100%";
        } else {
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.width = "";
        }
        return ()=>{
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.width = "";
        };
    }, [
        isLocked
    ]);
}


/***/ }),

/***/ 77720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ useContactUsForm; }
});

// UNUSED EXPORTS: formReducer

// EXTERNAL MODULE: ./src/lib/shared/contactUsForm.ts
var contactUsForm = __webpack_require__(37695);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/index.ts + 19 modules
var api = __webpack_require__(21513);
// EXTERNAL MODULE: ./src/lib/shared/form.ts + 1 modules
var shared_form = __webpack_require__(198);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
;// CONCATENATED MODULE: ./src/lib/contactUsUtils.ts
const getFinalContactUsFields = ({ severalBrandsRecaptcha , defaultFormFields , extraFields , token , doNotSellForm , visitId , domainId  })=>{
    if (doNotSellForm) {
        return {
            ...defaultFormFields,
            name: undefined,
            domainId,
            visitId,
            deleteMyInfo: !!defaultFormFields.deleteMyInfo,
            doNotSell: !!defaultFormFields.doNotSell
        };
    }
    return severalBrandsRecaptcha ? {
        ...defaultFormFields,
        name: undefined,
        customFields: extraFields,
        googleReCaptcha: token
    } : {
        ...defaultFormFields,
        customFields: extraFields
    };
};

// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/hooks/useContactUsForm.tsx







var ActionTypes;
(function(ActionTypes) {
    ActionTypes["SET_FIELDS_STATE"] = "SET_FIELDS_STATE";
    ActionTypes["SET_LOADING_FORM"] = "SET_LOADING_FORM";
    ActionTypes["SET_FORM_SUBMITTED"] = "SET_FORM_SUBMITTED";
    ActionTypes["SET_FORM_ERROR"] = "SET_FORM_ERROR";
})(ActionTypes || (ActionTypes = {}));
const initState = {
    submitted: false,
    loadingForm: false,
    fieldsState: null,
    formError: null
};
const formReducer = (state, action)=>{
    switch(action.type){
        case ActionTypes.SET_FIELDS_STATE:
            return {
                ...state,
                fieldsState: {
                    ...state.fieldsState,
                    ...action.payload
                }
            };
        case ActionTypes.SET_LOADING_FORM:
            return {
                ...state,
                loadingForm: action.payload
            };
        case ActionTypes.SET_FORM_SUBMITTED:
            return {
                ...state,
                submitted: true
            };
        case ActionTypes.SET_FORM_ERROR:
            return {
                ...state,
                formError: action.payload
            };
        default:
            return state;
    }
};
const useContactUsForm = (formFields, severalBrandsRecaptcha, setSubmittedForm, doNotSellForm, type, category, isConnectPageForm)=>{
    const { executeRecaptcha  } = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)();
    const { visitDetails , domain , locale  } = (0,useDomainContext/* useDomainContext */.w)();
    const { fields  } = useFields(formFields);
    const { 0: state , 1: dispatch  } = (0,react.useReducer)(formReducer, {
        ...initState,
        fieldsState: fields
    });
    const { submitted , loadingForm , fieldsState , formError  } = state;
    const handleFieldValidation = async (field, dispatchState)=>{
        const { valid , message  } = await (0,contactUsForm/* fieldValidation */.w)(field, fieldsState[field.name].value, domain, locale);
        const newObj = {};
        newObj[field.name] = {
            ...fieldsState[field.name],
            valid,
            errorMessage: message
        };
        if (dispatchState) {
            dispatch({
                type: ActionTypes.SET_FIELDS_STATE,
                payload: {
                    ...newObj
                }
            });
        }
        return {
            name: field.name,
            valid: valid,
            errorMessage: message,
            value: fieldsState[field.name].value
        };
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (loadingForm || submitted) return;
        dispatch({
            type: ActionTypes.SET_LOADING_FORM,
            payload: true
        });
        const formFieldValidation = [];
        for (const promise of formFields){
            const result = await handleFieldValidation(promise, false);
            formFieldValidation.push(result);
        }
        const finalObj = formFieldValidation.reduce((obj, currentValue)=>{
            obj[currentValue.name] = {
                valid: currentValue.valid,
                errorMessage: currentValue.errorMessage,
                value: currentValue.value
            };
            return obj;
        }, {});
        dispatch({
            type: ActionTypes.SET_FIELDS_STATE,
            payload: {
                ...finalObj
            }
        });
        const formValid = !formFieldValidation.map((filed)=>filed.valid).includes(false);
        if (formValid) {
            const defaultFormFields = {};
            const extraFields = [];
            if (category) {
                extraFields.push({
                    key: "category",
                    value: category
                });
            }
            if (isConnectPageForm) {
                extraFields.push({
                    key: "source",
                    value: "connect"
                });
            }
            const trustedFormCertificateUrl = document.getElementById("TrustedFormCertUrl_0")?.value || "";
            if (trustedFormCertificateUrl) {
                extraFields.push({
                    key: "trustedFormCertificateUrl",
                    value: trustedFormCertificateUrl
                });
            }
            formFields.forEach((field)=>{
                if (field.isExtraField) {
                    extraFields.push({
                        key: field.name,
                        value: fieldsState[field.name].value
                    });
                } else {
                    if (field.name === "name") {
                        const name = fieldsState[field.name].value.split(" ");
                        defaultFormFields["firstName"] = name[0];
                        defaultFormFields["lastName"] = name[1] ?? "---";
                    }
                    defaultFormFields[field.name] = fieldsState[field.name].value;
                }
            });
            dispatch({
                type: ActionTypes.SET_FORM_ERROR,
                payload: null
            });
            const token = executeRecaptcha && severalBrandsRecaptcha ? await executeRecaptcha("contact_us_form") : null;
            const finalData = getFinalContactUsFields({
                severalBrandsRecaptcha,
                defaultFormFields,
                extraFields,
                token,
                doNotSellForm,
                visitId: visitDetails?.visitId,
                domainId: domain?.id
            });
            let resData = null;
            let resError = null;
            if (doNotSellForm) {
                const { data , error  } = await (0,api/* submitDoNotSellForm */.TF)({
                    //@ts-ignore
                    fields: {
                        ...finalData
                    }
                });
                resData = data;
                resError = error;
            } else {
                const { data: data1 , error: error1  } = await (0,api/* submitContactUsForm */.F2)({
                    //@ts-ignore
                    fields: {
                        ...finalData
                    },
                    type
                });
                resData = data1;
                resError = error1;
            }
            dispatch({
                type: ActionTypes.SET_LOADING_FORM,
                payload: false
            });
            if (resError) {
                if (resData && resData?.code === "INVALID_PHONE_NUMBER_FORMAT") {
                    dispatch({
                        type: ActionTypes.SET_FORM_ERROR,
                        payload: "Invalid phone number"
                    });
                } else {
                    dispatch({
                        type: ActionTypes.SET_FORM_ERROR,
                        payload: "An error has occurred, please try again later"
                    });
                }
            } else {
                if (setSubmittedForm) {
                    setSubmittedForm(true);
                }
                dispatch({
                    type: ActionTypes.SET_FORM_SUBMITTED,
                    payload: undefined
                });
            }
        } else {
            dispatch({
                type: ActionTypes.SET_LOADING_FORM,
                payload: false
            });
        }
    };
    const handleFieldBlur = async (field)=>{
        await handleFieldValidation(field, true);
    };
    const handleFieldChange = (field, val)=>{
        const newVal = field.validation.rules?.type === "isPhone" && val ? (0,shared_form/* handleFieldMasking */.yr)("us-phone", val) : val;
        const newObj = {};
        newObj[field.name] = {
            valid: true,
            errorMessage: "",
            value: newVal
        };
        dispatch({
            type: ActionTypes.SET_FIELDS_STATE,
            payload: {
                ...newObj
            }
        });
    };
    return {
        handleSubmit,
        handleFieldBlur,
        handleFieldChange,
        submitted,
        loadingForm,
        formError,
        fieldsState
    };
};
const useFields = (fields)=>{
    const temp = {};
    fields.forEach((field)=>{
        temp[field.name] = {
            value: field.defaultValue ?? "",
            valid: true,
            errorMessage: ""
        };
    });
    return {
        fields: temp
    };
};


/***/ }),

/***/ 37695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ mainContactUsForm; },
/* harmony export */   "w": function() { return /* binding */ fieldValidation; }
/* harmony export */ });
/* harmony import */ var src_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21513);
/* harmony import */ var _lib_shared_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(198);
/* harmony import */ var _lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8712);



const mainContactUsForm = {
    firstName: {
        name: "firstName",
        label: "First Name",
        placeholder: "First Name",
        inputType: "text",
        type: "text",
        validation: {
            required: true,
            rules: {
                type: "isEmpty"
            }
        },
        autocomplete: "given-name",
        serverSideValidation: true
    },
    lastName: {
        name: "lastName",
        label: "Last Name",
        placeholder: "Last Name",
        inputType: "text",
        type: "text",
        validation: {
            required: true,
            rules: {
                type: "isEmpty"
            }
        },
        autocomplete: "family-name",
        serverSideValidation: true
    },
    email: {
        name: "email",
        label: "Email",
        placeholder: "Email",
        inputType: "text",
        type: "email",
        validation: {
            required: true,
            rules: {
                type: "isEmail"
            }
        },
        autocomplete: "email",
        serverSideValidation: true
    },
    phoneNumber: {
        name: "phone",
        label: "Phone Number",
        placeholder: "Phone Number",
        inputType: "text",
        type: "tel",
        validation: {
            required: true,
            rules: {
                type: "isPhone"
            }
        },
        autocomplete: "tel"
    },
    subject: {
        name: "subject",
        label: "Subject",
        placeholder: "Subject",
        inputType: "text",
        type: "text",
        validation: {
            required: true,
            rules: {
                type: "isEmpty",
                characterCount: {
                    min: 3,
                    max: 255
                }
            }
        }
    },
    description: {
        name: "body",
        label: "Description",
        placeholder: "Please enter the details of your request. A member of our support staff will get back to you within 24 hours",
        inputType: "textarea",
        type: null,
        rows: 5,
        validation: {
            required: true,
            rules: {
                type: "isEmpty",
                characterCount: {
                    min: 5,
                    max: 255
                }
            }
        }
    },
    recaptcha: {
        name: "googleReCaptcha",
        label: "",
        placeholder: "",
        inputType: "recaptcha",
        type: null,
        validation: {
            required: true
        }
    }
};
const getErrorMessage = (fieldName, errorCode, locale, options = {})=>{
    switch(errorCode){
        case "REQUIRED":
            switch(locale){
                case "ar":
                    return `${fieldName} مطلوب`;
                case "es":
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`${fieldName} es requerido`);
                case "en":
                default:
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`${fieldName} is required`);
            }
        case "INVALID_EMAIL":
            switch(locale){
                case "ar":
                    return `يرجى إدخال ${fieldName} صالح`;
                case "es":
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Por favor, introduzca un ${fieldName} válido`);
                case "en":
                default:
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Please enter a valid ${fieldName}`);
            }
        case "INVALID_PHONE":
            switch(locale){
                case "ar":
                    return `يرجى إدخال ${fieldName} صالح`;
                case "es":
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Por favor, introduzca un ${fieldName} válido`);
                case "en":
                default:
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Please enter a valid ${fieldName}`);
            }
        case "INVALID_STREET_ADDRESS":
            switch(locale){
                case "ar":
                    return `يرجى إدخال ${fieldName} صالح`;
                case "es":
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Por favor, introduzca un ${fieldName} válido`);
                case "en":
                default:
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Please enter a valid ${fieldName}`);
            }
        case "MAX_LENGTH_EXCEEDED":
            switch(locale){
                case "ar":
                    return `${fieldName} لا يمكن أن يكون أكثر من ${options?.maxCount?.toString()} أحرف`;
                case "es":
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`${fieldName} no puede tener más de ${options?.maxCount?.toString()} caracteres`);
                case "en":
                default:
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`${fieldName} cannot be more than ${options?.maxCount?.toString()} characters`);
            }
        case "MIN_LENGTH_NOT_MET":
            switch(locale){
                case "ar":
                    return `يرجى إدخال ما لا يقل عن ${options?.minCount?.toString()} أحرف`;
                case "es":
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Por favor, introduzca por lo menos ${options?.minCount?.toString()} caracteres`);
                case "en":
                default:
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Please enter at least ${options?.minCount?.toString()} characters`);
            }
        default:
            return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Invalid ${fieldName}`);
    }
};
const fieldValidation = async (field, value, domain, locale)=>{
    const conditions = [];
    const fieldName = field.errorMessageLabel || field.label || field.name;
    if (!value) {
        if (field.validation.required) {
            const fieldLabel = {
                en: "This field",
                es: "Este campo",
                // cspell:disable-next-line
                ar: "هذا الحقل"
            };
            conditions.push({
                valid: false,
                message: getErrorMessage(fieldLabel[locale] || fieldLabel["en"], "REQUIRED", locale)
            });
        }
    } else {
        if (field.validation.rules?.type === "isEmail") {
            const reg = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            const isValid = reg.test(String(value).toLowerCase());
            !isValid && conditions.push({
                valid: false,
                message: getErrorMessage(fieldName, "INVALID_EMAIL", locale)
            });
        }
        if (field.validation.rules?.type === "isPhone") {
            const reg1 = new RegExp(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/);
            const isValid1 = reg1.test(String(value).toLowerCase());
            !isValid1 && conditions.push({
                valid: false,
                message: getErrorMessage(fieldName, "INVALID_PHONE", locale)
            });
        }
        if (field.validation.rules?.type === "isStreetAddress") {
            // must start with a number and contain at least one letter
            const reg2 = new RegExp(/^\s*\d+\s+([a-zA-Z0-9\s\.,#\-]+)\s*$/);
            const isValid2 = reg2.test(String(value).toLowerCase());
            !isValid2 && conditions.push({
                valid: false,
                message: getErrorMessage(fieldName, "INVALID_STREET_ADDRESS", locale)
            });
        }
        if (field.validation.rules?.characterCount?.max) {
            const isValid3 = value.trim().length <= field.validation.rules?.characterCount?.max;
            !isValid3 && conditions.push({
                valid: false,
                message: getErrorMessage(fieldName, "MAX_LENGTH_EXCEEDED", locale, {
                    maxCount: field.validation.rules?.characterCount?.max
                })
            });
        }
        if (field.validation.rules?.characterCount?.min) {
            const isValid4 = value.trim().length >= field.validation.rules?.characterCount?.min;
            !isValid4 && conditions.push({
                valid: false,
                message: getErrorMessage(fieldName, "MIN_LENGTH_NOT_MET", locale, {
                    minCount: field.validation.rules?.characterCount?.min
                })
            });
        }
    }
    if (conditions.length >= 1) {
        return {
            valid: false,
            message: conditions[0].message
        };
    }
    if (field.serverSideValidation) {
        const { error  } = await (0,src_api__WEBPACK_IMPORTED_MODULE_0__/* .validateField */ .OP)({
            ruleName: field.name,
            value
        });
        if (error) {
            return {
                valid: false,
                message: (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)((0,_lib_shared_form__WEBPACK_IMPORTED_MODULE_1__/* .getServerSideValidationErrorMessage */ .V2)(error, fieldName, domain, locale))
            };
        }
    }
    const valid = true;
    const message = "";
    return {
        valid,
        message
    };
};


/***/ }),

/***/ 80121:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__11QkF","option":"styles_option__jNZft","box":"styles_box__jXVtM","checkbox-field":"styles_checkbox-field__gkLWO","select-all-checkbox-field":"styles_select-all-checkbox-field__XkuGW","checkbox-icon":"styles_checkbox-icon___rjXd","title":"styles_title__IQTZ0","description":"styles_description__xT9Pb"};

/***/ })

}]);